var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:05:21 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2013, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-Black",
    horizAdvX: 609
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway Black",
    fontWeight: 900,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 10 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 526,
    capHeight: 710,
    bbox: "-189 -234 1306 932",
    underlineThickness: 50,
    underlinePosition: -150,
    unicodeRange: "U+000D-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 691,
    d: "M611 580q-47 0 -47 -51v-64h115v-143h-115v-322h-190v322h-99v-322h-190v322h-65v143h65v23q0 49 13.5 89.5t39 69t62 44t81.5 15.5q62 0 142 -30q26 30 62.5 47t84.5 17q63 0 143 -30l-32 -144q-17 6 -36.5 10t-33.5 4zM374 537q-14 4 -28 6.5t-25 2.5q-46 0 -46 -51 v-30h99v72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 621,
    d: "M85 322h-65v143h65v57q0 49 17.5 89.5t49.5 69t75.5 44t96.5 15.5q58 0 112.5 -19.5t117.5 -60.5l-72 -144q-35 30 -72.5 47t-72.5 17q-29 0 -45.5 -12.5t-16.5 -38.5v-64h299v-465h-190v322h-109v-322h-190v322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 718,
    d: "M720 24q-1 -1 -15 -6.5t-35.5 -11.5t-48.5 -10.5t-54 -4.5q-38 0 -67.5 10t-50 27.5t-31.5 40t-11 48.5v356q0 54 -11 80.5t-51 26.5q-41 0 -55.5 -24t-14.5 -62v-29h69v-143h-69v-322h-190v322h-65v143h65v75q0 52 18.5 90t51.5 62.5t79.5 36t102.5 11.5q68 0 117 -16.5 t81 -46.5t47 -72.5t15 -94.5v-293q0 -19 9.5 -38t33.5 -19q8 0 18 2.5t18 5.5t14 5.5t7 2.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 911,
    d: "M85 322h-65v143h65v23q0 49 13.5 89.5t39 69t62 44t81.5 15.5q62 0 142 -30q32 30 79.5 47t107.5 17q51 0 108.5 -19t124.5 -61l-72 -144q-32 29 -71 46.5t-69 17.5q-67 0 -67 -51v-64h300v-465h-191v322h-109v-322h-190v322h-99v-322h-190v322zM374 465v72 q-14 4 -28 6.5t-25 2.5q-46 0 -46 -51v-30h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 1006,
    d: "M855 -9q-38 0 -67.5 10t-50 27.5t-31.5 40t-11 48.5v366q0 22 -2 39.5t-9.5 30.5t-21 20t-35.5 7q-36 0 -50 -25.5t-14 -60.5v-29h69v-143h-69v-322h-190v322h-98v-322h-190v322h-65v143h65v23q0 49 14 89.5t39 69t60.5 44t79.5 15.5q66 0 146 -30q33 33 84.5 48.5 t116.5 15.5q68 0 117 -16.5t81 -46.5t47 -72.5t15 -94.5v-293q0 -19 9.5 -38t33.5 -19q8 0 18 2.5t18 5.5t14 5.5t7 2.5l23 -152q-1 -1 -15 -6.5t-35.5 -11.5t-48.5 -10.5t-54 -4.5zM373 465v73q-29 8 -52 8q-46 0 -46 -51v-30h98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 225
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 362,
    d: "M86 300v417h190v-417h-190zM86 0v184h190v-184h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 476,
    d: "M53 496v234h160v-234h-160zM263 496v234h160v-234h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 757,
    d: "M721 397h-159l-20 -87h128v-140h-162l-41 -170h-151l42 170h-60l-41 -170h-151l42 170h-112v140h146l20 87h-115v130h147l45 183h151l-46 -183h60l45 183h151l-46 -183h127v-130zM392 310l20 87h-60l-20 -87h60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 649,
    d: "M510 478q-22 14 -48 26q-22 11 -49.5 20.5t-55.5 14.5v-90q9 -2 19 -5.5t21 -6.5q49 -15 88.5 -33t67.5 -42.5t43 -59.5t15 -85q0 -59 -20.5 -100.5t-54 -68t-76.5 -40t-89 -16.5v-121h-80v123q-69 6 -137 27t-122 53l84 171q27 -17 58 -32q26 -13 60.5 -25.5t70.5 -17.5 v88q-31 8 -62 19q-47 16 -81 34.5t-56 42t-32.5 53.5t-10.5 69q0 54 18 95.5t49 71.5t72.5 48t88.5 23v101h80v-102q33 -4 64 -12t59.5 -18.5t53.5 -22t46 -21.5zM401 198q0 14 -12 24.5t-32 18.5v-74q24 2 34 10t10 21zM265 508q0 -15 10 -24.5t30 -17.5v76q-40 -5 -40 -34 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 851,
    d: "M211 404q-38 0 -70.5 12.5t-56.5 33.5t-37.5 50t-13.5 62t13.5 62t37.5 50t56.5 33.5t70.5 12.5q37 0 69.5 -12.5t56.5 -33.5t38 -50t14 -62t-14 -62t-38 -50t-56.5 -33.5t-69.5 -12.5zM211 494q20 0 34 20t14 48t-14 48t-34 20t-34 -20t-14 -48t14 -48t34 -20zM640 -10 q-38 0 -70.5 12.5t-56.5 33.5t-37.5 50t-13.5 62t13.5 62t37.5 50t56.5 33.5t70.5 12.5q37 0 69.5 -12.5t56.5 -33.5t38 -50t14 -62t-14 -62t-38 -50t-56.5 -33.5t-69.5 -12.5zM640 80q20 0 34 20t14 48t-14 48t-34 20t-34 -20t-14 -48t14 -48t34 -20zM117 65l283 319 l251 337l83 -75l-271 -309l-263 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 749,
    d: "M506 0l-38 40q-43 -26 -89.5 -38t-93.5 -12q-62 0 -108.5 20t-78 52t-47.5 72.5t-16 81.5q0 61 29.5 105.5t70.5 77.5q-32 39 -45 69.5t-13 67.5q0 43 16 77.5t43.5 57.5t65.5 35.5t83 12.5q39 0 76.5 -9.5t67 -30t47.5 -53t18 -78.5q0 -54 -25 -97t-67 -79l82 -87 q11 28 17 60.5t6 70.5h153q-1 -77 -18 -138.5t-46 -110.5l159 -167h-249zM305 138q30 0 59 13l-113 121q-34 -28 -34 -56q0 -11 4.5 -24.5t15 -25.5t27.5 -20t41 -8zM249 544q0 -13 7.5 -22.5t25.5 -26.5q20 14 29 24.5t9 26.5q0 17 -9.5 26t-25.5 9q-17 0 -26.5 -10.5 t-9.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 266,
    d: "M53 496v234h160v-234h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 342,
    d: "M25 348q0 51 12 102.5t33 104t49.5 107t61.5 110.5l145 -58q-12 -19 -32.5 -58.5t-41 -90.5t-35.5 -108.5t-15 -111.5q0 -82 34.5 -166t84.5 -178l-138 -67q-31 46 -59.5 96.5t-50.5 103t-35 106.5t-13 108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 341,
    d: "M316 348q0 -54 -13 -108t-35 -106.5t-50.5 -103t-59.5 -96.5l-138 67q50 94 84.5 178t34.5 166q0 54 -15 111.5t-35.5 108.5t-41 90.5t-32.5 58.5l145 58q33 -56 61.5 -110.5t49.5 -107t33 -104t12 -102.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 364,
    d: "M65 499l49 78l-72 21l24 77l75 -36l-7 82h96l-7 -82l75 36l24 -77l-72 -21l49 -78l-69 -45l-48 83l-48 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 428,
    d: "M384 430v-150h-85v-95h-170v95h-85v150h85v95h170v-95h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 257,
    d: "M71 -157l36 157h-57v184h157v-184l-54 -157h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 413,
    d: "M50 191v170h313v-170h-313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 254,
    d: "M50 0v184h154v-184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 777,
    d: "M751 710l-516 -710h-209l515 710h210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 614,
    d: "M572 293q0 -66 -20 -121.5t-55.5 -96t-84 -63t-105.5 -22.5t-105.5 22.5t-84 63t-55.5 96t-20 121.5t20 121.5t55.5 96t84 63.5t105.5 23t105.5 -23t84 -63.5t55.5 -96t20 -121.5zM380 293q0 58 -20.5 94t-52.5 36q-34 0 -54.5 -36t-20.5 -94t20.5 -93.5t54.5 -35.5 q32 0 52.5 35.5t20.5 93.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 547,
    d: "M523 170v-170h-463v170h142v199q-9 -12 -28 -23.5t-42.5 -21.5t-47.5 -16t-43 -6v174q14 0 39 10.5t50 25t45.5 31t26.5 28.5h194v-401h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 599,
    d: "M31 0q0 50 8 88t26 68.5t46.5 54.5t70.5 47q54 29 85.5 46.5t47.5 28.5t20.5 18.5t4.5 16.5q0 25 -16 37t-44 12q-33 0 -62.5 -17t-61.5 -55l-120 141q19 21 49 38.5t66.5 30t77.5 19.5t84 7q115 0 174.5 -47.5t59.5 -132.5q0 -31 -8 -55t-21.5 -43.5t-32.5 -35.5 t-40 -30q-25 -17 -52.5 -32.5t-54.5 -34.5h220v-170h-527z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 581,
    d: "M408 237q31 -5 56.5 -21t44 -40t29 -54.5t10.5 -64.5q0 -47 -20 -85t-56.5 -64.5t-89.5 -40.5t-119 -14q-77 0 -136 19.5t-107 60.5l97 138q29 -23 61.5 -33.5t74.5 -10.5q51 0 74.5 15.5t23.5 49.5q0 38 -30 54.5t-98 16.5h-31v132h35q48 0 77 18.5t29 50.5 q0 24 -17 37.5t-48 13.5q-35 0 -65.5 -17.5t-53.5 -52.5l-120 141q18 20 45.5 36.5t62 28.5t73.5 18.5t80 6.5q55 0 101 -12.5t78 -35.5t50 -55.5t18 -72.5q0 -30 -10 -57t-27 -49t-40.5 -37t-51.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 586,
    d: "M272 -127v124h-257v170l317 404h130v-404h88v-170h-88v-124h-190zM202 167h92v120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 562,
    d: "M300 326q52 0 95 -17t74.5 -47.5t49 -73t17.5 -93.5q0 -54 -20 -99t-56.5 -77t-87 -50t-111.5 -18q-78 0 -140.5 29t-96.5 83l104 120q29 -31 64.5 -48.5t69.5 -17.5q37 0 58 20t21 54q0 33 -19 53t-50 20q-21 0 -38.5 -9.5t-26.5 -25.5h-163l84 442h356v-173h-219 l-11 -77q4 1 11 2q5 1 14 2t21 1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M572 240q0 -53 -20 -98.5t-56 -79t-84.5 -53t-105.5 -19.5q-128 0 -197.5 92t-69.5 258q0 88 19.5 157.5t56.5 118t90 74.5t120 26q130 0 226 -96l-105 -122q-54 54 -124 54q-49 0 -77.5 -29.5t-30.5 -83.5q38 34 108 34q54 0 99.5 -17.5t79 -49t52.5 -74t19 -92.5z M306 149q17 0 32.5 7.5t27 20t18.5 29t7 34.5q0 35 -25 59.5t-60 24.5t-60 -24.5t-25 -59.5q0 -18 7 -34.5t18.5 -29t27 -20t32.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 593,
    d: "M301 411h-271v173h570l-347 -710h-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 611,
    d: "M573 221q0 -52 -21 -94.5t-57.5 -73t-85.5 -47t-104 -16.5q-53 0 -101.5 16.5t-85.5 47.5t-59 75t-22 98q0 27 8 50t20.5 42t27.5 34t30 26q-29 17 -47.5 51t-18.5 69q0 51 23.5 90.5t59.5 66.5t80 40.5t85 13.5t85 -13.5t80.5 -39.5t60 -65.5t23.5 -90.5q0 -35 -19 -70 t-48 -52q15 -11 30.5 -26.5t27.5 -35.5t20 -44t8 -52zM380 232q0 33 -21.5 51t-53.5 18q-33 0 -54 -18.5t-21 -50.5q0 -29 21.5 -49t53.5 -20q33 0 54 20t21 49zM250 495q0 -27 17.5 -40t37.5 -13t38 13t18 40q0 20 -15.5 34t-40.5 14t-40 -14t-15 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 589,
    d: "M27 321q0 52 20 98t56 79.5t84.5 53t105.5 19.5q64 0 113.5 -23.5t83.5 -68.5t52 -110t18 -148q0 -88 -19.5 -157.5t-56.5 -118t-90 -74.5t-120 -26q-130 0 -226 96l105 122q54 -54 124 -54q49 0 77.5 29.5t30.5 83.5q-38 -34 -108 -34q-54 0 -99.5 17.5t-79 49t-52.5 74 t-19 92.5zM293 412q-17 0 -32.5 -7.5t-27 -20t-18.5 -29t-7 -34.5q0 -35 25 -59.5t60 -24.5t60 24.5t25 59.5q0 18 -7 34.5t-18.5 29t-27 20t-32.5 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 304,
    d: "M75 335v184h154v-184h-154zM75 0v184h154v-184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 305,
    d: "M76 335v184h154v-184h-154zM95 -157l36 157h-57v184h157v-184l-54 -157h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 521,
    d: "M31 298l424 258v-202l-148 -95l148 -87v-212l-424 250v88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 433,
    d: "M55 101v120h323v-120h-323zM55 331v120h323v-120h-323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 521,
    d: "M490 210l-424 -250v212l148 87l-148 95v202l424 -258v-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 495,
    d: "M95 259q0 21 2 41.5t10 39t24 35.5t43 31q11 6 31.5 16t41 24t35.5 31.5t15 38.5q0 23 -18 36.5t-42 13.5q-18 0 -31 -7t-22.5 -17t-16 -20.5t-12.5 -17.5l-121 86q26 61 82 95t128 34q38 0 77 -11t70.5 -35t51 -63t19.5 -95q0 -48 -17.5 -87.5t-62.5 -69.5 q-22 -15 -45 -26t-42.5 -22t-32 -23t-12.5 -28h-155zM98 0v164h155v-164h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 852,
    d: "M425 603q73 0 142 -22.5t122.5 -69t85.5 -118.5t32 -172q0 -14 -1.5 -37t-6.5 -49t-15.5 -53t-28.5 -49t-45 -35.5t-65 -13.5q-28 0 -47 7t-31 18t-18 24t-8 24q-34 -32 -78 -47.5t-91 -15.5q-77 0 -116 39t-39 105q0 43 16 72.5t42 47.5t59.5 26t68.5 8q38 0 63 -6.5 t39 -13.5q0 20 -5 37t-17 29t-32.5 18.5t-51.5 6.5q-42 0 -74.5 -11t-52.5 -30l-32 97q38 26 83 37.5t95 11.5q72 0 112 -21t59 -53t22.5 -69t3.5 -70v-67q0 -22 1 -44t6 -40t14.5 -29t27.5 -11q24 0 37.5 19t21 45.5t9.5 53.5t2 43q0 67 -22 123.5t-63 97.5t-99 64t-131 23 q-72 0 -129.5 -23t-97 -63.5t-60.5 -96t-21 -121.5q0 -63 19.5 -118.5t57 -97t91.5 -65.5t124 -24q26 0 47 3.5t39.5 8.5t35.5 12t36 14l20 -68q-43 -20 -89.5 -30t-91.5 -10q-75 0 -141 26.5t-115.5 75.5t-78 118.5t-28.5 156.5q0 92 32 161.5t85.5 116.5t123.5 70.5 t147 23.5zM465 100q13 7 26 19t13 29v41q-15 6 -42.5 12.5t-56.5 6.5q-42 0 -60.5 -17t-18.5 -52q0 -56 59 -56q14 0 37 3t43 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 690,
    d: "M665 182q0 -48 -20 -82.5t-55 -56.5t-81.5 -32.5t-98.5 -10.5h-349v710h412q37 0 67 -16t51 -41.5t32.5 -58t11.5 -66.5q0 -50 -25.5 -95.5t-76.5 -68.5q61 -18 96.5 -62.5t35.5 -119.5zM467 222q0 26 -14 43.5t-36 17.5h-161v-119h154q24 0 40.5 15t16.5 43zM256 544 v-109h133q20 0 36.5 11t16.5 44q0 29 -14 41.5t-33 12.5h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 691,
    d: "M22 361q0 65 24.5 128t71.5 113t114 81t153 31q103 0 178.5 -42.5t112.5 -112.5l-149 -106q-10 26 -26.5 43t-36.5 27t-41.5 14t-41.5 4q-42 0 -72.5 -16.5t-50 -43t-29 -60t-9.5 -66.5q0 -37 11 -71t32 -60t51.5 -41.5t68.5 -15.5q20 0 41 4.5t40.5 15t35 27t24.5 40.5 l159 -95q-16 -39 -48.5 -70t-74 -52t-89 -32t-92.5 -11q-79 0 -144.5 31.5t-113 83.5t-73.5 118t-26 134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 716,
    d: "M61 0v710h273q88 0 155 -28t112 -76t68 -112.5t23 -137.5q0 -81 -25.5 -146.5t-72.5 -112t-113 -72t-147 -25.5h-273zM494 356q0 41 -11 75t-31.5 58t-50.5 37.5t-67 13.5h-78v-370h78q38 0 68 14t50.5 39t31 59t10.5 74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 563,
    d: "M61 0v710h487v-170h-292v-118h238v-158h-238v-264h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 739,
    d: "M543 59q-76 -64 -175 -64q-69 0 -132 24.5t-110 71.5t-75 115t-28 155q0 75 28 139.5t77 112t115.5 75t143.5 27.5q48 0 92 -10.5t81.5 -31t67.5 -49t49 -64.5l-145 -111q-21 42 -63 67.5t-89 25.5q-35 0 -64 -14t-50 -39t-33 -59.5t-12 -75.5q0 -42 12 -76t33.5 -58.5 t51.5 -38t67 -13.5q85 0 150 70h-123v140h292v-378h-161v59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 750,
    d: "M689 710v-710h-195v278h-238v-278h-195v710h195v-262h238v262h195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 498,
    d: "M42 192q3 -2 13 -7t25 -10t34.5 -9t40.5 -4q31 0 50 10t29 32.5t13 58t3 86.5v361h195v-361q0 -81 -9 -147.5t-39 -113.5t-87.5 -73t-154.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 690,
    d: "M61 0v710h195v-270l216 270h220l-258 -318l276 -392h-224l-176 261l-54 -56v-205h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 585,
    d: "M61 0v710h195v-540h322v-170h-517z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 854,
    d: "M598 0v374l-119 -263h-104l-119 263v-374h-195v710h213l153 -334l154 334h212v-710h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 754,
    d: "M256 349v-349h-195v710h152l285 -361v361h195v-710h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 623,
    d: "M61 0v710h306q52 0 96 -21.5t75.5 -56t49.5 -79t18 -89.5q0 -47 -17 -91.5t-47.5 -79t-74 -55t-95.5 -20.5h-116v-218h-195zM256 388h103q18 0 33.5 16.5t15.5 59.5q0 44 -18 60t-36 16h-98v-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 765,
    d: "M547 34q-37 -19 -78.5 -29t-87.5 -10q-81 0 -147 30.5t-113 81t-73 115.5t-26 134q0 70 27 135t75.5 115t115 79.5t145.5 29.5q81 0 147 -31.5t113 -82.5t72.5 -116t25.5 -133q0 -66 -23.5 -126.5t-66.5 -108.5l108 -117h-182zM383 168q22 0 37 4l-117 128h182l39 -43 q11 23 16 48t5 51q0 36 -10 69.5t-30.5 59.5t-51 41.5t-71.5 15.5q-42 0 -72.5 -16.5t-50.5 -43t-29.5 -60t-9.5 -68.5q0 -36 10 -69.5t30 -59.5t50.5 -41.5t72.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 675,
    d: "M61 0v710h326q52 0 96 -21.5t75.5 -56t49.5 -79t18 -89.5q0 -62 -27 -115.5t-75 -87.5l150 -261h-220l-125 218h-73v-218h-195zM256 388h123q18 0 33.5 20t15.5 56q0 37 -18 56.5t-36 19.5h-118v-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 617,
    d: "M491 478q-30 18 -62 32q-27 12 -60.5 22.5t-65.5 10.5q-26 0 -41.5 -8t-15.5 -27q0 -14 9 -23t26 -16.5t41.5 -14.5t55.5 -17q49 -15 88.5 -33t67.5 -42.5t43 -59.5t15 -85q0 -64 -23.5 -107.5t-62 -69.5t-87 -37.5t-97.5 -11.5q-39 0 -80 6t-81.5 17t-78 26t-69.5 34 l84 171q35 -22 73 -39q32 -15 72.5 -27t82.5 -12q32 0 44.5 8.5t12.5 22.5q0 15 -12.5 25.5t-34.5 18.5t-50.5 16t-60.5 19q-47 16 -81 34.5t-56 42t-32.5 53.5t-10.5 69q0 59 21.5 104t58.5 75t84.5 45.5t100.5 15.5q39 0 76 -7.5t71.5 -19t64.5 -25t54 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 624,
    d: "M614 540h-204v-540h-195v540h-205v170h604v-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 672,
    d: "M198 710l139 -465l137 465h205l-261 -710h-162l-264 710h206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1057,
    d: "M287 710h179l62 -219l63 219h179l-117 -339l51 -148l153 487h212l-278 -710h-162l-101 254l-100 -254h-162l-278 710h211l154 -487l49 148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 657,
    d: "M200 710l129 -224l129 224h210l-237 -360l229 -350h-210l-121 214l-121 -214h-211l229 350l-237 360h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 666,
    d: "M205 710l127 -307l130 307h212l-245 -475v-235h-194v237l-241 473h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 622,
    d: "M27 145l332 395h-317v170h542v-145l-312 -395h318v-170h-563v145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 371,
    d: "M79 -40v780h245v-150h-70v-480h70v-150h-245z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 694,
    d: "M235 710l435 -710h-209l-436 710h210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 371,
    d: "M47 -40v150h70v480h-70v150h245v-780h-245z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 625,
    d: "M36 303l198 407h158l197 -407h-153l-123 253l-126 -253h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 441,
    d: "M44 -170v170h353v-170h-353z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 284,
    d: "M45 730h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 647,
    d: "M383 -10q-119 0 -170 92v-82h-165v730h190v-282q23 43 65 65.5t99 22.5q48 0 89.5 -21t71.5 -57.5t47 -87t17 -109.5t-18.5 -108.5t-51 -85.5t-77.5 -56.5t-97 -20.5zM328 150q47 0 75.5 30t28.5 80q0 24 -7.5 45t-20 37t-30 25t-38.5 9q-30 0 -57 -21.5t-41 -56.5v-94 q37 -54 90 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 577,
    d: "M19 263q0 54 19 103.5t55.5 87t90.5 60t124 22.5q96 0 160.5 -40t96.5 -103l-185 -56q-27 39 -73 39q-39 0 -66 -29.5t-27 -83.5t27 -83.5t66 -29.5q46 0 73 39l185 -56q-32 -63 -96.5 -103t-160.5 -40q-70 0 -124 22.5t-90.5 60t-55.5 87t-19 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 665,
    d: "M268 -10q-54 0 -99.5 20t-78.5 56.5t-51.5 87t-18.5 110.5q0 58 17 108t47.5 86.5t72.5 57t93 20.5t93.5 -23t65.5 -65v282h190v-520q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-27 -48 -73 -70t-98 -22zM320 150q52 0 90 54v94q-14 35 -41 56.5 t-57 21.5q-21 0 -38.5 -9t-30 -25t-20 -37t-7.5 -45q0 -50 28.5 -80t75.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 402,
    d: "M85 0v322h-65v143h65v57q0 49 14 89.5t39 69t60.5 44t79.5 15.5q66 0 146 -30l-32 -144q-17 6 -36.5 10t-34.5 4q-46 0 -46 -51v-64h115v-143h-115v-322h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 647,
    d: "M250 0q-51 0 -93.5 20.5t-72.5 56t-46.5 83.5t-16.5 104q0 59 18 109t50.5 86t77.5 56.5t99 20.5q57 0 100 -22.5t68 -65.5v78h165v-478q0 -62 -23 -112t-65 -85t-101 -54.5t-131 -19.5q-84 0 -146 26t-110 75l100 104q29 -27 69.5 -45.5t86.5 -18.5q26 0 49.5 7 t41.5 22.5t28.5 40.5t10.5 60v34q-23 -42 -65.5 -62t-93.5 -20zM318 150q29 0 50.5 13.5t40.5 40.5v94q-14 36 -41.5 57t-57.5 21q-20 0 -37.5 -9.5t-30.5 -25t-20 -37t-7 -45.5q0 -49 29 -79t74 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-43.5 17.5q-9 0 -21.5 -5.5t-25 -15t-23.5 -23.5t-18 -31v-295h-190v730h190v-282q28 43 73 65.5t101 22.5q55 0 88 -19t50 -47.5t22 -61.5t5 -62v-346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM48 570v160h190v-160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 290,
    d: "M36 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v529h190v-514q0 -49 -15 -89.5t-42.5 -70t-65.5 -45.5t-83 -16zM52 570v160h190v-160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 582,
    d: "M395 0l-119 192l-38 -42v-150h-190v730h190v-399l140 195h200l-181 -230l199 -296h-201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 355,
    d: "M44 730h190v-521q0 -60 49 -60q12 0 26 4t26 11l24 -140q-34 -16 -76.5 -25t-80.5 -9q-76 0 -117 39t-41 113v588z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 940,
    d: "M896 0h-190v296q0 39 -15.5 56.5t-37.5 17.5q-23 0 -48.5 -21t-37.5 -54v-295h-190v296q0 39 -15.5 56.5t-37.5 17.5q-23 0 -48.5 -21t-37.5 -54v-295h-190v526h171v-78q28 43 77 65.5t116 22.5q32 0 56 -7.5t41.5 -20.5t28 -29t16.5 -34q28 43 76.5 67t110.5 24 q52 0 82.5 -19.5t46.5 -48.5t21 -62t5 -60v-346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-40.5 17.5q-24 0 -51 -21t-40 -54v-295h-190v526h171v-78q28 43 78.5 65.5t119.5 22.5q54 0 85.5 -19.5t48 -48.5t21.5 -62t5 -60v-346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 647,
    d: "M402 -10q-57 0 -99 22.5t-65 65.5v-291h-190v739h165v-79q28 43 69 66t101 23q52 0 97 -20.5t77 -56.5t50.5 -86t18.5 -108q0 -59 -17 -109.5t-47 -87.5t-71 -57.5t-89 -20.5zM336 150q21 0 38.5 9t30 25t20 37t7.5 45q0 50 -28.5 80t-75.5 30q-53 0 -90 -54v-91 q14 -35 41 -58t57 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 647,
    d: "M245 -10q-48 0 -89 20.5t-71 57.5t-47 87.5t-17 109.5q0 58 18.5 108t50.5 86t76.5 56.5t97.5 20.5q60 0 101 -24t69 -67v81h165v-519q0 -27 10 -37.5t36 -12.5v-160q-25 -5 -54 -7.5t-51 -2.5q-27 0 -50.5 8.5t-41.5 23.5t-28.5 36.5t-10.5 48.5v174q-23 -43 -65 -65.5 t-99 -22.5zM319 150q52 0 90 54v94q-14 35 -41 56.5t-57 21.5q-21 0 -38.5 -9t-30 -25t-20 -37t-7.5 -45q0 -50 28.5 -80t75.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 416,
    d: "M405 364q-55 0 -100 -12t-67 -40v-312h-190v526h174v-100q28 53 69.5 81.5t89.5 28.5q19 0 24 -1v-171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 501,
    d: "M265 -10q-69 0 -135 22.5t-112 65.5l65 114q49 -33 94.5 -51t83.5 -18q40 0 40 25q0 14 -15.5 24t-60.5 23q-56 16 -93.5 31.5t-61 33.5t-33.5 40t-10 52q0 40 16 74t44.5 59t68 38.5t86.5 13.5q58 0 110.5 -15t105.5 -61l-72 -114q-49 32 -82 45.5t-62 13.5 q-17 0 -28 -6.5t-11 -20.5q0 -15 16 -24.5t63 -21.5q57 -15 96 -31.5t62.5 -36t33.5 -44t10 -56.5q0 -41 -15 -73t-43.5 -55t-69 -35t-91.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 423,
    d: "M417 29q-40 -17 -85.5 -28.5t-89.5 -11.5q-32 0 -61 8t-50.5 26t-34 47t-12.5 72v241h-65v143h65v165h190v-165h103v-143h-103v-174q0 -26 11 -36.5t30 -10.5q14 0 32 4.5t36 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 563,
    d: "M178 0l-177 526h195l94 -377l95 377h177l-177 -526h-207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 862,
    d: "M693 526h179l-215 -526h-155l-71 200l-71 -200h-155l-215 526h179l127 -353l33 113l-94 240h151l45 -154l45 154h151l-94 -240l33 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 554,
    d: "M192 526l75 -129l10 -21l10 21l75 129h193l-176 -263l181 -263h-193l-81 129l-9 20l-9 -20l-81 -129h-193l181 263l-176 263h193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 555,
    d: "M44 -53q46 -17 78 -17q61 0 67 70l-191 526h195l100 -365l81 365h177l-178 -589q-12 -39 -34 -70.5t-52.5 -54t-67.5 -34.5t-77 -12q-51 0 -98 19v162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 494,
    d: "M22 112l240 284h-225v130h423v-112l-239 -284h248v-130h-447v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 374,
    d: "M265 590v-154q0 -28 -12.5 -45t-28.5 -31q15 -14 28 -31.5t13 -44.5v-165h55v-150h-202q-6 0 -14.5 5.5t-8.5 24.5v220q0 32 -19.5 52t-40.5 25v130q10 0 21 6.5t19.5 17t14 24t5.5 27.5v209q0 18 8.5 24t14.5 6h202v-150h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 312,
    d: "M76 -130v905h160v-905h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 374,
    d: "M54 590v150h202q6 0 14.5 -6t8.5 -24v-209q0 -14 5.5 -27.5t14 -24t19 -17t21.5 -6.5v-130q-21 -5 -40.5 -25t-19.5 -52v-220q0 -19 -8.5 -24.5t-14.5 -5.5h-202v150h55v165q0 27 13 44.5t28 31.5q-16 14 -28.5 31t-12.5 45v154h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 610,
    d: "M45 216q0 12 8 38.5t27.5 53t51 46.5t79.5 20q30 0 54.5 -8t46.5 -17.5t43 -17.5t45 -8q22 0 36 7.5t21 16.5t9.5 17t2.5 10h100q0 -8 -8.5 -33.5t-28 -53.5t-52 -49.5t-81.5 -21.5q-29 0 -53 7.5t-46.5 16.5t-44 16.5t-45.5 7.5q-23 0 -36 -7t-19 -16t-7.5 -16.5 t-1.5 -8.5h-101v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 225
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 360,
    d: "M275 410v-417h-190v417h190zM275 710v-184h-190v184h190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 618,
    d: "M276 -120v111q-53 4 -97 28.5t-75.5 61.5t-49.5 83t-18 94q0 51 15 96t45 81.5t75 62t105 36.5v111h80v-111q66 -2 128 -36.5t99 -104.5l-185 -56q-7 12 -19 21.5t-23 11.5v-215q16 7 26 15.5t16 18.5l185 -56q-17 -36 -45.5 -63t-60.5 -44.5t-64.5 -26.5t-56.5 -9v-110 h-80zM232 258q0 -28 10.5 -52.5t33.5 -41.5v197q-20 -11 -32 -38.5t-12 -64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 586,
    d: "M61 388h55l-28 70t-14 73q0 39 17.5 72.5t48.5 58t72 39t89 14.5q66 0 126.5 -27.5t103.5 -77.5l-96 -117q-13 15 -29.5 27.5t-34.5 21.5t-36.5 14.5t-34.5 5.5q-27 0 -42.5 -14t-15.5 -38q0 -26 14.5 -56t28.5 -66h189v-140h-178q-7 -27 -22 -51.5t-40 -50.5 q24 8 42.5 11.5t35.5 3.5q32 0 65 -7.5t65 -7.5q17 0 31 3t32 10l46 -140q-23 -15 -56 -24.5t-63 -9.5q-23 0 -48 5t-50.5 11.5t-51.5 11.5t-51 5q-29 0 -67.5 -7.5t-76.5 -19.5l-38 134q31 18 54 51.5t32 71.5h-74v140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 569,
    d: "M183 507q22 11 47.5 16.5t55.5 5.5q29 0 54 -5.5t46 -14.5l68 69l71 -71l-63 -63q14 -23 22 -50t8 -56q0 -59 -31 -107l64 -64l-66 -66l-71 67q-42 -21 -102 -21q-59 0 -105 22l-72 -68l-66 66l66 66q-29 47 -29 105q0 28 7 54t21 49l-65 66l71 71zM213 338 q0 -37 20.5 -58t52.5 -21t52.5 21t20.5 58t-20.5 58t-52.5 21t-52.5 -21t-20.5 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 742,
    d: "M566 432h64v-120h-126l-39 -77v-33h166v-120h-166v-82h-194v82h-165v120h165v35l-38 75h-126v120h65l-142 278h211l127 -307l130 307h212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 316,
    d: "M238 254v-384h-160v384h160zM238 775v-384h-160v384h160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 551,
    d: "M488 232q9 -14 17 -38t8 -62q0 -62 -24 -104t-60 -68t-78 -37t-78 -11q-43 0 -80.5 13t-67.5 31.5t-51 38t-31 32.5l121 116q26 -29 51 -40t49 -11q22 0 36.5 8t14.5 25t-13 20.5t-27 4.5q-56 4 -96.5 20.5t-67.5 42t-40 58t-13 70.5q0 30 5.5 44t6.5 21q-8 11 -20 38.5 t-12 65.5q0 39 16.5 75.5t46 65.5t71 46.5t91.5 17.5q48 0 86 -16t66.5 -39t49 -48t33.5 -44l-145 -68q-11 18 -29 32.5t-49 14.5q-26 0 -35.5 -10t-9.5 -24q0 -20 13 -24t30 -5q38 -2 78.5 -11t73.5 -29.5t54.5 -54t21.5 -83.5q0 -29 -5.5 -48.5t-7.5 -25.5zM242 314 q0 -14 8 -20.5t19 -9.5t23 -3.5t20 -3.5q5 4 7 10.5t2 12.5q0 19 -14 26t-26 7q-5 0 -10 0.5t-10 1.5l-10 2q-9 -7 -9 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 566,
    d: "M90 580v140h156v-140h-156zM320 580v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 847,
    d: "M419 -7q-82 0 -152 27.5t-121 76t-79.5 114.5t-28.5 144q0 77 28.5 143t79.5 114t121 75.5t152 27.5q84 0 156 -27.5t124 -75.5t81.5 -114t29.5 -143q0 -78 -29.5 -144t-81.5 -114.5t-124 -76t-156 -27.5zM419 57q67 0 126 22t102 61t68 94t25 121q0 61 -24.5 115 t-67 94.5t-101.5 63.5t-128 23q-66 0 -123 -23t-99 -63.5t-65.5 -94.5t-23.5 -115q0 -62 23.5 -116.5t65 -95t98.5 -63.5t124 -23zM429 111q-65 0 -115.5 20t-84.5 53.5t-51.5 77.5t-17.5 92t17.5 92t51.5 77.5t84.5 53.5t115.5 20q92 0 154 -40t93 -103l-185 -56 q-23 39 -63 39q-30 0 -51.5 -21.5t-21.5 -61.5t21.5 -61.5t51.5 -21.5q40 0 63 39l185 -56q-31 -63 -93 -103t-154 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 451,
    d: "M155 333q-26 0 -48.5 9t-39 24.5t-25.5 37t-9 47.5q0 28 11 51t31 39.5t47.5 26t60.5 9.5q42 0 68 -14v11q0 26 -13 39t-45 13q-29 0 -54 -10t-53 -30l-38 82q69 47 158 47q85 0 130 -39.5t45 -117.5v-71q0 -19 7 -26.5t24 -8.5v-112q-17 -4 -33 -5.5t-28 -1.5 q-35 0 -53 12.5t-23 38.5l-3 14q-47 -65 -117 -65zM194 428q10 0 21.5 4t19.5 10q16 11 16 26v27q-10 5 -22.5 7.5t-22.5 2.5q-22 0 -36.5 -12t-14.5 -30q0 -15 11 -25t28 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 713,
    d: "M30 298l277 198v-152l-128 -85l128 -77v-152l-277 180v88zM381 298l277 198v-152l-128 -85l128 -77v-152l-277 180v88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 637,
    d: "M578 431v-342h-160v172h-369v170h529z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 629,
    d: "M50 191v170h529v-170h-529z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 847,
    d: "M421 -7q-83 0 -153.5 27.5t-121.5 76t-79.5 114.5t-28.5 144q0 77 28.5 143t79.5 114t121.5 75.5t153.5 27.5t154.5 -27.5t123.5 -75.5t81.5 -114t29.5 -143q0 -78 -29.5 -144t-81.5 -114.5t-123.5 -76t-154.5 -27.5zM422 56q66 0 123.5 22.5t100 62t66.5 93.5t24 118 q0 63 -23.5 117.5t-65.5 95t-99.5 63.5t-125.5 23t-125 -23t-98 -63.5t-64 -94.5t-23 -116t23 -116t64 -94.5t98 -64t125 -23.5zM251 572h199q31 0 58 -13t46 -34.5t30 -48.5t11 -54q0 -35 -17 -68t-45 -53l96 -157h-147l-81 131h-18v-131h-132v428zM436 387q11 0 20 7t9 28 q0 23 -10 29t-21 6h-51v-70h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 438,
    d: "M64 607v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 300,
    d: "M31 610q0 49 33 81.5t86 32.5t86 -32.5t33 -81.5q0 -57 -33 -90.5t-86 -33.5t-86 34.5t-33 89.5zM127 627q-9 -9 -9 -22t9 -22q10 -10 23 -10q14 0 22 10q5 4 7 10.5t2 11.5q0 14 -9 22q-4 5 -10 7t-12 2q-14 0 -23 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 480,
    d: "M49 1v150h380v-150h-380zM430 462v-150h-105v-115h-170v115h-105v150h105v115h170v-115h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 441,
    d: "M26 376q0 43 6 74.5t21 56t41 43.5t66 36q24 10 47 19.5t41 20t29 22.5t11 29q0 23 -19.5 30.5t-52.5 7.5q-38 0 -69 -13.5t-51 -30.5l-68 80q22 29 75 49.5t129 20.5q87 0 133.5 -36.5t46.5 -108.5q0 -34 -12.5 -58t-31 -41t-40.5 -27t-41 -15q-36 -10 -58 -21t-22 -31 h187v-107h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 422,
    d: "M194 369q-63 0 -107 17t-64 54l57 84q6 -6 15.5 -14t23 -14.5t31.5 -11.5t42 -5q36 0 63 7.5t27 27.5q0 23 -39 32t-109 9h-25v99h24q58 0 96 8.5t38 31.5q0 8 -7 13t-17.5 8t-22 4t-20.5 1q-39 0 -64 -12t-46 -32l-69 89q13 14 33 24.5t43.5 17.5t49.5 10.5t52 3.5 q39 0 73 -9t58.5 -25.5t38.5 -38.5t14 -47q0 -36 -26.5 -59.5t-71.5 -30.5q51 -7 79.5 -39.5t28.5 -74.5q0 -35 -17.5 -59.5t-45.5 -39.5t-63.5 -22t-72.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 284,
    d: "M165 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 708,
    d: "M75 526h190v-303q0 -35 15 -54t47 -19q18 0 41 10t46 44v322h190v-316q0 -27 10 -37.5t36 -12.5v-160q-29 -5 -51 -7.5t-39 -2.5q-97 0 -112 73l-4 19q-6 -15 -20.5 -31.5t-33.5 -30t-40 -22.5t-40 -9q-17 0 -32 8.5t-25 28.5v-239h-178v739z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 705,
    d: "M34 445q0 128 73.5 196.5t208.5 68.5h341v-140h-70v-650h-160v268h-31v-268h-160v268q-45 0 -82 19t-64 52.5t-41.5 81t-14.5 104.5zM191 450q0 -50 12.5 -84t32.5 -38v242q-20 -4 -32.5 -37.5t-12.5 -82.5zM427 570h-31v-242h31v242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 254,
    d: "M50 238v184h154v-184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 362,
    d: "M55 -128q11 -7 37 -13.5t53 -6.5q23 0 39.5 7t16.5 24t-15 23.5t-40 6.5q-21 0 -44.5 -3.5t-34.5 -5.5l64 132l69 -19l-36 -51q6 1 12.5 1.5t14.5 0.5q18 0 35 -4.5t30 -13.5t21 -24t8 -36q0 -42 -36.5 -72.5t-115.5 -30.5q-36 0 -64.5 6.5t-48.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 321,
    d: "M300 485v-107h-253v107h76v221q-5 -7 -16 -16t-24 -17.5t-27 -14t-26 -5.5v109q15 0 31.5 9t30 20t22.5 20t9 10h110v-336h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 438,
    d: "M219 333q-47 0 -82.5 15.5t-59.5 42t-36.5 61t-12.5 72.5t12.5 72.5t36.5 61t59.5 42t82.5 15.5t83 -15.5t60 -42t36 -61t12 -72.5t-12 -72.5t-36 -61t-60 -42t-83 -15.5zM161 524q0 -37 16 -58t42 -21t42 21t16 58t-16 58t-42 21t-42 -21t-16 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 713,
    d: "M683 210l-277 -180v152l128 77l-128 85v152l277 -198v-88zM332 210l-277 -180v152l128 77l-128 85v152l277 -198v-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1020,
    d: "M214 65l283 319l251 337l83 -75l-271 -309l-263 -347zM310 395v-107h-253v107h76v221q-5 -7 -16 -16t-24 -17.5t-27 -14t-26 -5.5v109q15 0 31.5 9t30 20t22.5 20t9 10h110v-336h67zM814 1v83h-215v107l249 250h74v-250h64v-107h-64v-83h-108zM700 191h118v121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1033,
    d: "M171 65l283 319l251 337l83 -75l-271 -309l-263 -347zM307 395v-107h-253v107h76v221q-5 -7 -16 -16t-24 -17.5t-27 -14t-26 -5.5v109q15 0 31.5 9t30 20t22.5 20t9 10h110v-336h67zM609 0q0 43 6 74.5t21 56t41 43.5t67 36q24 10 46.5 19.5t40.5 20t29 22.5t11 29 q0 23 -19.5 30.5t-52.5 7.5q-38 0 -69 -13.5t-51 -30.5l-68 80q22 29 75 49.5t130 20.5q86 0 132.5 -36.5t46.5 -108.5q0 -34 -12.5 -58t-31 -41t-40.5 -27t-41 -15q-36 -10 -58 -21t-22 -31h206v-107h-387z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 1027,
    d: "M243 65l283 319l251 337l83 -75l-271 -309l-263 -347zM821 1v83h-215v107l249 250h74v-250h64v-107h-64v-83h-108zM707 191h118v121zM208 279q-63 0 -107 17t-64 54l57 84q20 -18 45.5 -31.5t66.5 -13.5q36 0 63 7.5t27 27.5q0 23 -39 32t-109 9h-25v99h24q58 0 96 8.5 t38 31.5q0 8 -7 13t-17.5 8t-22 4t-20.5 1q-39 0 -64 -12t-46 -32l-69 89q13 14 33 24.5t43.5 17.5t49.5 10.5t52 3.5q39 0 73 -9t58.5 -25.5t38.5 -38.5t14 -47q0 -36 -26.5 -59.5t-71.5 -30.5q51 -7 79.5 -39.5t28.5 -74.5q0 -35 -17.5 -59.5t-45.5 -39.5t-63.5 -22 t-72.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 487,
    d: "M395 247q0 -21 -2 -41.5t-10 -39t-24 -35.5t-43 -31q-11 -6 -32 -16t-41 -24t-35 -31.5t-15 -38.5q0 -23 18 -36.5t42 -13.5q18 0 31 7t22.5 17t16 20.5t12.5 17.5l121 -86q-26 -61 -82 -95t-128 -34q-38 0 -77 11t-70.5 35t-51 63t-19.5 95q0 48 17.5 87.5t62.5 69.5 q22 15 45 26t42.5 22t32 22.5t12.5 28.5h155zM392 506v-164h-155v164h155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM177 915h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM392 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM153 799l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM398 756q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5 t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM141 765v140h156v-140h-156zM371 765v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM217 827q0 44 31.5 65.5t85.5 21.5t85.5 -21.5t31.5 -65.5t-31.5 -65.5t-85.5 -21.5t-85.5 21.5t-31.5 65.5zM334 860q-17 0 -28.5 -9t-11.5 -23q0 -15 11.5 -24.5t28.5 -9.5 t28.5 9.5t11.5 24.5q0 14 -11.5 23t-28.5 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 971,
    d: "M405 710h527v-170h-282v-94h228v-170h-228v-106h291v-170h-485v139h-201l-75 -139h-206zM441 309v186l-104 -186h104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 691,
    d: "M277 -128q11 -7 37 -13.5t53 -6.5q23 0 39.5 7t16.5 24t-15 23.5t-40 6.5q-21 0 -44.5 -3.5t-34.5 -5.5l45 93q-70 9 -127.5 43t-98.5 84.5t-63.5 112t-22.5 124.5q0 65 24.5 128t71.5 113t114 81t153 31q103 0 178.5 -42.5t112.5 -112.5l-149 -106q-10 26 -26.5 43 t-36.5 27t-41.5 14t-41.5 4q-42 0 -72.5 -16.5t-50 -43t-29 -60t-9.5 -66.5q0 -37 11 -71t32 -60t51.5 -41.5t68.5 -15.5q20 0 41 4.5t40.5 15t35 27t24.5 40.5l159 -95q-15 -36 -44 -65t-66.5 -50t-80.5 -33.5t-86 -15.5l-20 -29q6 1 12.5 1.5t14.5 0.5q18 0 35 -4.5 t30 -13.5t21 -24t8 -36q0 -42 -36.5 -72.5t-115.5 -30.5q-36 0 -64.5 6.5t-48.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM159 915h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM374 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM135 799l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM123 765v140h156v-140h-156zM353 765v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM1 915h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM216 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM-23 799l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM-35 765v140h156v-140h-156zM195 765v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 720,
    d: "M65 0v287h-37v140h37v283h273q88 0 155 -28t112 -76t68 -112.5t23 -137.5q0 -81 -25.5 -146.5t-72.5 -112t-113 -72t-147 -25.5h-273zM498 356q0 41 -11 75t-31.5 58t-50.5 37.5t-67 13.5h-78v-113h114v-140h-114v-117h78q38 0 68 14t50.5 39t31 59t10.5 74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 754,
    d: "M256 349v-349h-195v710h152l285 -361v361h195v-710h-155zM438 755q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5 t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM233 915h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM451 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM203 799l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM452 756q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8 t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM191 765v140h156v-140h-156zM421 765v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 492,
    d: "M451 191l-119 -118l-87 87l-87 -87l-117 118l86 86l-80 81l119 118l80 -80l80 80l117 -118l-80 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 763,
    d: "M745 710l-90 -123q42 -50 64.5 -111t22.5 -124q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30q-74 0 -137 26l-14 -20h-209l87 120q-42 50 -64 110.5t-22 125.5q0 70 27 135t75.5 114.5t115 79t145.5 29.5q37 0 70.5 -7t64.5 -19l16 22h210zM219 354q0 -36 9 -67 l183 251q-15 3 -30 3q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM544 356q0 35 -9 65l-183 -252q7 -1 14.5 -1.5t15.5 -0.5q42 0 73 16.5t50.5 43t29 60.5t9.5 69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM214 915h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM429 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM190 799l113 115h136l113 -115l-96 -42l-85 63 l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM178 765v140h156v-140h-156zM408 765v140h156 v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 666,
    d: "M205 710l127 -307l130 307h212l-245 -475v-235h-194v237l-241 473h211zM390 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 605,
    d: "M352 592q52 0 96 -21.5t75.5 -56t49.5 -78.5t18 -89q0 -48 -17 -92t-47.5 -78.5t-74 -55t-95.5 -20.5h-101v-101h-195v710h195v-118h96zM347 271q19 0 34 20.5t15 55.5q0 37 -17.5 56t-36.5 19h-86v-151h91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 563,
    d: "M254 168q37 0 63.5 17.5t26.5 51.5q0 18 -7.5 30.5t-18.5 20.5t-22.5 11.5t-20.5 3.5h-23v170h21q21 0 30 11t9 28q0 16 -6.5 24.5t-14.5 12.5t-14.5 4.5t-7.5 0.5q-15 0 -23.5 -7.5t-12.5 -17.5t-4.5 -20t-0.5 -15v-494h-180v529q0 40 18.5 73.5t51 58.5t76 39t94.5 14 q44 0 81.5 -11t64.5 -32.5t42.5 -53t15.5 -71.5q0 -25 -6 -48t-15.5 -41.5t-22.5 -32.5t-27 -21q57 -22 90 -70t33 -120q0 -65 -26.5 -107.5t-68 -67t-93 -34.5t-102.5 -10v174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM123 731h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM338 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM99 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM344 572q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7 t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM87 581v140h156v-140h-156zM317 581v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM163 643q0 44 31.5 65.5t85.5 21.5t85.5 -21.5t31.5 -65.5 t-31.5 -65.5t-85.5 -21.5t-85.5 21.5t-31.5 65.5zM280 676q-17 0 -28.5 -9t-11.5 -23q0 -15 11.5 -24.5t28.5 -9.5t28.5 9.5t11.5 24.5q0 14 -11.5 23t-28.5 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 942,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q-1 37 -22 55t-69 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q117 0 185 -50q34 23 77.5 36.5t97.5 13.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5 q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40q-80 0 -138.5 28t-94.5 74q-19 -27 -44 -46.5t-52 -31.5t-55 -18t-53 -6zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10 t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM724 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 577,
    d: "M216 -128q11 -7 37 -13.5t53 -6.5q23 0 39.5 7t16.5 24t-15 23.5t-40 6.5q-21 0 -44.5 -3.5t-34.5 -5.5l42 88q-61 6 -107.5 30t-78.5 61t-48.5 83.5t-16.5 96.5q0 54 19 103.5t55.5 87t90.5 60t124 22.5q96 0 160.5 -40t96.5 -103l-185 -56q-27 39 -73 39 q-39 0 -66 -29.5t-27 -83.5t27 -83.5t66 -29.5q46 0 73 39l185 -56q-29 -57 -85 -95.5t-137 -45.5l-18 -26q6 1 12.5 1.5t14.5 0.5q18 0 35 -4.5t30 -13.5t21 -24t8 -36q0 -42 -36.5 -72.5t-115.5 -30.5q-36 0 -64.5 6.5t-48.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM150 731h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM365 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM126 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM114 581v140h156v-140h-156zM344 581v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM-14 731h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM201 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM-38 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM-50 581v140h156v-140h-156zM180 581v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 621,
    d: "M551 641l-62 -32q51 -66 80 -148t29 -170q0 -71 -20 -126.5t-57 -94.5t-90.5 -59.5t-120.5 -20.5q-63 0 -116 18t-91.5 50.5t-59.5 77t-21 98.5q0 50 18.5 93t50.5 75t75.5 50.5t93.5 18.5q40 0 77 -12t66 -34q-9 33 -23.5 63.5t-35.5 59.5l-76 -38l-52 71l67 34 q-67 61 -175 115h230q23 -11 45.5 -24.5t43.5 -31.5l72 38zM217 235q0 -38 25.5 -61.5t67.5 -23.5t67.5 23.5t25.5 61.5t-25.5 61.5t-67.5 23.5t-67.5 -23.5t-25.5 -61.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-40.5 17.5q-24 0 -51 -21t-40 -54v-295h-190v526h171v-78q28 43 78.5 65.5t119.5 22.5q54 0 85.5 -19.5t48 -48.5t21.5 -62t5 -60v-346zM397 572q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5 h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM150 731 h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM365 556 l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM126 615 l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM371 572 q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM114 581 v140h156v-140h-156zM344 581v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 485,
    d: "M164 435v160h159v-160h-159zM164 27v160h159v-160h-159zM41 235v150h404v-150h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 614,
    d: "M14 -6l74 83q-35 38 -52 85.5t-17 100.5q0 54 18.5 103.5t55 87t90 60t124.5 22.5q46 0 84 -9.5t70 -26.5l29 32h101l-70 -78q37 -38 55.5 -87.5t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5q-48 0 -88.5 10.5t-72.5 29.5l-32 -36h-100zM307 150q41 0 67 30 t26 83q0 28 -8 50l-133 -150q20 -13 48 -13zM214 263q0 -12 1.5 -22.5t3.5 -20.5l130 146q-22 10 -42 10q-41 0 -67 -30t-26 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM151 731h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM366 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM127 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM115 581v140h156v-140h-156zM345 581v140h156v-140h-156z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 555,
    d: "M44 -53q46 -17 78 -17q61 0 67 70l-191 526h195l100 -365l81 365h177l-178 -589q-12 -39 -34 -70.5t-52.5 -54t-67.5 -34.5t-77 -12q-51 0 -98 19v162zM351 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 599,
    d: "M581 255q0 -57 -22 -109t-58.5 -91.5t-85.5 -62.5t-103 -23q-23 0 -42.5 5t-26.5 13v-200h-195v923h195v-185q11 9 30.5 14t45.5 5q53 0 100.5 -23t83.5 -62.5t57 -92t21 -111.5zM386 259q0 53 -21.5 84t-57.5 31q-20 0 -35 -10.5t-29 -36.5v-148q0 -7 5.5 -14t14.5 -13 t20 -9.5t22 -3.5q36 0 58.5 33t22.5 87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 555,
    d: "M44 -53q46 -17 78 -17q61 0 67 70l-191 526h195l100 -365l81 365h177l-178 -589q-12 -39 -34 -70.5t-52.5 -54t-67.5 -34.5t-77 -12q-51 0 -98 19v162zM100 581v140h156v-140h-156zM330 581v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM180 791v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM126 607v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM334 833q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM280 649q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51 t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 680,
    d: "M632 -215q-78 9 -115 37t-37 63q0 29 21.5 59t64.5 56h-95l-43 139h-189l-42 -139h-199l247 710h178l246 -710q-35 -20 -53.5 -40.5t-18.5 -37.5t17 -27t53 -10zM397 269l-63 220l-66 -220h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 600,
    d: "M541 -215q-78 9 -115 37t-37 63q0 27 18.5 55t55.5 53q-65 10 -77 70l-4 19q-35 -45 -81 -68.5t-98 -23.5q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118 q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-35 -20 -53.5 -40.5t-18.5 -37.5t17 -27t53 -10zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 691,
    d: "M22 361q0 65 24.5 128t71.5 113t114 81t153 31q103 0 178.5 -42.5t112.5 -112.5l-149 -106q-10 26 -26.5 43t-36.5 27t-41.5 14t-41.5 4q-42 0 -72.5 -16.5t-50 -43t-29 -60t-9.5 -66.5q0 -37 11 -71t32 -60t51.5 -41.5t68.5 -15.5q20 0 41 4.5t40.5 15t35 27t24.5 40.5 l159 -95q-16 -39 -48.5 -70t-74 -52t-89 -32t-92.5 -11q-79 0 -144.5 31.5t-113 83.5t-73.5 118t-26 134zM448 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 577,
    d: "M19 263q0 54 19 103.5t55.5 87t90.5 60t124 22.5q96 0 160.5 -40t96.5 -103l-185 -56q-27 39 -73 39q-39 0 -66 -29.5t-27 -83.5t27 -83.5t66 -29.5q46 0 73 39l185 -56q-32 -63 -96.5 -103t-160.5 -40q-70 0 -124 22.5t-90.5 60t-55.5 87t-19 103.5zM366 556l-120 32 l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 691,
    d: "M22 361q0 65 24.5 128t71.5 113t114 81t153 31q103 0 178.5 -42.5t112.5 -112.5l-149 -106q-10 26 -26.5 43t-36.5 27t-41.5 14t-41.5 4q-42 0 -72.5 -16.5t-50 -43t-29 -60t-9.5 -66.5q0 -37 11 -71t32 -60t51.5 -41.5t68.5 -15.5q20 0 41 4.5t40.5 15t35 27t24.5 40.5 l159 -95q-16 -39 -48.5 -70t-74 -52t-89 -32t-92.5 -11q-79 0 -144.5 31.5t-113 83.5t-73.5 118t-26 134zM201 799l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 577,
    d: "M19 263q0 54 19 103.5t55.5 87t90.5 60t124 22.5q96 0 160.5 -40t96.5 -103l-185 -56q-27 39 -73 39q-39 0 -66 -29.5t-27 -83.5t27 -83.5t66 -29.5q46 0 73 39l185 -56q-32 -63 -96.5 -103t-160.5 -40q-70 0 -124 22.5t-90.5 60t-55.5 87t-19 103.5zM127 615l113 115 h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 691,
    d: "M22 361q0 65 24.5 128t71.5 113t114 81t153 31q103 0 178.5 -42.5t112.5 -112.5l-149 -106q-10 26 -26.5 43t-36.5 27t-41.5 14t-41.5 4q-42 0 -72.5 -16.5t-50 -43t-29 -60t-9.5 -66.5q0 -37 11 -71t32 -60t51.5 -41.5t68.5 -15.5q20 0 41 4.5t40.5 15t35 27t24.5 40.5 l159 -95q-16 -39 -48.5 -70t-74 -52t-89 -32t-92.5 -11q-79 0 -144.5 31.5t-113 83.5t-73.5 118t-26 134zM305 764v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 577,
    d: "M19 263q0 54 19 103.5t55.5 87t90.5 60t124 22.5q96 0 160.5 -40t96.5 -103l-185 -56q-27 39 -73 39q-39 0 -66 -29.5t-27 -83.5t27 -83.5t66 -29.5q46 0 73 39l185 -56q-32 -63 -96.5 -103t-160.5 -40q-70 0 -124 22.5t-90.5 60t-55.5 87t-19 103.5zM223 580v150h170 v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 691,
    d: "M22 361q0 65 24.5 128t71.5 113t114 81t153 31q103 0 178.5 -42.5t112.5 -112.5l-149 -106q-10 26 -26.5 43t-36.5 27t-41.5 14t-41.5 4q-42 0 -72.5 -16.5t-50 -43t-29 -60t-9.5 -66.5q0 -37 11 -71t32 -60t51.5 -41.5t68.5 -15.5q20 0 41 4.5t40.5 15t35 27t24.5 40.5 l159 -95q-16 -39 -48.5 -70t-74 -52t-89 -32t-92.5 -11q-79 0 -144.5 31.5t-113 83.5t-73.5 118t-26 134zM310 914l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 577,
    d: "M19 263q0 54 19 103.5t55.5 87t90.5 60t124 22.5q96 0 160.5 -40t96.5 -103l-185 -56q-27 39 -73 39q-39 0 -66 -29.5t-27 -83.5t27 -83.5t66 -29.5q46 0 73 39l185 -56q-32 -63 -96.5 -103t-160.5 -40q-70 0 -124 22.5t-90.5 60t-55.5 87t-19 103.5zM223 730l85 -63 l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 716,
    d: "M61 0v710h273q88 0 155 -28t112 -76t68 -112.5t23 -137.5q0 -81 -25.5 -146.5t-72.5 -112t-113 -72t-147 -25.5h-273zM494 356q0 41 -11 75t-31.5 58t-50.5 37.5t-67 13.5h-78v-370h78q38 0 68 14t50.5 39t31 59t10.5 74zM232 914l85 -63l85 63l96 -42l-113 -115h-136 l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 665,
    d: "M268 -10q-54 0 -99.5 20t-78.5 56.5t-51.5 87t-18.5 110.5q0 58 17 108t47.5 86.5t72.5 57t93 20.5t93.5 -23t65.5 -65v282h190v-520q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-27 -48 -73 -70t-98 -22zM320 150q52 0 90 54v94q-14 35 -41 56.5 t-57 21.5q-21 0 -38.5 -9t-30 -25t-20 -37t-7.5 -45q0 -50 28.5 -80t75.5 -30zM739 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 720,
    d: "M65 0v287h-37v140h37v283h273q88 0 155 -28t112 -76t68 -112.5t23 -137.5q0 -81 -25.5 -146.5t-72.5 -112t-113 -72t-147 -25.5h-273zM498 356q0 41 -11 75t-31.5 58t-50.5 37.5t-67 13.5h-78v-113h114v-140h-114v-117h78q38 0 68 14t50.5 39t31 59t10.5 74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 665,
    d: "M268 -10q-54 0 -99.5 20t-78.5 56.5t-51.5 87t-18.5 110.5q0 58 17 108t47.5 86.5t72.5 57t93 20.5t93.5 -23t65.5 -65v131h-87v109h87v42h190v-42h58v-109h-58v-369q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-27 -48 -73 -70t-98 -22zM320 150 q52 0 90 54v94q-14 35 -41 56.5t-57 21.5q-21 0 -38.5 -9t-30 -25t-20 -37t-7.5 -45q0 -50 28.5 -80t75.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM162 791v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM153 607v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM316 833q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM307 649q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM231 764v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM222 580v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 598,
    d: "M530 -215q-78 9 -115 37t-37 63q0 29 21.5 59t64.5 56h-403v710h497v-170h-302v-100h258v-158h-258v-112h311v-170q-35 -20 -53.5 -40.5t-18.5 -37.5t17 -27t53 -10l-35 -100v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    d: "M364 -213q-78 9 -115 37t-37 63q0 26 17 53t52 51q-63 4 -112 27t-82.5 59t-50.5 82.5t-17 96.5q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39 l161 -46q-24 -47 -66.5 -81.5t-102.5 -50.5q-71 -40 -71 -77q0 -17 17 -27t53 -10zM391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM231 914l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM222 730l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 739,
    d: "M543 59q-76 -64 -175 -64q-69 0 -132 24.5t-110 71.5t-75 115t-28 155q0 75 28 139.5t77 112t115.5 75t143.5 27.5q48 0 92 -10.5t81.5 -31t67.5 -49t49 -64.5l-145 -111q-21 42 -63 67.5t-89 25.5q-35 0 -64 -14t-50 -39t-33 -59.5t-12 -75.5q0 -42 12 -76t33.5 -58.5 t51.5 -38t67 -13.5q85 0 150 70h-123v140h292v-378h-161v59zM208 799l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 647,
    d: "M250 0q-51 0 -93.5 20.5t-72.5 56t-46.5 83.5t-16.5 104q0 59 18 109t50.5 86t77.5 56.5t99 20.5q57 0 100 -22.5t68 -65.5v78h165v-478q0 -62 -23 -112t-65 -85t-101 -54.5t-131 -19.5q-84 0 -146 26t-110 75l100 104q29 -27 69.5 -45.5t86.5 -18.5q26 0 49.5 7 t41.5 22.5t28.5 40.5t10.5 60v34q-23 -42 -65.5 -62t-93.5 -20zM318 150q29 0 50.5 13.5t40.5 40.5v94q-14 36 -41.5 57t-57.5 21q-20 0 -37.5 -9.5t-30.5 -25t-20 -37t-7 -45.5q0 -49 29 -79t74 -30zM172 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 739,
    d: "M543 59q-76 -64 -175 -64q-69 0 -132 24.5t-110 71.5t-75 115t-28 155q0 75 28 139.5t77 112t115.5 75t143.5 27.5q48 0 92 -10.5t81.5 -31t67.5 -49t49 -64.5l-145 -111q-21 42 -63 67.5t-89 25.5q-35 0 -64 -14t-50 -39t-33 -59.5t-12 -75.5q0 -42 12 -76t33.5 -58.5 t51.5 -38t67 -13.5q85 0 150 70h-123v140h292v-378h-161v59zM389 833q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 647,
    d: "M250 0q-51 0 -93.5 20.5t-72.5 56t-46.5 83.5t-16.5 104q0 59 18 109t50.5 86t77.5 56.5t99 20.5q57 0 100 -22.5t68 -65.5v78h165v-478q0 -62 -23 -112t-65 -85t-101 -54.5t-131 -19.5q-84 0 -146 26t-110 75l100 104q29 -27 69.5 -45.5t86.5 -18.5q26 0 49.5 7 t41.5 22.5t28.5 40.5t10.5 60v34q-23 -42 -65.5 -62t-93.5 -20zM318 150q29 0 50.5 13.5t40.5 40.5v94q-14 36 -41.5 57t-57.5 21q-20 0 -37.5 -9.5t-30.5 -25t-20 -37t-7 -45.5q0 -49 29 -79t74 -30zM353 649q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51 t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 739,
    d: "M543 59q-76 -64 -175 -64q-69 0 -132 24.5t-110 71.5t-75 115t-28 155q0 75 28 139.5t77 112t115.5 75t143.5 27.5q48 0 92 -10.5t81.5 -31t67.5 -49t49 -64.5l-145 -111q-21 42 -63 67.5t-89 25.5q-35 0 -64 -14t-50 -39t-33 -59.5t-12 -75.5q0 -42 12 -76t33.5 -58.5 t51.5 -38t67 -13.5q85 0 150 70h-123v140h292v-378h-161v59zM306 764v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 647,
    d: "M250 0q-51 0 -93.5 20.5t-72.5 56t-46.5 83.5t-16.5 104q0 59 18 109t50.5 86t77.5 56.5t99 20.5q57 0 100 -22.5t68 -65.5v78h165v-478q0 -62 -23 -112t-65 -85t-101 -54.5t-131 -19.5q-84 0 -146 26t-110 75l100 104q29 -27 69.5 -45.5t86.5 -18.5q26 0 49.5 7 t41.5 22.5t28.5 40.5t10.5 60v34q-23 -42 -65.5 -62t-93.5 -20zM318 150q29 0 50.5 13.5t40.5 40.5v94q-14 36 -41.5 57t-57.5 21q-20 0 -37.5 -9.5t-30.5 -25t-20 -37t-7 -45.5q0 -49 29 -79t74 -30zM268 580v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 739,
    d: "M543 59q-76 -64 -175 -64q-69 0 -132 24.5t-110 71.5t-75 115t-28 155q0 75 28 139.5t77 112t115.5 75t143.5 27.5q48 0 92 -10.5t81.5 -31t67.5 -49t49 -64.5l-145 -111q-21 42 -63 67.5t-89 25.5q-35 0 -64 -14t-50 -39t-33 -59.5t-12 -75.5q0 -42 12 -76t33.5 -58.5 t51.5 -38t67 -13.5q85 0 150 70h-123v140h292v-378h-161v59zM313 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 647,
    d: "M250 0q-51 0 -93.5 20.5t-72.5 56t-46.5 83.5t-16.5 104q0 59 18 109t50.5 86t77.5 56.5t99 20.5q57 0 100 -22.5t68 -65.5v78h165v-478q0 -62 -23 -112t-65 -85t-101 -54.5t-131 -19.5q-84 0 -146 26t-110 75l100 104q29 -27 69.5 -45.5t86.5 -18.5q26 0 49.5 7 t41.5 22.5t28.5 40.5t10.5 60v34q-23 -42 -65.5 -62t-93.5 -20zM318 150q29 0 50.5 13.5t40.5 40.5v94q-14 36 -41.5 57t-57.5 21q-20 0 -37.5 -9.5t-30.5 -25t-20 -37t-7 -45.5q0 -49 29 -79t74 -30zM396 750l-36 -61h57v-106h-157v106l54 61h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 750,
    d: "M689 710v-710h-195v278h-238v-278h-195v710h195v-262h238v262h195zM197 798l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-43.5 17.5q-9 0 -21.5 -5.5t-25 -15t-23.5 -23.5t-18 -31v-295h-190v730h190v-282q28 43 73 65.5t101 22.5q55 0 88 -19t50 -47.5t22 -61.5t5 -62v-346zM266 617l93 112h111l92 -112l-78 -40l-70 61l-69 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 756,
    d: "M692 710v-84h50v-88h-50v-538h-195v278h-238v-278h-195v538h-50v88h50v84h195v-84h238v84h195zM497 448v90h-238v-90h238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-43.5 17.5q-9 0 -21.5 -5.5t-25 -15t-23.5 -23.5t-18 -31v-295h-190v579h-30v109h30v42h190v-42h115v-109h-115v-131q28 43 73 65.5t101 22.5q55 0 88 -19t50 -47.5t22 -61.5t5 -62v-346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM222 756q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53 t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM207 572q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53 t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM4 791v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM-11 607v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM158 833q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM143 649q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 318,
    d: "M219 -215q-78 9 -115 37t-37 63q0 29 21.5 59t64.5 56h-92v710h195v-710q-35 -20 -53.5 -40.5t-18.5 -37.5t17 -27t53 -10l-35 -100v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 286,
    d: "M201 -215q-78 9 -115 37t-37 63q0 29 21.5 59t64.5 56h-87v526h190v-526q-35 -20 -53.5 -40.5t-18.5 -37.5t17 -27t53 -10zM48 570v160h190v-160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM73 764v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 815,
    d: "M61 0v710h195v-710h-195zM359 192q3 -2 13 -7t25 -10t34.5 -9t40.5 -4q31 0 50 10t29 32.5t13 58t3 86.5v361h195v-361q0 -81 -9 -147.5t-39 -113.5t-87.5 -73t-154.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 576,
    d: "M48 0v526h190v-526h-190zM48 570v160h190v-160h-190zM322 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v529h190v-514q0 -49 -15 -89.5t-42.5 -70t-65.5 -45.5t-83 -16zM338 570v160h190v-160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 498,
    d: "M42 192q3 -2 13 -7t25 -10t34.5 -9t40.5 -4q31 0 50 10t29 32.5t13 58t3 86.5v361h195v-361q0 -81 -9 -147.5t-39 -113.5t-87.5 -73t-154.5 -26q-90 0 -154 44zM169 799l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 286,
    d: "M32 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v529h190v-514q0 -49 -15 -89.5t-42.5 -70t-65.5 -45.5t-83 -16zM-38 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 690,
    d: "M61 0v710h195v-270l216 270h220l-258 -318l276 -392h-224l-176 261l-54 -56v-205h-195zM309 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 582,
    d: "M395 0l-119 192l-38 -42v-150h-190v730h190v-399l140 195h200l-181 -230l199 -296h-201zM239 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 582,
    d: "M395 0l-119 192l-38 -42v-150h-190v526h190v-195l140 195h200l-181 -230l199 -296h-201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 585,
    d: "M61 0v710h195v-540h322v-170h-517zM429 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 355,
    d: "M44 730h190v-521q0 -60 49 -60q12 0 26 4t26 11l24 -140q-34 -16 -76.5 -25t-80.5 -9q-76 0 -117 39t-41 113v588zM197 758l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 585,
    d: "M61 0v710h195v-540h322v-170h-517zM276 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 355,
    d: "M44 730h190v-521q0 -60 49 -60q12 0 26 4t26 11l24 -140q-34 -16 -76.5 -25t-80.5 -9q-76 0 -117 39t-41 113v588zM141 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 585,
    d: "M61 0v710h195v-540h322v-170h-517zM439 555l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 355,
    d: "M44 730h190v-521q0 -60 49 -60q12 0 26 4t26 11l24 -140q-34 -16 -76.5 -25t-80.5 -9q-76 0 -117 39t-41 113v588zM389 555l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 585,
    d: "M61 0v710h195v-540h322v-170h-517zM364 317v184h154v-184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 467,
    d: "M44 730h190v-521q0 -60 49 -60q12 0 26 4t26 11l24 -140q-34 -16 -76.5 -25t-80.5 -9q-76 0 -117 39t-41 113v588zM295 299v184h154v-184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 597,
    d: "M73 0v275l-47 -23l-43 101l90 44v313h195v-218l71 35l43 -101l-114 -56v-200h322v-170h-517z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 387,
    d: "M72 271l-40 -19l-43 101l83 40v337h190v-244l83 41l43 -101l-126 -62v-155q0 -60 49 -60q12 0 26 4t26 11l24 -140q-34 -16 -76.5 -25t-80.5 -9q-76 0 -117 39t-41 113v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 754,
    d: "M256 349v-349h-195v710h152l285 -361v361h195v-710h-155zM432 739l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-40.5 17.5q-24 0 -51 -21t-40 -54v-295h-190v526h171v-78q28 43 78.5 65.5t119.5 22.5q54 0 85.5 -19.5t48 -48.5t21.5 -62t5 -60v-346zM391 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 754,
    d: "M256 349v-349h-195v710h152l285 -361v361h195v-710h-155zM313 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-40.5 17.5q-24 0 -51 -21t-40 -54v-295h-190v526h171v-78q28 43 78.5 65.5t119.5 22.5q54 0 85.5 -19.5t48 -48.5t21.5 -62t5 -60v-346zM250 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 754,
    d: "M256 349v-349h-195v710h152l285 -361v361h195v-710h-155zM289 913l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-40.5 17.5q-24 0 -51 -21t-40 -54v-295h-190v526h171v-78q28 43 78.5 65.5t119.5 22.5q54 0 85.5 -19.5t48 -48.5t21.5 -62t5 -60v-346zM248 730l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-40.5 17.5q-24 0 -51 -21t-40 -54v-295h-190v526h171v-78q28 43 78.5 65.5t119.5 22.5q54 0 85.5 -19.5t48 -48.5t21.5 -62t5 -60v-346zM79 556l-120 32l31 87l-11 55h199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 735,
    d: "M256 343v-343h-195v710h150l267 -351v350h195v-704q0 -49 -15.5 -88.5t-43.5 -67.5t-65.5 -43t-81.5 -15q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 620,
    d: "M370 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q19 0 30 11.5t11 31.5v299q0 39 -17.5 56.5t-40.5 17.5q-24 0 -51 -21t-40 -54v-295h-190v526h171v-78q28 43 78.5 65.5t119.5 22.5q54 0 85.5 -19.5t48 -48.5t21 -62t4.5 -60v-334q0 -49 -15.5 -89.5t-43 -70 t-65 -45.5t-82.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM232 791v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM153 607 v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM388 833q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM307 649 q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM325 741l-90 32l40 142h139zM515 741l-90 32l40 142h139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM244 557 l-90 32l40 142h139zM434 557l-90 32l40 142h139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1030,
    d: "M1000 170v-170h-486v41q-34 -21 -72.5 -33.5t-80.5 -12.5q-76 0 -138.5 30.5t-107 81t-69 115.5t-24.5 134q0 70 25.5 135t71.5 115t108.5 79.5t137.5 29.5q42 0 79 -12t70 -33v40h477v-170h-282v-94h228v-170h-228v-106h291zM363 168q37 0 64 16.5t44 43t25.5 60 t8.5 68.5q0 36 -9 69.5t-26.5 59.5t-44.5 41.5t-63 15.5q-37 0 -63.5 -16.5t-44 -43t-26 -60t-8.5 -68.5q0 -36 8.5 -69.5t26.5 -59.5t45 -41.5t63 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 991,
    d: "M305 -10q-63 0 -115.5 20t-90.5 56.5t-59 86.5t-21 110t21 110t58.5 86.5t90 56.5t114.5 20q60 0 106.5 -20.5t87.5 -65.5q47 46 92.5 66t103.5 20q62 0 114.5 -20.5t90 -56.5t58.5 -86t21 -110q0 -15 -1.5 -30.5t-3.5 -27.5h-369q2 -36 29 -59.5t66 -23.5q32 0 59.5 16 t37.5 41l156 -46q-35 -67 -103.5 -105t-155.5 -38q-27 0 -50 4t-46 13.5t-47 25t-52 37.5q-28 -23 -51.5 -38t-46 -24.5t-45.5 -13.5t-49 -4zM307 150q42 0 67.5 31t25.5 82t-25.5 82t-67.5 31t-67.5 -31t-25.5 -82t25.5 -82t67.5 -31zM777 319q-5 38 -29 60t-61 22 q-38 0 -62 -22t-28 -60h180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 675,
    d: "M61 0v710h326q52 0 96 -21.5t75.5 -56t49.5 -79t18 -89.5q0 -62 -27 -115.5t-75 -87.5l150 -261h-220l-125 218h-73v-218h-195zM256 388h123q18 0 33.5 20t15.5 56q0 37 -18 56.5t-36 19.5h-118v-152zM377 739l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 416,
    d: "M405 364q-55 0 -100 -12t-67 -40v-312h-190v526h174v-100q28 53 69.5 81.5t89.5 28.5q19 0 24 -1v-171zM317 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 675,
    d: "M61 0v710h326q52 0 96 -21.5t75.5 -56t49.5 -79t18 -89.5q0 -62 -27 -115.5t-75 -87.5l150 -261h-220l-125 218h-73v-218h-195zM256 388h123q18 0 33.5 20t15.5 56q0 37 -18 56.5t-36 19.5h-118v-152zM293 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 416,
    d: "M405 364q-55 0 -100 -12t-67 -40v-312h-190v526h174v-100q28 53 69.5 81.5t89.5 28.5q19 0 24 -1v-171zM75 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 675,
    d: "M61 0v710h326q52 0 96 -21.5t75.5 -56t49.5 -79t18 -89.5q0 -62 -27 -115.5t-75 -87.5l150 -261h-220l-125 218h-73v-218h-195zM256 388h123q18 0 33.5 20t15.5 56q0 37 -18 56.5t-36 19.5h-118v-152zM234 913l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 416,
    d: "M405 364q-55 0 -100 -12t-67 -40v-312h-190v526h174v-100q28 53 69.5 81.5t89.5 28.5q19 0 24 -1v-171zM174 730l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 617,
    d: "M491 478q-30 18 -62 32q-27 12 -60.5 22.5t-65.5 10.5q-26 0 -41.5 -8t-15.5 -27q0 -14 9 -23t26 -16.5t41.5 -14.5t55.5 -17q49 -15 88.5 -33t67.5 -42.5t43 -59.5t15 -85q0 -64 -23.5 -107.5t-62 -69.5t-87 -37.5t-97.5 -11.5q-39 0 -80 6t-81.5 17t-78 26t-69.5 34 l84 171q35 -22 73 -39q32 -15 72.5 -27t82.5 -12q32 0 44.5 8.5t12.5 22.5q0 15 -12.5 25.5t-34.5 18.5t-50.5 16t-60.5 19q-47 16 -81 34.5t-56 42t-32.5 53.5t-10.5 69q0 59 21.5 104t58.5 75t84.5 45.5t100.5 15.5q39 0 76 -7.5t71.5 -19t64.5 -25t54 -25.5zM385 740 l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 501,
    d: "M265 -10q-69 0 -135 22.5t-112 65.5l65 114q49 -33 94.5 -51t83.5 -18q40 0 40 25q0 14 -15.5 24t-60.5 23q-56 16 -93.5 31.5t-61 33.5t-33.5 40t-10 52q0 40 16 74t44.5 59t68 38.5t86.5 13.5q58 0 110.5 -15t105.5 -61l-72 -114q-49 32 -82 45.5t-62 13.5 q-17 0 -28 -6.5t-11 -20.5q0 -15 16 -24.5t63 -21.5q57 -15 96 -31.5t62.5 -36t33.5 -44t10 -56.5q0 -41 -15 -73t-43.5 -55t-69 -35t-91.5 -12zM300 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 617,
    d: "M491 478q-30 18 -62 32q-27 12 -60.5 22.5t-65.5 10.5q-26 0 -41.5 -8t-15.5 -27q0 -14 9 -23t26 -16.5t41.5 -14.5t55.5 -17q49 -15 88.5 -33t67.5 -42.5t43 -59.5t15 -85q0 -64 -23.5 -107.5t-62 -69.5t-87 -37.5t-97.5 -11.5q-39 0 -80 6t-81.5 17t-78 26t-69.5 34 l84 171q35 -22 73 -39q32 -15 72.5 -27t82.5 -12q32 0 44.5 8.5t12.5 22.5q0 15 -12.5 25.5t-34.5 18.5t-50.5 16t-60.5 19q-47 16 -81 34.5t-56 42t-32.5 53.5t-10.5 69q0 59 21.5 104t58.5 75t84.5 45.5t100.5 15.5q39 0 76 -7.5t71.5 -19t64.5 -25t54 -25.5zM146 799 l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 501,
    d: "M265 -10q-69 0 -135 22.5t-112 65.5l65 114q49 -33 94.5 -51t83.5 -18q40 0 40 25q0 14 -15.5 24t-60.5 23q-56 16 -93.5 31.5t-61 33.5t-33.5 40t-10 52q0 40 16 74t44.5 59t68 38.5t86.5 13.5q58 0 110.5 -15t105.5 -61l-72 -114q-49 32 -82 45.5t-62 13.5 q-17 0 -28 -6.5t-11 -20.5q0 -15 16 -24.5t63 -21.5q57 -15 96 -31.5t62.5 -36t33.5 -44t10 -56.5q0 -41 -15 -73t-43.5 -55t-69 -35t-91.5 -12zM61 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 617,
    d: "M233 -128q11 -7 37 -13.5t53 -6.5q23 0 39.5 7t16.5 24t-15 23.5t-40 6.5q-21 0 -44.5 -3.5t-34.5 -5.5l42 88q-71 5 -144 26.5t-130 55.5l84 171q35 -22 73 -39q32 -15 72.5 -27t82.5 -12q32 0 44.5 8.5t12.5 22.5q0 15 -12.5 25.5t-34.5 18.5t-50.5 16t-60.5 19 q-47 16 -81 34.5t-56 42t-32.5 53.5t-10.5 69q0 59 21.5 104t58.5 75t84.5 45.5t100.5 15.5q39 0 76 -7.5t71.5 -19t64.5 -25t54 -25.5l-84 -161q-30 18 -62 32q-27 12 -60.5 22.5t-65.5 10.5q-26 0 -41.5 -8t-15.5 -27q0 -14 9 -23t26 -16.5t41.5 -14.5t55.5 -17 q49 -15 88.5 -33t67.5 -42.5t43 -59.5t15 -85q0 -58 -19.5 -99t-52 -67.5t-74 -40.5t-86.5 -17l-18 -27q6 1 12.5 1.5t14.5 0.5q18 0 35 -4.5t30 -13.5t21 -24t8 -36q0 -42 -36.5 -72.5t-115.5 -30.5q-36 0 -64.5 6.5t-48.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 501,
    d: "M160 -128q11 -7 37 -13.5t53 -6.5q23 0 39.5 7t16.5 24t-15 23.5t-40 6.5q-21 0 -44.5 -3.5t-34.5 -5.5l43 89q-57 7 -108 28.5t-89 56.5l65 114q49 -33 94.5 -51t83.5 -18q40 0 40 25q0 14 -15.5 24t-60.5 23q-56 16 -93.5 31.5t-61 33.5t-33.5 40t-10 52q0 40 16 74 t44.5 59t68 38.5t86.5 13.5q58 0 110.5 -15t105.5 -61l-72 -114q-49 32 -82 45.5t-62 13.5q-17 0 -28 -6.5t-11 -20.5q0 -15 16 -24.5t63 -21.5q57 -15 96 -31.5t62.5 -36t33.5 -44t10 -56.5q0 -77 -52.5 -123t-145.5 -51l-17 -25q6 1 12.5 1.5t14.5 0.5q18 0 35 -4.5 t30 -13.5t21 -24t8 -36q0 -42 -36.5 -72.5t-115.5 -30.5q-36 0 -64.5 6.5t-48.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 617,
    d: "M491 478q-30 18 -62 32q-27 12 -60.5 22.5t-65.5 10.5q-26 0 -41.5 -8t-15.5 -27q0 -14 9 -23t26 -16.5t41.5 -14.5t55.5 -17q49 -15 88.5 -33t67.5 -42.5t43 -59.5t15 -85q0 -64 -23.5 -107.5t-62 -69.5t-87 -37.5t-97.5 -11.5q-39 0 -80 6t-81.5 17t-78 26t-69.5 34 l84 171q35 -22 73 -39q32 -15 72.5 -27t82.5 -12q32 0 44.5 8.5t12.5 22.5q0 15 -12.5 25.5t-34.5 18.5t-50.5 16t-60.5 19q-47 16 -81 34.5t-56 42t-32.5 53.5t-10.5 69q0 59 21.5 104t58.5 75t84.5 45.5t100.5 15.5q39 0 76 -7.5t71.5 -19t64.5 -25t54 -25.5zM242 914 l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 501,
    d: "M265 -10q-69 0 -135 22.5t-112 65.5l65 114q49 -33 94.5 -51t83.5 -18q40 0 40 25q0 14 -15.5 24t-60.5 23q-56 16 -93.5 31.5t-61 33.5t-33.5 40t-10 52q0 40 16 74t44.5 59t68 38.5t86.5 13.5q58 0 110.5 -15t105.5 -61l-72 -114q-49 32 -82 45.5t-62 13.5 q-17 0 -28 -6.5t-11 -20.5q0 -15 16 -24.5t63 -21.5q57 -15 96 -31.5t62.5 -36t33.5 -44t10 -56.5q0 -41 -15 -73t-43.5 -55t-69 -35t-91.5 -12zM157 730l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 624,
    d: "M219 -128q11 -7 37 -13.5t53 -6.5q23 0 39.5 7t16.5 24t-15 23.5t-40 6.5q-21 0 -44.5 -3.5t-34.5 -5.5l46 96h-62v540h-205v170h604v-170h-204v-540h-58l-24 -34q6 1 12.5 1.5t14.5 0.5q18 0 35 -4.5t30 -13.5t21 -24t8 -36q0 -42 -36.5 -72.5t-115.5 -30.5 q-36 0 -64.5 6.5t-48.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 423,
    d: "M160 -128q11 -7 37 -13.5t53 -6.5q23 0 39.5 7t16.5 24t-15 23.5t-40 6.5q-21 0 -44.5 -3.5t-34.5 -5.5l42 87q-27 3 -51 12.5t-41.5 27.5t-27.5 45.5t-10 65.5v241h-65v143h65v165h190v-165h103v-143h-103v-174q0 -26 11 -36.5t30 -10.5q14 0 32 4.5t36 12.5l34 -150 q-30 -13 -63 -22.5t-67 -14.5l-18 -26q6 1 12.5 1.5t14.5 0.5q18 0 35 -4.5t30 -13.5t21 -24t8 -36q0 -42 -36.5 -72.5t-115.5 -30.5q-36 0 -64.5 6.5t-48.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 624,
    d: "M614 540h-204v-540h-195v540h-205v170h604v-170zM235 914l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 423,
    d: "M417 29q-40 -17 -85.5 -28.5t-89.5 -11.5q-32 0 -61 8t-50.5 26t-34 47t-12.5 72v241h-65v143h65v165h190v-165h103v-143h-103v-174q0 -26 11 -36.5t30 -10.5q14 0 32 4.5t36 12.5zM424 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 646,
    d: "M625 540h-204v-184h164v-88h-164v-268h-195v268h-165v88h165v184h-205v170h604v-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 424,
    d: "M418 29q-40 -17 -85.5 -28.5t-89.5 -11.5q-32 0 -61 8t-50.5 26t-34 47t-12.5 72v85h-65v109h65v47h-65v143h65v165h190v-165h103v-143h-103v-47h103v-109h-103v-18q0 -26 11 -36.5t30 -10.5q14 0 32 4.5t36 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM435 756q-23 0 -40.5 7.5t-32.5 16.5 t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM372 572q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5 t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM217 791v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM154 607v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM371 833q23 0 40.5 23t20.5 58h98 q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM308 649q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5 t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM254 827q0 44 31.5 65.5t85.5 21.5t85.5 -21.5 t31.5 -65.5t-31.5 -65.5t-85.5 -21.5t-85.5 21.5t-31.5 65.5zM371 860q-17 0 -28.5 -9t-11.5 -23q0 -15 11.5 -24.5t28.5 -9.5t28.5 9.5t11.5 24.5q0 14 -11.5 23t-28.5 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM191 643q0 44 31.5 65.5t85.5 21.5t85.5 -21.5t31.5 -65.5 t-31.5 -65.5t-85.5 -21.5t-85.5 21.5t-31.5 65.5zM308 676q-17 0 -28.5 -9t-11.5 -23q0 -15 11.5 -24.5t28.5 -9.5t28.5 9.5t11.5 24.5q0 14 -11.5 23t-28.5 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM308 741l-90 32l40 142h139zM498 741l-90 32 l40 142h139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM245 557l-90 32l40 142h139zM435 557l-90 32l40 142h139z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 743,
    d: "M385 -214q-78 9 -115 37t-37 63q0 29 20 57.5t60 54.5q-69 9 -119 40.5t-81.5 78t-46.5 105.5t-15 123v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5t58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -69 -16.5 -130t-51 -107.5t-87 -75.5t-124.5 -36 q-30 -19 -46.5 -37.5t-16.5 -35.5t17 -27t53 -10l-35 -100v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 639,
    d: "M572 -215q-78 9 -115 37t-37 63q0 27 18.5 55t55.5 53q-65 11 -77 70l-4 19q-37 -49 -88 -70.5t-117 -21.5q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-35 -20 -53.5 -40.5 t-18.5 -37.5t17 -27t53 -10l-35 -100v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1057,
    d: "M287 710h179l62 -219l63 219h179l-117 -339l51 -148l153 487h212l-278 -710h-162l-101 254l-100 -254h-162l-278 710h211l154 -487l49 148zM347 799l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 862,
    d: "M693 526h179l-215 -526h-155l-71 200l-71 -200h-155l-215 526h179l127 -353l33 113l-94 240h151l45 -154l45 154h151l-94 -240l33 -113zM250 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 666,
    d: "M205 710l127 -307l130 307h212l-245 -475v-235h-194v237l-241 473h211zM151 799l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 555,
    d: "M44 -53q46 -17 78 -17q61 0 67 70l-191 526h195l100 -365l81 365h177l-178 -589q-12 -39 -34 -70.5t-52.5 -54t-67.5 -34.5t-77 -12q-51 0 -98 19v162zM112 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 666,
    d: "M205 710l127 -307l130 307h212l-245 -475v-235h-194v237l-241 473h211zM139 765v140h156v-140h-156zM369 765v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 622,
    d: "M27 145l332 395h-317v170h542v-145l-312 -395h318v-170h-563v145zM378 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 494,
    d: "M22 112l240 284h-225v130h423v-112l-239 -284h248v-130h-447v112zM301 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 622,
    d: "M27 145l332 395h-317v170h542v-145l-312 -395h318v-170h-563v145zM235 764v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 494,
    d: "M22 112l240 284h-225v130h423v-112l-239 -284h248v-130h-447v112zM158 580v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 622,
    d: "M27 145l332 395h-317v170h542v-145l-312 -395h318v-170h-563v145zM235 914l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 494,
    d: "M22 112l240 284h-225v130h423v-112l-239 -284h248v-130h-447v112zM158 730l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 758,
    d: "M375 -5q-89 0 -157 32.5t-113.5 83t-69 111t-23.5 116.5q0 19 2 38.5t4 34.5h505q-3 35 -16.5 60t-33.5 41t-45 23.5t-51 7.5q-21 0 -41.5 -5.5t-38 -15.5t-30.5 -24.5t-19 -33.5l-203 57q20 43 51.5 79t73.5 61t93.5 39t111.5 14q87 0 154.5 -32.5t113 -83t69.5 -112 t24 -120.5q0 -67 -23 -133.5t-69 -119t-113.5 -85.5t-155.5 -33zM378 165q57 0 94.5 27t45.5 76h-290q9 -49 49.5 -76t100.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 565,
    d: "M177 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v325h-65v143h65v57q0 49 14 89.5t39 69t60.5 44t79.5 15.5q66 0 146 -30l-32 -144q-17 6 -36.5 10t-34.5 4q-46 0 -46 -51v-64h115v-143h-115v-320q0 -47 -15.5 -86t-43 -66.5t-65.5 -43t-82 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1338,
    d: "M61 0v710h273q88 0 155 -28t112 -76t68 -112.5t23 -137.5q0 -81 -25.5 -146.5t-72.5 -112t-113 -72t-147 -25.5h-273zM494 356q0 41 -11 75t-31.5 58t-50.5 37.5t-67 13.5h-78v-370h78q38 0 68 14t50.5 39t31 59t10.5 74zM743 145l332 395h-317v170h542v-145l-312 -395 h318v-170h-563v145zM951 914l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1210,
    d: "M61 0v710h273q88 0 155 -28t112 -76t68 -112.5t23 -137.5q0 -81 -25.5 -146.5t-72.5 -112t-113 -72t-147 -25.5h-273zM494 356q0 41 -11 75t-31.5 58t-50.5 37.5t-67 13.5h-78v-370h78q38 0 68 14t50.5 39t31 59t10.5 74zM738 112l240 284h-225v130h423v-112l-239 -284 h248v-130h-447v112zM874 730l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1159,
    d: "M268 -10q-54 0 -99.5 20t-78.5 56.5t-51.5 87t-18.5 110.5q0 58 17 108t47.5 86.5t72.5 57t93 20.5t93.5 -23t65.5 -65v282h190v-520q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-27 -48 -73 -70t-98 -22zM320 150q52 0 90 54v94q-14 35 -41 56.5 t-57 21.5q-21 0 -38.5 -9t-30 -25t-20 -37t-7.5 -45q0 -50 28.5 -80t75.5 -30zM687 112l240 284h-225v130h423v-112l-239 -284h248v-130h-447v112zM823 730l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1083,
    d: "M61 0v710h195v-540h322v-170h-517zM627 192q3 -2 13 -7t25 -10t34.5 -9t40.5 -4q31 0 50 10t29 32.5t13 58t3 86.5v361h195v-361q0 -81 -9 -147.5t-39 -113.5t-87.5 -73t-154.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 875,
    d: "M61 0v710h195v-540h322v-170h-517zM621 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v529h190v-514q0 -49 -15 -89.5t-42.5 -70t-65.5 -45.5t-83 -16zM637 570v160h190v-160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 645,
    d: "M44 730h190v-521q0 -60 49 -60q12 0 26 4t26 11l24 -140q-34 -16 -76.5 -25t-80.5 -9q-76 0 -117 39t-41 113v588zM391 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v529h190v-514q0 -49 -15 -89.5t-42.5 -70t-65.5 -45.5t-83 -16zM407 570v160h190v-160 h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1252,
    d: "M256 349v-349h-195v710h152l285 -361v361h195v-710h-155zM796 192q3 -2 13 -7t25 -10t34.5 -9t40.5 -4q31 0 50 10t29 32.5t13 58t3 86.5v361h195v-361q0 -81 -9 -147.5t-39 -113.5t-87.5 -73t-154.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 1044,
    d: "M256 349v-349h-195v710h152l285 -361v361h195v-710h-155zM790 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v529h190v-514q0 -49 -15 -89.5t-42.5 -70t-65.5 -45.5t-83 -16zM806 570v160h190v-160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 911,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-40.5 17.5q-24 0 -51 -21t-40 -54v-295h-190v526h171v-78q28 43 78.5 65.5t119.5 22.5q54 0 85.5 -19.5t48 -48.5t21.5 -62t5 -60v-346zM657 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v529h190v-514q0 -49 -15 -89.5 t-42.5 -70t-65.5 -45.5t-83 -16zM673 570v160h190v-160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 765,
    d: "M388 -214q-78 9 -115 37t-37 63q0 29 20.5 58t61.5 55q-68 11 -122.5 45t-93 83t-59.5 108t-21 121q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -66 -24 -127.5t-67 -110t-103.5 -80t-132.5 -38.5q-30 -19 -46.5 -37.5 t-16.5 -35.5t17 -27t53 -10zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 614,
    d: "M357 -214q-78 9 -115 37t-37 63q0 26 18 53.5t53 52.5q-63 5 -111 29t-80.5 60.5t-49 83.5t-16.5 98q0 54 18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -45 -13 -87.5t-38.5 -77t-63.5 -60.5t-88 -38q-70 -40 -70 -77q0 -17 17 -27 t53 -10zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1329,
    d: "M61 0v710h273q88 0 155 -28t112 -76t68 -112.5t23 -137.5q0 -81 -25.5 -146.5t-72.5 -112t-113 -72t-147 -25.5h-273zM494 356q0 41 -11 75t-31.5 58t-50.5 37.5t-67 13.5h-78v-370h78q38 0 68 14t50.5 39t31 59t10.5 74zM734 145l332 395h-317v170h542v-145l-312 -395 h318v-170h-563v145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1204,
    d: "M61 0v710h273q88 0 155 -28t112 -76t68 -112.5t23 -137.5q0 -81 -25.5 -146.5t-72.5 -112t-113 -72t-147 -25.5h-273zM494 356q0 41 -11 75t-31.5 58t-50.5 37.5t-67 13.5h-78v-370h78q38 0 68 14t50.5 39t31 59t10.5 74zM732 112l240 284h-225v130h423v-112l-239 -284 h248v-130h-447v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1159,
    d: "M268 -10q-54 0 -99.5 20t-78.5 56.5t-51.5 87t-18.5 110.5q0 58 17 108t47.5 86.5t72.5 57t93 20.5t93.5 -23t65.5 -65v282h190v-520q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-27 -48 -73 -70t-98 -22zM320 150q52 0 90 54v94q-14 35 -41 56.5 t-57 21.5q-21 0 -38.5 -9t-30 -25t-20 -37t-7.5 -45q0 -50 28.5 -80t75.5 -30zM687 112l240 284h-225v130h423v-112l-239 -284h248v-130h-447v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 739,
    d: "M543 59q-76 -64 -175 -64q-69 0 -132 24.5t-110 71.5t-75 115t-28 155q0 75 28 139.5t77 112t115.5 75t143.5 27.5q48 0 92 -10.5t81.5 -31t67.5 -49t49 -64.5l-145 -111q-21 42 -63 67.5t-89 25.5q-35 0 -64 -14t-50 -39t-33 -59.5t-12 -75.5q0 -42 12 -76t33.5 -58.5 t51.5 -38t67 -13.5q85 0 150 70h-123v140h292v-378h-161v59zM448 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 647,
    d: "M250 0q-51 0 -93.5 20.5t-72.5 56t-46.5 83.5t-16.5 104q0 59 18 109t50.5 86t77.5 56.5t99 20.5q57 0 100 -22.5t68 -65.5v78h165v-478q0 -62 -23 -112t-65 -85t-101 -54.5t-131 -19.5q-84 0 -146 26t-110 75l100 104q29 -27 69.5 -45.5t86.5 -18.5q26 0 49.5 7 t41.5 22.5t28.5 40.5t10.5 60v34q-23 -42 -65.5 -62t-93.5 -20zM318 150q29 0 50.5 13.5t40.5 40.5v94q-14 36 -41.5 57t-57.5 21q-20 0 -37.5 -9.5t-30.5 -25t-20 -37t-7 -45.5q0 -49 29 -79t74 -30zM379 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 667,
    d: "M419 808q32 -22 32 -65q0 -35 -21 -56l239 -687h-198l-43 139h-189l-42 -139h-199l239 688q-20 22 -20 55q0 32 17 52t49 29l38 94h169zM397 269l-63 220l-66 -220h129zM334 776q-17 0 -28.5 -9t-11.5 -23q0 -15 11.5 -24.5t28.5 -9.5t28.5 9.5t11.5 24.5q0 14 -11.5 23 t-28.5 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM163 643q0 44 31.5 65.5t85.5 21.5t85.5 -21.5t31.5 -65.5 t-31.5 -65.5t-85.5 -21.5t-85.5 21.5t-31.5 65.5zM280 676q-17 0 -28.5 -9t-11.5 -23q0 -15 11.5 -24.5t28.5 -9.5t28.5 9.5t11.5 24.5q0 14 -11.5 23t-28.5 9zM338 744l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 971,
    d: "M405 710h527v-170h-282v-94h228v-170h-228v-106h291v-170h-485v139h-201l-75 -139h-206zM441 309v186l-104 -186h104zM683 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 942,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q-1 37 -22 55t-69 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q117 0 185 -50q34 23 77.5 36.5t97.5 13.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5 q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40q-80 0 -138.5 28t-94.5 74q-19 -27 -44 -46.5t-52 -31.5t-55 -18t-53 -6zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10 t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM724 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM523 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 763,
    d: "M745 710l-90 -123q42 -50 64.5 -111t22.5 -124q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30q-74 0 -137 26l-14 -20h-209l87 120q-42 50 -64 110.5t-22 125.5q0 70 27 135t75.5 114.5t115 79t145.5 29.5q37 0 70.5 -7t64.5 -19l16 22h210zM439 740l-120 32 l50 142h169zM219 354q0 -36 9 -67l183 251q-15 3 -30 3q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM544 356q0 35 -9 65l-183 -252q7 -1 14.5 -1.5t15.5 -0.5q42 0 73 16.5t50.5 43t29 60.5t9.5 69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 614,
    d: "M365 556l-120 32l50 142h169zM14 -6l74 83q-35 38 -52 85.5t-17 100.5q0 54 18.5 103.5t55 87t90 60t124.5 22.5q46 0 84 -9.5t70 -26.5l29 32h101l-70 -78q37 -38 55.5 -87.5t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5q-48 0 -88.5 10.5t-72.5 29.5 l-32 -36h-100zM307 150q41 0 67 30t26 83q0 28 -8 50l-133 -150q20 -13 48 -13zM214 263q0 -12 1.5 -22.5t3.5 -20.5l130 146q-22 10 -42 10q-41 0 -67 -30t-26 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM323 915h139l40 -142l-90 -32zM133 915h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM255 730h139l40 -142l-90 -32zM65 730h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129zM334 833q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    horizAdvX: 599,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14zM294 649q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51 t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM290 915h139l40 -142l-90 -32zM100 915h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM295 730h139l40 -142l-90 -32zM105 730h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM313 833q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM311 649q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM148 915h139l40 -142l-90 -32zM-42 915h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM135 730h139l40 -142l-90 -32zM-55 730h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM159 833q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM143 649q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM364 915h139l40 -142l-90 -32zM174 915h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM295 730 h139l40 -142l-90 -32zM105 730h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM384 833q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83zM307 649 q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 675,
    d: "M61 0v710h326q52 0 96 -21.5t75.5 -56t49.5 -79t18 -89.5q0 -62 -27 -115.5t-75 -87.5l150 -261h-220l-125 218h-73v-218h-195zM256 388h123q18 0 33.5 20t15.5 56q0 37 -18 56.5t-36 19.5h-118v-152zM295 915h139l40 -142l-90 -32zM105 915h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 416,
    d: "M405 364q-55 0 -100 -12t-67 -40v-312h-190v526h174v-100q28 53 69.5 81.5t89.5 28.5q19 0 24 -1v-171zM215 730h139l40 -142l-90 -32zM25 730h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 675,
    d: "M61 0v710h326q52 0 96 -21.5t75.5 -56t49.5 -79t18 -89.5q0 -62 -27 -115.5t-75 -87.5l150 -261h-220l-125 218h-73v-218h-195zM256 388h123q18 0 33.5 20t15.5 56q0 37 -18 56.5t-36 19.5h-118v-152zM322 833q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51 t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 416,
    d: "M405 364q-55 0 -100 -12t-67 -40v-312h-190v526h174v-100q28 53 69.5 81.5t89.5 28.5q19 0 24 -1v-171zM223 649q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM356 915h139l40 -142l-90 -32zM166 915h139 l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM299 730h139l40 -142l-90 -32zM109 730h139l40 -142 l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM371 833q-25 0 -43 -24t-18 -57h-98 q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM305 649q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5 t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 617,
    d: "M491 478q-30 18 -62 32q-27 12 -60.5 22.5t-65.5 10.5q-26 0 -41.5 -8t-15.5 -27q0 -14 9 -23t26 -16.5t41.5 -14.5t55.5 -17q49 -15 88.5 -33t67.5 -42.5t43 -59.5t15 -85q0 -64 -23.5 -107.5t-62 -69.5t-87 -37.5t-97.5 -11.5q-39 0 -80 6t-81.5 17t-78 26t-69.5 34 l84 171q35 -22 73 -39q32 -15 72.5 -27t82.5 -12q32 0 44.5 8.5t12.5 22.5q0 15 -12.5 25.5t-34.5 18.5t-50.5 16t-60.5 19q-47 16 -81 34.5t-56 42t-32.5 53.5t-10.5 69q0 59 21.5 104t58.5 75t84.5 45.5t100.5 15.5q39 0 76 -7.5t71.5 -19t64.5 -25t54 -25.5zM266 -213 l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 501,
    d: "M265 -10q-69 0 -135 22.5t-112 65.5l65 114q49 -33 94.5 -51t83.5 -18q40 0 40 25q0 14 -15.5 24t-60.5 23q-56 16 -93.5 31.5t-61 33.5t-33.5 40t-10 52q0 40 16 74t44.5 59t68 38.5t86.5 13.5q58 0 110.5 -15t105.5 -61l-72 -114q-49 32 -82 45.5t-62 13.5 q-17 0 -28 -6.5t-11 -20.5q0 -15 16 -24.5t63 -21.5q57 -15 96 -31.5t62.5 -36t33.5 -44t10 -56.5q0 -41 -15 -73t-43.5 -55t-69 -35t-91.5 -12zM204 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 624,
    d: "M614 540h-204v-540h-195v540h-205v170h604v-170zM259 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 423,
    d: "M417 29q-40 -17 -85.5 -28.5t-89.5 -11.5q-32 0 -61 8t-50.5 26t-34 47t-12.5 72v241h-65v143h65v165h190v-165h103v-143h-103v-174q0 -26 11 -36.5t30 -10.5q14 0 32 4.5t36 12.5zM181 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 286,
    d: "M32 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v529h190v-514q0 -49 -15 -89.5t-42.5 -70t-65.5 -45.5t-83 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    d: "M302 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5q0 15 1.5 30.5t3.5 27.5h369q-3 42 -31 60.5t-61 18.5q-31 0 -58.5 -14t-36.5 -39l-161 46q32 63 98.5 103t163.5 40q69 0 123 -21.5t90.5 -58.5t55.5 -85t19 -101q0 -57 -18.5 -108t-55 -89t-90.5 -60.5 t-124 -22.5zM305 125q36 0 59 22t28 60h-174q5 -38 28 -60t59 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 518,
    d: "M280 556l-120 32l31 87l-11 55h199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 402,
    d: "M20 615l113 115h136l113 -115l-96 -42l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 402,
    d: "M116 730l85 -63l85 63l96 -42l-113 -115h-136l-113 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 438,
    d: "M64 607v113h310v-113h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 368,
    d: "M184 649q23 0 40.5 23t20.5 58h98q0 -36 -11.5 -65.5t-32.5 -51t-50.5 -33.5t-64.5 -12t-64.5 12t-50.5 33.5t-32.5 51t-11.5 65.5h98q0 -33 18 -57t43 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 270,
    d: "M50 580v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 274,
    d: "M20 643q0 44 31.5 65.5t85.5 21.5t85.5 -21.5t31.5 -65.5t-31.5 -65.5t-85.5 -21.5t-85.5 21.5t-31.5 65.5zM137 676q-17 0 -28.5 -9t-11.5 -23q0 -15 11.5 -24.5t28.5 -9.5t28.5 9.5t11.5 24.5q0 14 -11.5 23t-28.5 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 332,
    d: "M226 -214q-78 9 -115 37t-37 63q0 36 33.5 73t99.5 66l56 -24q-35 -20 -53.5 -40.5t-18.5 -37.5t17 -27t53 -10l-35 -100v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 464,
    d: "M301 572q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 399,
    d: "M115 556l-90 32l40 142h139zM305 556l-90 32l40 142h139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 399,
    d: "M195 730h139l40 -142l-90 -32zM5 730h139l40 -142l-90 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 368,
    d: "M184 649q-25 0 -43 -24t-18 -57h-98q0 36 11.5 65.5t32.5 51t50.5 33.5t64.5 12t64.5 -12t50.5 -33.5t32.5 -51t11.5 -65.5h-98q-3 35 -20.5 58t-40.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 659,
    d: "M645 150v-150h-631v150l237 560h158zM463 170l-133 327l-127 -327h260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 792,
    d: "M30 129h149q-65 38 -102 101.5t-37 144.5q0 67 27 128.5t74.5 108.5t112.5 75t142 28q76 0 141.5 -28t113 -75t74.5 -108.5t27 -128.5q0 -81 -37 -144.5t-102 -101.5h149v-129h-329v129q30 13 53.5 38.5t40 58.5t25.5 71.5t9 77.5q0 31 -11.5 61t-32.5 54t-51.5 38.5 t-69.5 14.5t-69.5 -14.5t-51.5 -38.5t-32.5 -54t-11.5 -61q0 -39 9 -77.5t25.5 -71.5t40 -58.5t53.5 -38.5v-129h-329v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 653,
    d: "M49 526h190v-303q0 -35 15 -54t47 -19q18 0 41 10t46 44v322h190v-316q0 -27 10 -37.5t36 -12.5v-160q-29 -5 -51 -7.5t-39 -2.5q-97 0 -112 73l-4 19q-6 -15 -20.5 -31.5t-33.5 -30t-40 -22.5t-40 -9q-17 0 -32 8.5t-25 28.5v-239h-178v739z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 682,
    d: "M286 362v-362h-189v362h-70v160h599v-160h-80v-153q0 -60 49 -60q12 0 26 4t26 11l24 -140q-34 -16 -76.5 -25t-80.5 -9q-76 0 -117 39t-41 113v220h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0400",
    unicode: "\u0400",
    horizAdvX: 601,
    d: "M571 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM163 915h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0401",
    unicode: "\u0401",
    horizAdvX: 601,
    d: "M571 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM127 765v140h156v-140h-156zM357 765v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 764,
    d: "M131 545h-121v165h584v-165h-273v-130q34 26 77.5 40t92.5 14q63 0 112.5 -17.5t84.5 -49t53.5 -75.5t18.5 -97q0 -113 -68.5 -176.5t-191.5 -63.5q-69 0 -134 22l51 157q14 -8 31 -13t34 -5t33 4t28 13.5t19.5 24.5t7.5 37q0 37 -25.5 58t-65.5 21q-86 0 -158 -62v-247 h-190v545z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 535,
    d: "M341 740l-120 32l50 142h169zM528 540h-268v-540h-195v710h463v-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 694,
    d: "M683 159q-16 -39 -48.5 -70t-74 -52t-89 -32t-92.5 -11q-79 0 -144.5 31.5t-113 83.5t-73.5 118t-26 134q0 65 24.5 128t71.5 113t114 81t153 31q103 0 178.5 -42.5t112.5 -112.5l-149 -106q-10 26 -26.5 43t-36.5 27t-41.5 14t-41.5 4q-57 0 -93 -29.5t-53 -71.5h202 v-155h-207q17 -51 56 -84.5t97 -33.5q20 0 41 4.5t40.5 15t35 27t24.5 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0405",
    unicode: "\u0405",
    horizAdvX: 617,
    d: "M491 478q-30 18 -62 32q-27 12 -60.5 22.5t-65.5 10.5q-26 0 -41.5 -8t-15.5 -27q0 -14 9 -23t26 -16.5t41.5 -14.5t55.5 -17q49 -15 88.5 -33t67.5 -42.5t43 -59.5t15 -85q0 -64 -23.5 -107.5t-62 -69.5t-87 -37.5t-97.5 -11.5q-39 0 -80 6t-81.5 17t-78 26t-69.5 34 l84 171q35 -22 73 -39q32 -15 72.5 -27t82.5 -12q32 0 44.5 8.5t12.5 22.5q0 15 -12.5 25.5t-34.5 18.5t-50.5 16t-60.5 19q-47 16 -81 34.5t-56 42t-32.5 53.5t-10.5 69q0 59 21.5 104t58.5 75t84.5 45.5t100.5 15.5q39 0 76 -7.5t71.5 -19t64.5 -25t54 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0406",
    unicode: "\u0406",
    horizAdvX: 325,
    d: "M65 0v710h195v-710h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0407",
    unicode: "\u0407",
    horizAdvX: 325,
    d: "M65 0v710h195v-710h-195zM-31 765v140h156v-140h-156zM199 765v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0408",
    unicode: "\u0408",
    horizAdvX: 501,
    d: "M42 192q3 -2 13 -7t25 -10t34.5 -9t40.5 -4q31 0 50 10t29 32.5t13 58t3 86.5v361h195v-361q0 -81 -9 -147.5t-39 -113.5t-87.5 -73t-154.5 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 1096,
    d: "M13 161q38 4 62 17t39 48t25 100.5t20 175.5l19 208h496v-255h146q60 0 107.5 -15.5t81 -44.5t51.5 -70t18 -93q0 -54 -17 -97t-49 -73t-78 -46t-104 -16h-351v540h-126l-9 -96q-13 -135 -33 -222t-56.5 -138t-94.5 -71t-147 -20v168zM802 164q38 0 57.5 19t19.5 51 q0 28 -19.5 48.5t-57.5 20.5h-128v-139h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 1115,
    d: "M65 710h195v-262h238v262h195v-255h146q60 0 107.5 -15.5t81 -44.5t51.5 -70t18 -93q0 -54 -17 -97t-49 -73t-78 -46t-104 -16h-351v278h-238v-278h-195v710zM821 164q38 0 57.5 12.5t19.5 47.5q0 59 -77 59h-128v-119h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 754,
    d: "M534 135q0 72 -25 111t-85 39q-58 0 -103 -28v-257h-190v545h-121v165h564v-165h-253v-105q61 26 156 26q114 0 181 -59.5t67 -187.5v-219h-191v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 690,
    d: "M406 740l-120 32l50 142h169zM259 439h15l196 271h220l-257 -343l280 -367h-217l-205 262h-32v-262h-194v710h194v-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 769,
    d: "M261 915h169l50 -142l-120 -32zM260 304l302 406h142v-710h-195v394l-299 -394h-145v710h195v-406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 651,
    d: "M218 -7q-12 0 -28 2t-34 7t-35 12.5t-30 18.5l41 159q1 -2 7 -7t15 -10t20 -9t24 -4q22 0 37 11t19 31l-263 506h215l135 -317l124 317h205l-250 -540q-22 -48 -42.5 -81.5t-44 -54.5t-51 -31t-64.5 -10zM336 754q-47 0 -85 12t-66 33.5t-43 51t-15 65.5h118 q0 -26 27.5 -43.5t63.5 -17.5q35 0 60.5 17.5t30.5 43.5h118q0 -36 -15 -65.5t-43 -51t-66.5 -33.5t-84.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 727,
    d: "M64 710h195v-540h209v540h195v-710h-210v-166h-180v166h-209v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0410",
    unicode: "\u0410",
    horizAdvX: 667,
    d: "M245 710h178l246 -710h-198l-43 139h-189l-42 -139h-199zM397 269l-63 220l-66 -220h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 681,
    d: "M65 710h543v-170h-348v-105h146q128 0 193 -56.5t65 -156.5q0 -104 -62 -163t-186 -59h-351v710zM388 164q38 0 57.5 16t19.5 44q0 24 -19.5 41.5t-57.5 17.5h-128v-119h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0412",
    unicode: "\u0412",
    horizAdvX: 694,
    d: "M669 182q0 -48 -20 -82.5t-55 -56.5t-81.5 -32.5t-98.5 -10.5h-349v710h412q37 0 67 -16t51 -41.5t32.5 -58t11.5 -66.5q0 -50 -25.5 -95.5t-76.5 -68.5q61 -18 96.5 -62.5t35.5 -119.5zM471 222q0 26 -14 43.5t-36 17.5h-161v-119h154q24 0 40.5 15t16.5 43zM260 544 v-109h133q20 0 36.5 11t16.5 44q0 29 -14 41.5t-33 12.5h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 535,
    d: "M528 540h-268v-540h-195v710h463v-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 808,
    d: "M16 170h44q25 0 42.5 17.5t30.5 56.5t22 102.5t18 155.5l19 208h496v-540h100v-336h-190v166h-392v-166h-190v336zM493 170v370h-126l-9 -96q-8 -90 -22.5 -157t-34.5 -117h192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0415",
    unicode: "\u0415",
    horizAdvX: 601,
    d: "M571 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 1057,
    d: "M257 367l-257 343h220l196 -271h15v271h195v-271h15l196 271h220l-257 -343l280 -367h-217l-205 262h-32v-262h-195v262h-32l-205 -262h-217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 586,
    d: "M23 610q54 52 120.5 79.5t155.5 27.5q54 0 97.5 -12t74.5 -35.5t48 -59t17 -81.5q0 -23 -4.5 -45.5t-16.5 -43t-32.5 -38t-51.5 -29.5q66 -19 98 -64.5t32 -107.5q0 -51 -20.5 -90t-57 -65t-86 -39t-107.5 -13q-84 0 -148.5 21.5t-129.5 69.5l89 149q38 -30 80 -48 t97 -18q37 0 61 17t24 55q0 13 -4 26t-14 23t-26 16t-41 6h-99v128h82q50 0 73 16t23 45q0 25 -15.5 40t-57.5 15q-48 0 -86.5 -17t-76.5 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 769,
    d: "M260 304l302 406h142v-710h-195v394l-299 -394h-145v710h195v-406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 769,
    d: "M610 916q0 -36 -15 -65.5t-43 -51t-66.5 -33.5t-84.5 -12q-47 0 -85 12t-66 33.5t-43 51t-15 65.5h118q0 -26 27.5 -43.5t63.5 -17.5q35 0 60.5 17.5t30.5 43.5h118zM260 304l302 406h142v-710h-195v394l-299 -394h-145v710h195v-406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041A",
    unicode: "\u041A",
    horizAdvX: 690,
    d: "M259 439h15l196 271h220l-257 -343l280 -367h-217l-205 262h-32v-262h-194v710h194v-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 738,
    d: "M344 444q-13 -135 -33 -222t-56.5 -138t-94.5 -71t-147 -20v168q38 4 62 17t39 48t25 100.5t20 175.5l19 208h496v-710h-195v540h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041C",
    unicode: "\u041C",
    horizAdvX: 862,
    d: "M602 0v374l-119 -263h-104l-119 263v-374h-195v710h213l153 -334l154 334h212v-710h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041D",
    unicode: "\u041D",
    horizAdvX: 758,
    d: "M693 710v-710h-195v278h-238v-278h-195v710h195v-262h238v262h195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041E",
    unicode: "\u041E",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 739,
    d: "M65 710h609v-710h-195v540h-219v-540h-195v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0420",
    unicode: "\u0420",
    horizAdvX: 627,
    d: "M65 0v710h306q52 0 96 -21.5t75.5 -56t49.5 -79t18 -89.5q0 -47 -17 -91.5t-47.5 -79t-74 -55t-95.5 -20.5h-116v-218h-195zM260 388h103q18 0 33.5 16.5t15.5 59.5q0 44 -18 60t-36 16h-98v-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0421",
    unicode: "\u0421",
    horizAdvX: 691,
    d: "M22 361q0 65 24.5 128t71.5 113t114 81t153 31q103 0 178.5 -42.5t112.5 -112.5l-149 -106q-10 26 -26.5 43t-36.5 27t-41.5 14t-41.5 4q-42 0 -72.5 -16.5t-50 -43t-29 -60t-9.5 -66.5q0 -37 11 -71t32 -60t51.5 -41.5t68.5 -15.5q20 0 41 4.5t40.5 15t35 27t24.5 40.5 l159 -95q-16 -39 -48.5 -70t-74 -52t-89 -32t-92.5 -11q-79 0 -144.5 31.5t-113 83.5t-73.5 118t-26 134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0422",
    unicode: "\u0422",
    horizAdvX: 624,
    d: "M614 540h-204v-540h-195v540h-205v170h604v-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 651,
    d: "M218 -7q-12 0 -28 2t-34 7t-35 12.5t-30 18.5l41 159q1 -2 7 -7t15 -10t20 -9t24 -4q22 0 37 11t19 31l-263 506h215l135 -317l124 317h205l-250 -540q-22 -48 -42.5 -81.5t-44 -54.5t-51 -31t-64.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 828,
    d: "M322 52q-80 10 -137.5 37t-95 68t-55.5 94t-18 115q0 59 17 111.5t53.5 94t94.5 70t141 39.5v99h184v-99q82 -11 140 -39.5t95 -70t54 -94t17 -111.5q0 -62 -18 -114.5t-55.5 -93t-95.5 -68t-137 -37.5v-83h-184v82zM506 232q67 14 93 49t26 86q0 54 -26.5 87t-92.5 47 v-269zM322 501q-66 -14 -93 -47t-27 -87q0 -51 26.5 -86t93.5 -49v269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0425",
    unicode: "\u0425",
    horizAdvX: 657,
    d: "M200 710l129 -224l129 224h210l-237 -360l229 -350h-210l-121 214l-121 -214h-211l229 350l-237 360h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 774,
    d: "M564 0h-499v710h195v-540h199v540h195v-540h100v-336h-190v166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 659,
    d: "M404 710h190v-710h-190v250q-28 -13 -60.5 -19.5t-85.5 -6.5q-63 0 -106.5 18.5t-70.5 51.5t-39 77.5t-12 96.5v242h190v-178q0 -62 24.5 -95.5t84.5 -33.5q44 0 75 14v293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 1033,
    d: "M968 710v-710h-903v710h195v-540h159v540h195v-540h159v540h195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 1088,
    d: "M878 0h-813v710h195v-540h159v540h195v-540h159v540h195v-540h100v-336h-190v166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 772,
    d: "M8 710h371v-235h116q60 0 107.5 -16t81 -46.5t51.5 -73.5t18 -97q0 -113 -66 -177.5t-182 -64.5h-321v550h-176v160zM379 164h98q38 0 57.5 21.5t19.5 58.5q0 32 -19.5 55.5t-57.5 23.5h-98v-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 985,
    d: "M65 710h195v-235h116q60 0 107.5 -16t81 -46.5t51.5 -73.5t18 -97q0 -113 -66 -177.5t-182 -64.5h-321v710zM725 0v710h195v-710h-195zM260 164h98q38 0 57.5 21.5t19.5 58.5q0 32 -19.5 55.5t-57.5 23.5h-98v-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 653,
    d: "M65 710h195v-235h116q60 0 107.5 -16t81 -46.5t51.5 -73.5t18 -97q0 -113 -66 -177.5t-182 -64.5h-321v710zM260 164h98q38 0 57.5 21.5t19.5 58.5q0 32 -19.5 55.5t-57.5 23.5h-98v-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 694,
    d: "M315 -6q-45 0 -92.5 11t-89 32t-74 52t-48.5 70l159 95q9 -24 24.5 -40.5t35 -27t40.5 -15t41 -4.5q58 0 97 33.5t56 84.5h-207v155h202q-17 42 -53 71.5t-93 29.5q-20 0 -41.5 -4t-41.5 -14t-36.5 -27t-26.5 -43l-149 106q37 70 112.5 112.5t178.5 42.5q85 0 152.5 -31 t114.5 -81t71.5 -113t24.5 -128q0 -68 -26.5 -134t-73.5 -118t-112.5 -83.5t-144.5 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 1032,
    d: "M671 -6q-65 0 -119.5 21t-97 58t-70.5 88.5t-40 112.5h-84v-274h-195v710h195v-266h86q13 60 42.5 110t72 85.5t97 55t117.5 19.5q75 0 136.5 -28.5t105 -77.5t67.5 -115t24 -141q0 -81 -25 -147t-69.5 -113t-106.5 -72.5t-136 -25.5zM535 354q0 -87 33.5 -137t104.5 -50 q72 0 104.5 52t32.5 137q0 88 -34 136.5t-104 48.5q-71 0 -104 -51t-33 -136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 689,
    d: "M429 0v248h-52l-156 -248h-209l171 270q-58 27 -91 80.5t-33 128.5q0 51 18 93t49.5 73t75.5 48t96 17h326v-710h-195zM429 545h-103q-12 0 -24.5 -3t-22 -10.5t-16 -20.5t-6.5 -32q0 -20 6 -32.5t15.5 -20t22 -10.5t25.5 -3h103v132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0430",
    unicode: "\u0430",
    horizAdvX: 601,
    d: "M203 -10q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-102q0 -27 8 -37.5t28 -12.5v-160q-23 -5 -43.5 -7.5 t-36.5 -2.5q-51 0 -77.5 18.5t-34.5 54.5l-4 19q-35 -45 -81 -68.5t-98 -23.5zM260 126q17 0 35 5.5t32 14.5q11 8 18 17.5t7 19.5v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 629,
    d: "M315 531q-45 -9 -71.5 -37t-36.5 -82q26 32 68 51.5t101 19.5q45 0 87 -18.5t74.5 -50t51.5 -73t19 -88.5q0 -52 -18.5 -99.5t-55 -84t-90.5 -58t-124 -21.5q-142 0 -215 79t-73 231q0 98 17.5 166.5t52.5 114.5t89 73t127 41l229 45v-163zM227 253q0 -48 26 -75.5 t67 -27.5t67 28t26 75q0 35 -26 57.5t-67 22.5t-67 -22.5t-26 -57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 593,
    d: "M418 526q30 0 54 -12t41 -31t26 -43.5t9 -49.5q0 -35 -20 -68.5t-62 -50.5q49 -14 77.5 -45t28.5 -91q0 -77 -57 -106t-162 -29h-303v526h368zM321 313q17 0 28 9t11 29q0 17 -11 28t-28 11h-81v-77h81zM343 136q14 0 25 11t11 28q0 21 -11 32t-25 11h-103v-82h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 440,
    d: "M428 361h-188v-361h-190v526h378v-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 674,
    d: "M12 165h26q23 0 38 7.5t25 27.5t16.5 55t12.5 90l20 181h418v-361h80v-297h-171v132h-300v-132h-165v297zM378 165v196h-67l-4 -36q-5 -47 -16.5 -85.5t-28.5 -74.5h116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0435",
    unicode: "\u0435",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 919,
    d: "M219 526l130 -176h13v176h196v-176h14l129 176h215l-188 -252l206 -274h-228l-134 185h-15v-185h-194v185h-15l-133 -185h-229l205 274l-187 252h215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 477,
    d: "M25 466q50 37 105.5 53.5t109.5 16.5q36 0 71 -8t62 -25.5t43.5 -45t16.5 -66.5q0 -36 -20.5 -68.5t-60.5 -42.5q56 -16 82 -51.5t26 -82.5q0 -35 -17.5 -63.5t-48 -49t-71.5 -32t-88 -11.5q-36 0 -70.5 5.5t-64.5 15.5t-54 23.5t-39 30.5l84 118q14 -17 45.5 -27.5 t65.5 -10.5q32 0 53.5 10t21.5 32q0 10 -3.5 18.5t-14 14t-29 8.5t-48.5 3h-48v90h46q45 0 67 15t22 36q0 18 -14.5 26t-37.5 8q-26 0 -60.5 -12t-58.5 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 629,
    d: "M240 273l206 253h133v-526h-190v244l-205 -244h-134v526h190v-253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 629,
    d: "M502 730q0 -36 -13 -65.5t-36.5 -51t-56.5 -33.5t-73 -12t-73 12t-56.5 33.5t-36.5 51t-13 65.5h98q0 -33 20 -57t61 -24q38 0 57.5 23t23.5 58h98zM240 273l206 253h133v-526h-190v244l-205 -244h-134v526h190v-253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 587,
    d: "M384 526h201l-204 -254l222 -272h-220l-140 169h-4v-169h-189v526h189v-184h4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 598,
    d: "M12 165q25 1 40.5 8t26 26.5t17.5 54.5t13 91l20 181h419v-526h-190v361h-67l-4 -36q-11 -96 -29 -159t-49.5 -100.5t-79 -52.5t-117.5 -16v168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 754,
    d: "M377 311l129 215h198v-526h-180v251l-107 -179h-80l-107 179v-251h-180v526h199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 620,
    d: "M240 352h140v174h190v-526h-190v187h-140v-187h-190v526h190v-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043E",
    unicode: "\u043E",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 605,
    d: "M555 0h-190v361h-125v-361h-190v526h505v-526z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0440",
    unicode: "\u0440",
    horizAdvX: 648,
    d: "M404 -10q-57 0 -99 22.5t-65 65.5v-291h-190v739h165v-79q28 43 69 66t101 23q52 0 97 -20.5t77 -56.5t50.5 -86t18.5 -108q0 -59 -17 -109.5t-47 -87.5t-71 -57.5t-89 -20.5zM338 150q21 0 38.5 9t30 25t20 37t7.5 45q0 50 -28.5 80t-75.5 30q-53 0 -90 -54v-91 q14 -35 41 -58t57 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0441",
    unicode: "\u0441",
    horizAdvX: 577,
    d: "M19 263q0 54 19 103.5t55.5 87t90.5 60t124 22.5q96 0 160.5 -40t96.5 -103l-185 -56q-27 39 -73 39q-39 0 -66 -29.5t-27 -83.5t27 -83.5t66 -29.5q46 0 73 39l185 -56q-32 -63 -96.5 -103t-160.5 -40q-70 0 -124 22.5t-90.5 60t-55.5 87t-19 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 514,
    d: "M353 0h-190v361h-151v165h490v-165h-149v-361z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0443",
    unicode: "\u0443",
    horizAdvX: 555,
    d: "M84 -63q17 -4 32 -5.5t23 -1.5q23 0 35 14.5t15 55.5l-191 526h195l100 -365l81 365h177l-178 -589q-26 -84 -81 -127.5t-132 -43.5q-17 0 -37 2t-39 7v162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 764,
    d: "M480 529q66 -10 116 -33.5t83 -58t49.5 -79t16.5 -96.5q0 -109 -67.5 -177.5t-197.5 -87.5v-210h-190v209q-134 17 -202.5 85.5t-68.5 180.5q0 106 67 177t204 91v200h190v-201zM290 385q-51 -13 -71 -44t-20 -78t18 -78t73 -45v245zM480 142q50 14 67.5 45t17.5 76 t-18.5 75.5t-66.5 44.5v-241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0445",
    unicode: "\u0445",
    horizAdvX: 554,
    d: "M192 526l75 -129l10 -21l10 21l75 129h193l-176 -263l181 -263h-193l-81 129l-9 20l-9 -20l-81 -129h-193l181 263l-176 263h193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 645,
    d: "M50 526h190v-361h113v361h190v-361h76v-297h-171v132h-398v526z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 549,
    d: "M499 0h-184v162q-54 -20 -100 -20q-41 0 -76 13.5t-60.5 38t-40 58t-14.5 72.5v202h180v-177q0 -32 14.5 -48.5t46.5 -16.5q23 0 50 14v228h184v-526z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 909,
    d: "M50 0v526h190v-361h120v361h190v-361h119v361h190v-526h-809z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 962,
    d: "M50 526h190v-361h120v361h190v-361h119v361h190v-361h77v-297h-172v132h-714v526z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 655,
    d: "M316 378h107q106 0 164 -50t58 -134q0 -88 -54 -141t-157 -53h-308v373h-115v153h305v-148zM402 143q49 0 49 46q0 21 -12.5 33.5t-36.5 12.5h-86v-92h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 843,
    d: "M50 526h190v-148h76q107 0 165 -50t58 -134q0 -88 -54 -141t-157 -53h-278v526zM603 526h190v-526h-190v526zM296 143q49 0 49 46q0 21 -12.5 33.5t-36.5 12.5h-56v-92h56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 579,
    d: "M50 526h190v-148h106q107 0 165 -50t58 -134q0 -88 -54 -141t-157 -53h-308v526zM326 143q49 0 49 46q0 21 -12.5 33.5t-36.5 12.5h-86v-92h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 563,
    d: "M257 -10q-39 0 -76.5 8t-70 24t-59 38.5t-42.5 51.5l143 88q16 -25 44 -38.5t55 -13.5q31 0 52.5 15.5t34.5 41.5h-124v110h127q-13 32 -40 47.5t-59 15.5q-26 0 -52 -11.5t-44 -35.5l-131 89q30 54 93 85t142 31q68 0 123 -23t93.5 -61t59 -86.5t20.5 -99.5 q0 -53 -22 -102.5t-60.5 -88t-91.5 -62t-115 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 835,
    d: "M307 352q24 86 91 135t160 49q59 0 106.5 -20t81 -56.5t51.5 -87.5t18 -113q0 -65 -19.5 -115t-53.5 -84t-81.5 -52t-102.5 -18q-50 0 -92 14t-74.5 40t-55 62t-32.5 81h-64v-187h-190v526h190v-174h67zM477 263q0 -57 22 -82t57 -25t56.5 26t21.5 83t-21 81t-56 24 q-36 0 -58 -25t-22 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 589,
    d: "M147 193q-49 16 -74 53t-25 100q0 43 15 77t41.5 57.5t63 36t79.5 12.5h292v-529h-190v163h-36l-102 -163h-199zM349 296v90h-72q-15 0 -25.5 -12t-10.5 -33t10.5 -33t27.5 -12h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0450",
    unicode: "\u0450",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM150 731h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0451",
    unicode: "\u0451",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM114 581v140h156v-140h-156zM344 581v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 626,
    d: "M579 12q0 -49 -15 -89.5t-42.5 -70t-65.5 -45.5t-83 -16q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v239q0 39 -17 56.5t-40 17.5q-29 0 -53.5 -28.5t-38.5 -76.5v-205h-190v534h-80v109h80v87h190v-87h203v-109h-203v-166q28 52 73 80t101 28q55 0 88 -19 t50 -47.5t22 -61.5t5 -62v-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 440,
    d: "M428 361h-188v-361h-190v526h378v-165zM301 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 565,
    d: "M307 -10q-62 0 -115 20.5t-91.5 57.5t-60.5 87.5t-22 110.5q0 54 20.5 103t59 86t93.5 59t123 22q79 0 143 -31t94 -85l-144 -104q-6 16 -17 27.5t-24.5 19t-27 11.5t-25.5 4q-36 0 -58 -20.5t-33 -42.5h128v-110h-124q12 -21 33.5 -39t53.5 -18q24 0 51 15t37 43 l154 -94q-12 -29 -39 -51.5t-61.5 -38.5t-73 -24t-74.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0455",
    unicode: "\u0455",
    horizAdvX: 501,
    d: "M265 -10q-69 0 -135 22.5t-112 65.5l65 114q49 -33 94.5 -51t83.5 -18q40 0 40 25q0 14 -15.5 24t-60.5 23q-56 16 -93.5 31.5t-61 33.5t-33.5 40t-10 52q0 40 16 74t44.5 59t68 38.5t86.5 13.5q58 0 110.5 -15t105.5 -61l-72 -114q-49 32 -82 45.5t-62 13.5 q-17 0 -28 -6.5t-11 -20.5q0 -15 16 -24.5t63 -21.5q57 -15 96 -31.5t62.5 -36t33.5 -44t10 -56.5q0 -41 -15 -73t-43.5 -55t-69 -35t-91.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0456",
    unicode: "\u0456",
    horizAdvX: 290,
    d: "M50 0v526h190v-526h-190zM50 570v160h190v-160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0457",
    unicode: "\u0457",
    horizAdvX: 290,
    d: "M50 0v526h190v-526h-190zM-48 581v140h156v-140h-156zM182 581v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0458",
    unicode: "\u0458",
    horizAdvX: 294,
    d: "M38 -209q-42 0 -80 14t-69 40l78 129q18 -20 47 -20q40 0 40 43v529h190v-514q0 -49 -15 -89.5t-42.5 -70t-65.5 -45.5t-83 -16zM54 570v160h190v-160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 856,
    d: "M13 165q25 1 40.5 8t26 26.5t17.5 54.5t13 91l20 181h419v-171h70q107 0 165 -47t58 -125q0 -84 -54 -133.5t-157 -49.5h-272v361h-67l-4 -36q-11 -96 -29 -159t-49.5 -100.5t-79 -52.5t-117.5 -16v168zM595 145q49 0 49 36q0 17 -12.5 26.5t-36.5 9.5h-46v-72h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 893,
    d: "M50 526h190v-179h157v179h190v-171h70q106 0 164 -47t58 -125q0 -84 -54 -133.5t-157 -49.5h-271v182h-157v-182h-190v526zM633 145q49 0 49 36q0 17 -12.5 26.5t-36.5 9.5h-46v-72h46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045B",
    unicode: "\u045B",
    horizAdvX: 626,
    d: "M389 236q0 39 -17 56.5t-40 17.5q-29 0 -53.5 -28.5t-38.5 -76.5v-205h-190v534h-80v109h80v87h190v-87h203v-109h-203v-166q28 52 73 80t101 28q55 0 88 -19t50 -47.5t22 -61.5t5 -62v-286h-190v236z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 587,
    d: "M362 556l-120 32l50 142h169zM384 526h201l-204 -254l222 -272h-220l-140 169h-4v-169h-189v526h189v-184h4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 629,
    d: "M179 731h169l50 -142l-120 -32zM240 273l206 253h133v-526h-190v244l-205 -244h-134v526h190v-253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 555,
    d: "M292 649q38 0 57.5 23t23.5 58h98q0 -36 -13 -65.5t-36.5 -51t-56.5 -33.5t-73 -12t-73 12t-56.5 33.5t-36.5 51t-13 65.5h98q0 -33 20 -57t61 -24zM84 -63q17 -4 32 -5.5t23 -1.5q23 0 35 14.5t15 55.5l-191 526h195l100 -365l81 365h177l-178 -589q-26 -84 -81 -127.5 t-132 -43.5q-17 0 -37 2t-39 7v162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 604,
    d: "M215 0h-165v526h190v-361h124v361h190v-526h-166v-132h-173v132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 534,
    d: "M64 710h294l7 166h162v-336h-268v-540h-195v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 440,
    d: "M257 526l10 132h161v-297h-188v-361h-190v526h207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 648,
    d: "M590 229v-120h-170v-109h-194v109h-169v120h169v8l-241 473h211l127 -307l130 307h212l-245 -475v-6h170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 539,
    d: "M186 0h-133v120h119v4l-178 402h201l74 -249l84 249h192l-179 -402v-4h120v-120h-134v-213h-166v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 716,
    d: "M61 0v710h273q88 0 155 -28t112 -76t68 -112.5t23 -137.5q0 -81 -25.5 -146.5t-72.5 -112t-113 -72t-147 -25.5h-273zM494 356q0 41 -11 75t-31.5 58t-50.5 37.5t-67 13.5h-78v-370h78q38 0 68 14t50.5 39t31 59t10.5 74zM260 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 665,
    d: "M268 -10q-54 0 -99.5 20t-78.5 56.5t-51.5 87t-18.5 110.5q0 58 17 108t47.5 86.5t72.5 57t93 20.5t93.5 -23t65.5 -65v282h190v-520q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-27 -48 -73 -70t-98 -22zM320 150q52 0 90 54v94q-14 35 -41 56.5 t-57 21.5q-21 0 -38.5 -9t-30 -25t-20 -37t-7.5 -45q0 -50 28.5 -80t75.5 -30zM270 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 750,
    d: "M689 710v-710h-195v278h-238v-278h-195v710h195v-262h238v262h195zM287 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-43.5 17.5q-9 0 -21.5 -5.5t-25 -15t-23.5 -23.5t-18 -31v-295h-190v730h190v-282q28 43 73 65.5t101 22.5q55 0 88 -19t50 -47.5t22 -61.5t5 -62v-346zM225 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 754,
    d: "M256 349v-349h-195v710h152l285 -361v361h195v-710h-155zM289 763v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 621,
    d: "M577 0h-190v296q0 39 -17.5 56.5t-40.5 17.5q-24 0 -51 -21t-40 -54v-295h-190v526h171v-78q28 43 78.5 65.5t119.5 22.5q54 0 85.5 -19.5t48 -48.5t21.5 -62t5 -60v-346zM248 580v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 675,
    d: "M61 0v710h326q52 0 96 -21.5t75.5 -56t49.5 -79t18 -89.5q0 -62 -27 -115.5t-75 -87.5l150 -261h-220l-125 218h-73v-218h-195zM256 388h123q18 0 33.5 20t15.5 56q0 37 -18 56.5t-36 19.5h-118v-152zM260 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 416,
    d: "M405 364q-55 0 -100 -12t-67 -40v-312h-190v526h174v-100q28 53 69.5 81.5t89.5 28.5q19 0 24 -1v-171zM58 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 617,
    d: "M491 478q-30 18 -62 32q-27 12 -60.5 22.5t-65.5 10.5q-26 0 -41.5 -8t-15.5 -27q0 -14 9 -23t26 -16.5t41.5 -14.5t55.5 -17q49 -15 88.5 -33t67.5 -42.5t43 -59.5t15 -85q0 -64 -23.5 -107.5t-62 -69.5t-87 -37.5t-97.5 -11.5q-39 0 -80 6t-81.5 17t-78 26t-69.5 34 l84 171q35 -22 73 -39q32 -15 72.5 -27t82.5 -12q32 0 44.5 8.5t12.5 22.5q0 15 -12.5 25.5t-34.5 18.5t-50.5 16t-60.5 19q-47 16 -81 34.5t-56 42t-32.5 53.5t-10.5 69q0 59 21.5 104t58.5 75t84.5 45.5t100.5 15.5q39 0 76 -7.5t71.5 -19t64.5 -25t54 -25.5zM218 -213 v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 501,
    d: "M265 -10q-69 0 -135 22.5t-112 65.5l65 114q49 -33 94.5 -51t83.5 -18q40 0 40 25q0 14 -15.5 24t-60.5 23q-56 16 -93.5 31.5t-61 33.5t-33.5 40t-10 52q0 40 16 74t44.5 59t68 38.5t86.5 13.5q58 0 110.5 -15t105.5 -61l-72 -114q-49 32 -82 45.5t-62 13.5 q-17 0 -28 -6.5t-11 -20.5q0 -15 16 -24.5t63 -21.5q57 -15 96 -31.5t62.5 -36t33.5 -44t10 -56.5q0 -41 -15 -73t-43.5 -55t-69 -35t-91.5 -12zM167 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 624,
    d: "M614 540h-204v-540h-195v540h-205v170h604v-170zM224 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 423,
    d: "M417 29q-40 -17 -85.5 -28.5t-89.5 -11.5q-32 0 -61 8t-50.5 26t-34 47t-12.5 72v241h-65v143h65v165h190v-165h103v-143h-103v-174q0 -26 11 -36.5t30 -10.5q14 0 32 4.5t36 12.5zM152 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1057,
    d: "M287 710h179l62 -219l63 219h179l-117 -339l51 -148l153 487h212l-278 -710h-162l-101 254l-100 -254h-162l-278 710h211l154 -487l49 148zM371 915h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 862,
    d: "M693 526h179l-215 -526h-155l-71 200l-71 -200h-155l-215 526h179l127 -353l33 113l-94 240h151l45 -154l45 154h151l-94 -240l33 -113zM274 731h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1057,
    d: "M287 710h179l62 -219l63 219h179l-117 -339l51 -148l153 487h212l-278 -710h-162l-101 254l-100 -254h-162l-278 710h211l154 -487l49 148zM586 740l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 862,
    d: "M693 526h179l-215 -526h-155l-71 200l-71 -200h-155l-215 526h179l127 -353l33 113l-94 240h151l45 -154l45 154h151l-94 -240l33 -113zM489 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1057,
    d: "M287 710h179l62 -219l63 219h179l-117 -339l51 -148l153 487h212l-278 -710h-162l-101 254l-100 -254h-162l-278 710h211l154 -487l49 148zM335 765v140h156v-140h-156zM565 765v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 862,
    d: "M693 526h179l-215 -526h-155l-71 200l-71 -200h-155l-215 526h179l127 -353l33 113l-94 240h151l45 -154l45 154h151l-94 -240l33 -113zM238 581v140h156v-140h-156zM468 581v140h156v-140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 622,
    d: "M27 145l332 395h-317v170h542v-145l-312 -395h318v-170h-563v145zM226 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 494,
    d: "M22 112l240 284h-225v130h423v-112l-239 -284h248v-130h-447v112zM160 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM232 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM213 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 597,
    d: "M567 170v-170h-506v710h497v-170h-302v-100h258v-158h-258v-112h311zM380 756q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5 t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    d: "M307 -10q-69 0 -123 21.5t-90.5 58.5t-55.5 85t-19 101q0 57 18.5 108t55 89t90 60.5t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5q0 -15 -1.5 -30.5t-3.5 -27.5h-369q3 -42 31 -60.5t61 -18.5q31 0 58.5 14t36.5 39l161 -46q-32 -63 -98.5 -103t-163.5 -40z M391 319q-5 38 -28 60t-59 22t-59 -22t-28 -60h174zM371 572q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100 q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 317,
    d: "M61 0v710h195v-710h-195zM72 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 286,
    d: "M48 0v526h190v-526h-190zM48 570v160h190v-160h-190zM56 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 765,
    d: "M381 -6q-81 0 -147 31t-113 81.5t-73 115.5t-26 134q0 70 27 135t75.5 114.5t115 79t145.5 29.5q81 0 147 -31t113 -82t72.5 -116t25.5 -133q0 -70 -27 -134.5t-75 -114t-114.5 -79.5t-145.5 -30zM220 354q0 -36 10 -69.5t30 -59.5t50.5 -42t72.5 -16t73 16.5t50.5 43 t29 60.5t9.5 69q0 36 -10 69.5t-30.5 59t-51 41t-71.5 15.5q-42 0 -72.5 -16t-50.5 -42.5t-29.5 -60t-9.5 -68.5zM295 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 614,
    d: "M307 -10q-71 0 -124.5 22.5t-90 60t-55 87t-18.5 103.5t18.5 103.5t55 87t90 60t124.5 22.5q70 0 124 -22.5t90.5 -60t55 -87t18.5 -103.5t-18.5 -103.5t-55 -87t-90.5 -60t-124 -22.5zM214 263q0 -53 26 -83t67 -30t67 30t26 83t-26 83t-67 30t-67 -30t-26 -83z M221 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 743,
    d: "M371 167q34 0 58 15t39 39.5t22 56.5t7 67v365h195v-365q0 -74 -19 -138.5t-59 -111.5t-100.5 -74t-142.5 -27q-85 0 -145.5 28.5t-99.5 76.5t-57 111.5t-18 134.5v365h195v-365q0 -35 7 -67.5t22 -57t38.5 -39t57.5 -14.5zM282 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 638,
    d: "M207 -10q-80 0 -122 48.5t-42 141.5v346h190v-303q0 -35 15.5 -54t42.5 -19q22 0 45 10t46 44v322h190v-316q0 -27 8 -37.5t28 -12.5v-160q-49 -10 -80 -10q-97 0 -112 73l-4 19q-37 -49 -88 -70.5t-117 -21.5zM222 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 666,
    d: "M205 710l127 -307l130 307h212l-245 -475v-235h-194v237l-241 473h211zM175 915h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 555,
    d: "M44 -53q46 -17 78 -17q61 0 67 70l-191 526h195l100 -365l81 365h177l-178 -589q-12 -39 -34 -70.5t-52.5 -54t-67.5 -34.5t-77 -12q-51 0 -98 19v162zM136 731h169l50 -142l-120 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 666,
    d: "M205 710l127 -307l130 307h212l-245 -475v-235h-194v237l-241 473h211zM396 756q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5 t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 555,
    d: "M44 -53q46 -17 78 -17q61 0 67 70l-191 526h195l100 -365l81 365h177l-178 -589q-12 -39 -34 -70.5t-52.5 -54t-67.5 -34.5t-77 -12q-51 0 -98 19v162zM357 572q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-13.5 -16t-5.5 -16.5t-1 -8.5h-101 q0 13 7.5 39.5t24.5 52.5t43 46t64 20q24 0 42 -8t33 -17.5t29 -17.5t31 -8q16 0 26 7.5t15.5 17t7 17.5t1.5 9h100q0 -9 -8 -34.5t-25 -53t-44 -49t-66 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 621
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 940
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 629,
    d: "M50 191v170h529v-170h-529z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 948,
    d: "M50 191v170h848v-170h-848z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 293,
    d: "M220 730l-26 -131h52v-160h-197v165l42 126h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 282,
    d: "M69 453l26 131h-52v160h197v-165l-42 -126h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 297,
    d: "M76 -151l26 151h-52v184h197v-189l-42 -146h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 542,
    d: "M220 730l-26 -131h52v-160h-197v165l42 126h129zM469 730l-26 -131h52v-160h-197v165l42 126h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 531,
    d: "M69 453l26 131h-52v160h197v-165l-42 -126h-129zM318 453l26 131h-52v160h197v-165l-42 -126h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 534,
    d: "M76 -151l26 151h-52v184h197v-189l-42 -146h-129zM313 -151l26 151h-52v184h197v-189l-42 -146h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 509,
    d: "M165 -130v316h-132v170h132v419h180v-419h131v-170h-131v-316h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 537,
    d: "M179 -130v183h-132v170h132v113h-132v170h132v269h180v-269h131v-170h-131v-113h131v-170h-131v-183h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 371,
    d: "M302 353q0 -24 -9 -45.5t-25 -37.5t-37.5 -25t-45.5 -9t-45.5 9t-37 25t-25 37.5t-9.5 45.5t9.5 45.5t25 37t37 25t45.5 9.5t45.5 -9.5t37.5 -25t25 -37t9 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 722,
    d: "M50 0v184h154v-184h-154zM284 0v184h154v-184h-154zM518 0v184h154v-184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1258,
    d: "M214 404q-38 0 -70.5 12.5t-56.5 33.5t-37.5 50t-13.5 62t13.5 62t37.5 50t56.5 33.5t70.5 12.5q37 0 69.5 -12.5t56.5 -33.5t38 -50t14 -62t-14 -62t-38 -50t-56.5 -33.5t-69.5 -12.5zM214 494q20 0 34 20t14 48t-14 48t-34 20t-34 -20t-14 -48t14 -48t34 -20zM643 -10 q-38 0 -70.5 12.5t-56.5 33.5t-37.5 50t-13.5 62t13.5 62t37.5 50t56.5 33.5t70.5 12.5q37 0 69.5 -12.5t56.5 -33.5t38 -50t14 -62t-14 -62t-38 -50t-56.5 -33.5t-69.5 -12.5zM643 80q20 0 34 20t14 48t-14 48t-34 20t-34 -20t-14 -48t14 -48t34 -20zM1049 -10 q-38 0 -70.5 12.5t-56.5 33.5t-37.5 50t-13.5 62t13.5 62t37.5 50t56.5 33.5t70.5 12.5q37 0 69.5 -12.5t56.5 -33.5t38 -50t14 -62t-14 -62t-38 -50t-56.5 -33.5t-69.5 -12.5zM1049 80q20 0 34 20t14 48t-14 48t-34 20t-34 -20t-14 -48t14 -48t34 -20zM120 65l283 319 l251 337l83 -75l-271 -309l-263 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 362,
    d: "M30 298l277 198v-152l-128 -85l128 -77v-152l-277 180v88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 362,
    d: "M332 210l-277 -180v152l128 77l-128 85v152l277 -198v-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 240,
    d: "M-189 65l283 319l251 337l83 -75l-271 -309l-263 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 511,
    d: "M256 374q-57 0 -100 21t-72 53.5t-43.5 72t-14.5 76.5q0 40 16 79.5t46 71.5t72.5 52t95.5 20q57 0 99.5 -21.5t71.5 -54t43.5 -72t14.5 -75.5q0 -40 -16 -80t-45.5 -71.5t-72 -51.5t-95.5 -20zM138 597q0 -20 7 -40t21.5 -36.5t37 -27t52.5 -10.5q31 0 53 11t36.5 28 t21 37t6.5 38q0 20 -7.5 40t-22 36.5t-36.5 27t-51 10.5q-32 0 -54 -11t-36.5 -28t-21 -37t-6.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 431,
    d: "M234 381v83h-215v107l249 250h74v-250h64v-107h-64v-83h-108zM120 571h118v121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 412,
    d: "M216 669q37 0 68.5 -10.5t55 -29.5t36.5 -45.5t13 -57.5q0 -33 -14.5 -61t-41 -48.5t-63 -31.5t-79.5 -11q-55 0 -100.5 18.5t-70.5 50.5l62 76q21 -19 50.5 -29.5t65.5 -10.5q33 0 56.5 11.5t23.5 41.5q0 15 -6.5 26t-17 18t-22.5 10t-23 3q-23 0 -47 -12t-34 -31h-94 q13 69 31 137t30 138h258v-109h-180l-17 -51q7 2 21.5 5t38.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 441,
    d: "M416 524q0 -32 -14.5 -60t-40.5 -49t-61.5 -33t-77.5 -12q-91 0 -142 56.5t-51 161.5q0 108 55.5 170t152.5 62q47 0 88.5 -15t71.5 -44l-62 -77q-17 16 -44.5 24t-58.5 8q-46 0 -73.5 -17t-29.5 -49q17 11 45.5 15t52.5 4q42 0 77 -11t60 -30.5t38.5 -46t13.5 -57.5z M224 470q36 0 62.5 16t26.5 38t-26 36.5t-63 14.5q-38 0 -64 -14.5t-26 -36.5t27 -38t63 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 417,
    d: "M253 712h-230v109h400l-259 -440h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 439,
    d: "M412 513q0 -30 -15.5 -55.5t-41.5 -44t-61 -29t-74 -10.5t-74.5 10.5t-61.5 29.5t-41.5 45t-15.5 56q0 19 6.5 34t17 27t25 21.5t30.5 17.5q-25 11 -43.5 30t-18.5 50q0 27 15.5 50t40.5 39.5t56.5 26t62.5 9.5t62.5 -9t57 -25.5t41.5 -39t16 -49.5q0 -29 -18 -49.5 t-45 -32.5q35 -17 57 -41t22 -61zM302 525q0 19 -25.5 30t-57.5 11q-34 0 -58 -11.5t-24 -29.5q0 -19 26 -30.5t57 -11.5q32 0 57 12t25 30zM152 685q0 -14 21.5 -22t45.5 -8t46 8t22 22t-20.5 22t-47.5 8t-47 -8t-20 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 441,
    d: "M25 665q0 33 14.5 61t40.5 49t61.5 33t77.5 12q91 0 142 -57t51 -162q0 -108 -55 -169.5t-152 -61.5q-48 0 -89.5 15t-71.5 44l62 77q17 -16 44.5 -24.5t58.5 -8.5q46 0 73.5 17.5t29.5 49.5q-16 -11 -44.5 -15.5t-54.5 -4.5q-42 0 -76.5 11t-59 30.5t-38.5 46t-14 57.5z M217 720q-36 0 -62 -16.5t-26 -38.5q0 -21 26 -35.5t63 -14.5t63 14.5t26 35.5q0 22 -26.5 38.5t-63.5 16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 511,
    d: "M256 -96q-57 0 -100 21t-72 53.5t-43.5 72t-14.5 76.5q0 40 16 79.5t46 71.5t72.5 52t95.5 20q57 0 99.5 -21.5t71.5 -54t43.5 -72t14.5 -75.5q0 -40 -16 -80t-45.5 -71.5t-72 -51.5t-95.5 -20zM138 127q0 -20 7 -40t21.5 -36.5t37 -27t52.5 -10.5q31 0 53 11t36.5 28 t21 37t6.5 38q0 20 -7.5 40t-22 36.5t-36.5 27t-51 10.5q-32 0 -54 -11t-36.5 -28t-21 -37t-6.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 370,
    d: "M354 17v-107h-307v107h103v221q-6 -7 -20 -16t-31.5 -17.5t-35.5 -14t-33 -5.5v109q19 0 40.5 9t39 20t29 20t11.5 10h110v-336h94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 447,
    d: "M26 -90q0 43 6 74.5t21 56t41 43.5t67 36q24 10 46.5 19.5t40.5 20t29 22.5t11 29q0 23 -19.5 30.5t-52.5 7.5q-38 0 -69 -13.5t-51 -30.5l-68 80q22 29 75 49.5t130 20.5q86 0 132.5 -36.5t46.5 -108.5q0 -34 -12.5 -58t-31 -41t-40.5 -27t-41 -15q-36 -10 -58 -21 t-22 -31h206v-107h-387z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 422,
    d: "M194 -96q-63 0 -107 17t-64 54l57 84q19 -18 45.5 -31.5t66.5 -13.5q36 0 63 7.5t27 27.5q0 23 -39 32t-109 9h-25v99h24q58 0 96 8.5t38 31.5q0 8 -7 13t-17.5 8t-22 4t-20.5 1q-39 0 -64 -12t-46 -32l-69 89q13 14 33 24.5t43.5 17.5t49.5 10.5t52 3.5q39 0 73 -9 t58.5 -25.5t38.5 -38.5t14 -47q0 -36 -26.5 -59.5t-71.5 -30.5q51 -7 79.5 -39.5t28.5 -74.5q0 -35 -17.5 -59.5t-45.5 -39.5t-63.5 -22t-72.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 431,
    d: "M234 -89v83h-215v107l249 250h74v-250h64v-107h-64v-83h-108zM120 101h118v121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 411,
    d: "M215 199q37 0 68.5 -10.5t55 -29.5t36.5 -45.5t13 -57.5q0 -33 -14.5 -61t-41 -48.5t-63 -31.5t-79.5 -11q-55 0 -100.5 18.5t-70.5 50.5l62 76q21 -19 50.5 -29.5t65.5 -10.5q33 0 56.5 11.5t23.5 41.5q0 15 -6.5 26t-17 18t-22.5 10t-23 3q-23 0 -47 -12t-34 -31h-94 q13 69 31 137t30 138h258v-109h-180l-17 -51q7 2 21.5 5t38.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 441,
    d: "M416 58q0 -32 -14.5 -60t-40.5 -49t-61.5 -33t-77.5 -12q-91 0 -142 56.5t-51 161.5q0 108 55.5 170t152.5 62q47 0 88.5 -15t71.5 -44l-62 -77q-17 16 -44.5 24t-58.5 8q-46 0 -73.5 -17t-29.5 -49q17 11 45.5 15t52.5 4q42 0 77 -11t60 -30.5t38.5 -46t13.5 -57.5z M224 4q36 0 62.5 16t26.5 38t-26 36.5t-63 14.5q-38 0 -64 -14.5t-26 -36.5t27 -38t63 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 418,
    d: "M253 242h-230v109h400l-259 -440h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 439,
    d: "M412 43q0 -30 -15.5 -55.5t-41.5 -44t-61 -29t-74 -10.5t-74.5 10.5t-61.5 29.5t-41.5 45t-15.5 56q0 19 6.5 34t17 27t25 21.5t30.5 17.5q-25 11 -43.5 30t-18.5 50q0 27 15.5 50t40.5 39.5t56.5 26t62.5 9.5t62.5 -9t57 -25.5t41.5 -39t16 -49.5q0 -29 -18 -49.5 t-45 -32.5q35 -17 57 -41t22 -61zM302 55q0 19 -25.5 30t-57.5 11q-34 0 -58 -11.5t-24 -29.5q0 -19 26 -30.5t57 -11.5q32 0 57 12t25 30zM152 215q0 -14 21.5 -22t45.5 -8t46 8t22 22t-20.5 22t-47.5 8t-47 -8t-20 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 441,
    d: "M25 199q0 33 14.5 61t40.5 49t61.5 33t77.5 12q91 0 142 -57t51 -162q0 -108 -55 -169.5t-152 -61.5q-48 0 -89.5 15t-71.5 44l62 77q17 -16 44.5 -24.5t58.5 -8.5q46 0 73.5 17.5t29.5 49.5q-16 -11 -44.5 -15.5t-54.5 -4.5q-42 0 -76.5 11t-59 30.5t-38.5 46t-14 57.5z M217 254q-36 0 -62 -16.5t-26 -38.5q0 -21 26 -35.5t63 -14.5t63 14.5t26 35.5q0 22 -26.5 38.5t-63.5 16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 585,
    d: "M188 13q-40 16 -70.5 42t-51.5 58.5t-31.5 70.5t-10.5 79q0 40 10.5 78t31.5 70.5t51.5 58.5t70.5 43v132h84v-111q10 1 20 1.5t21 0.5h9.5t9.5 -1v110h84v-124q54 -17 92.5 -50t61.5 -78l-185 -56q-27 39 -73 39q-39 0 -66 -29.5t-27 -83.5t27 -83.5t66 -29.5 q46 0 73 39l185 -56q-23 -45 -61.5 -78t-92.5 -50v-125h-84v111q-5 -1 -9.5 -1h-9.5q-11 0 -21 0.5t-20 1.5v-112h-84v133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 606,
    d: "M102 0v76h-67v120h67v514h487v-170h-292v-118h238v-158h-238v-68h105v-120h-105v-76h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 573,
    d: "M36 462h62q-5 17 -8.5 34t-3.5 35q0 39 17.5 72.5t48.5 58t72 39t89 14.5q66 0 126.5 -27.5t103.5 -77.5l-96 -117q-13 15 -29.5 27.5t-34.5 21.5t-36.5 14.5t-34.5 5.5q-27 0 -42.5 -14t-15.5 -38q0 -21 11 -48h155v-120h-110q2 -8 3 -15t1 -15h106v-120h-137 q-15 -24 -37 -46q24 8 42.5 11.5t35.5 3.5q32 0 65 -7.5t65 -7.5q17 0 31 3t32 10l46 -140q-23 -15 -56 -24.5t-63 -9.5q-23 0 -48 5t-50.5 11.5t-51.5 11.5t-51 5q-29 0 -67.5 -7.5t-76.5 -19.5l-38 134q38 23 63 67h-88v120h115q-2 8 -3.5 15t-3.5 15h-108v120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 870,
    d: "M831 433h-80v-170h80v-120h-80v-143h-155l-116 143h-166v-143h-195v143h-80v120h80v170h-80v120h80v157h152l124 -157h161v157h195v-157h80v-120zM314 263h69l-69 86v-86zM556 349v84h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1167,
    d: "M43 222h189l-43 110h-146v120h99l-101 258h211l81 -258h94l-87 258h179l62 -219l63 219h179l-89 -258h95l81 258h212l-101 -258h104v-120h-151l-43 -110h194v-120h-241l-40 -102h-162l-101 254l-100 -254h-162l-40 102h-236v120zM757 223l34 109h-72zM406 223l36 109h-71 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 802,
    d: "M118 464q16 50 46.5 95.5t74.5 80t100.5 54.5t125.5 20q103 0 178.5 -42.5t112.5 -112.5l-149 -106q-10 26 -26.5 43t-36.5 27t-41.5 14t-41.5 4q-49 0 -82 -22t-52 -55h180l-40 -100h-167q0 -16 0.5 -25.5t1.5 -17.5h177l-40 -100h-93q21 -25 50 -39.5t67 -14.5 q20 0 41 4.5t40.5 15t35 27t24.5 40.5l159 -95q-16 -39 -48.5 -70t-74 -52t-89 -32t-92.5 -11q-58 0 -109.5 17.5t-93.5 48.5t-74 72.5t-51 88.5h-97l40 100h30q-1 10 -1.5 20t-0.5 23h-68l40 100h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 579,
    d: "M541 403h-109q-12 -44 -41.5 -80.5t-71.5 -61.5l180 -261h-220l-239 368h154q23 0 38 35h-192v120h191q-8 18 -19.5 27.5t-22.5 9.5h-149v150h501v-120h-136q19 -34 28 -67h108v-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 329,
    d: "M211 113q10 0 23.5 3.5t24.5 8.5l22 -111q-22 -9 -52 -15t-53 -6q-61 0 -95.5 29t-34.5 81v507q0 28 12 51.5t32.5 41t49 27.5t61.5 10q66 0 106 -36t40 -94q0 -44 -15.5 -99.5t-41 -112t-58.5 -108.5t-68 -88v-27q0 -29 12.5 -45.5t34.5 -16.5zM236 564q0 67 -34 67 q-17 0 -27.5 -17t-10.5 -44v-206q15 24 28 51t22.5 53.5t15.5 51t6 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1152,
    d: "M275 349v-349h-195v710h152l285 -361v361h195v-710h-155zM956 333q-47 0 -82.5 15.5t-59.5 42t-36.5 61t-12.5 72.5t12.5 72.5t36.5 61t59.5 42t82.5 15.5t83 -15.5t60 -42t36 -61t12 -72.5t-12 -72.5t-36 -61t-60 -42t-83 -15.5zM898 524q0 -37 16 -58t42 -21t42 21 t16 58t-16 58t-42 21t-42 -21t-16 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 851,
    d: "M614 710h182v-309h-120v161l-48 -119h-97l-48 119v-161h-120v309h181l35 -131zM278 601q-32 14 -54 21t-42 7q-13 0 -21 -2.5t-8 -8.5q0 -7 10.5 -11.5t42.5 -10.5q70 -18 97 -39.5t27 -58.5q0 -48 -36 -75.5t-98 -27.5q-20 0 -42 3t-44 8t-41.5 11.5t-34.5 14.5l43 86 q32 -17 61.5 -26t54.5 -9q30 0 30 10q0 6 -12 10.5t-45 11.5q-65 17 -90.5 37.5t-25.5 55.5q0 48 37 78t95 30q63 0 139 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 912,
    d: "M370 592h-95v-191h-120v191h-95v120h310v-120zM667 710h182v-309h-120v161l-48 -119h-97l-48 119v-161h-120v309h181l35 -131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 792,
    d: "M30 130h149q-65 38 -102 101t-37 144q0 67 27 128.5t74.5 108.5t112.5 75t142 28q76 0 141.5 -28t113 -75t74.5 -108.5t27 -128.5q0 -81 -37 -144t-102 -101h149v-130h-329v130q30 13 53.5 38t40 58t25.5 71.5t9 77.5q0 31 -11.5 61t-32.5 54t-51.5 38.5t-69.5 14.5 t-69.5 -14.5t-51.5 -38.5t-32.5 -54t-11.5 -61q0 -39 9 -77.5t25.5 -71.5t40 -58t53.5 -38v-130h-329v130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 619,
    d: "M315 47q73 0 123.5 20.5t80.5 48.5l36 -43q-38 -35 -97.5 -59t-142.5 -24q-65 0 -118.5 22t-91 59t-58 86t-20.5 103q0 57 21 107t58.5 87.5t90.5 59.5t118 22t118 -23.5t91 -64t59 -95.5t21 -118h-430v-131q26 -25 63 -41t78 -16zM315 479q-41 0 -78 -17.5t-63 -52.5 v-114h284v113q-26 36 -63.5 53.5t-79.5 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 1041,
    d: "M164 65l283 319l251 337l83 -75l-271 -309l-263 -347zM310 395v-107h-253v107h76v221q-5 -7 -16 -16t-24 -17.5t-27 -14t-26 -5.5v109q15 0 31.5 9t30 20t22.5 20t9 10h110v-336h67zM809 -6q-63 0 -107 17t-64 54l57 84q20 -18 45.5 -31.5t66.5 -13.5q36 0 63 7.5 t27 27.5q0 23 -39 32t-109 9h-25v99h24q58 0 96 8.5t38 31.5q0 8 -7 13t-17.5 8t-22 4t-20.5 1q-39 0 -64 -12t-46 -32l-69 89q13 14 33 24.5t43.5 17.5t49.5 10.5t52 3.5q39 0 73 -9t58.5 -25.5t38.5 -38.5t14 -47q0 -36 -26.5 -59.5t-71.5 -30.5q51 -7 79.5 -39.5 t28.5 -74.5q0 -35 -17.5 -59.5t-45.5 -39.5t-63.5 -22t-72.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 1088,
    d: "M250 65l283 319l251 337l83 -75l-271 -309l-263 -347zM855 -6q-63 0 -107 17t-64 54l57 84q20 -18 45.5 -31.5t66.5 -13.5q36 0 63 7.5t27 27.5q0 23 -39 32t-109 9h-25v99h24q58 0 96 8.5t38 31.5q0 8 -7 13t-17.5 8t-22 4t-20.5 1q-39 0 -64 -12t-46 -32l-69 89 q13 14 33 24.5t43.5 17.5t49.5 10.5t52 3.5q39 0 73 -9t58.5 -25.5t38.5 -38.5t14 -47q0 -36 -26.5 -59.5t-71.5 -30.5q51 -7 79.5 -39.5t28.5 -74.5q0 -35 -17.5 -59.5t-45.5 -39.5t-63.5 -22t-72.5 -7zM40 286q0 43 6 74.5t21 56t41 43.5t66 36q24 10 47 19.5t41 20 t29 22.5t11 29q0 23 -19.5 30.5t-52.5 7.5q-38 0 -69 -13.5t-51 -30.5l-68 80q22 29 75 49.5t129 20.5q87 0 133.5 -36.5t46.5 -108.5q0 -34 -12.5 -58t-31 -41t-40.5 -27t-41 -15q-36 -10 -58 -21t-22 -31h187v-107h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 1036,
    d: "M177 65l283 319l251 337l83 -75l-271 -309l-263 -347zM311 395v-107h-253v107h76v221q-5 -7 -16 -16t-24 -17.5t-27 -14t-26 -5.5v109q15 0 31.5 9t30 20t22.5 20t9 10h110v-336h67zM1003 133q0 -30 -15.5 -55.5t-41.5 -44t-61 -29t-74 -10.5t-74.5 10.5t-61.5 29.5 t-41.5 45t-15.5 56q0 19 6.5 34t17 27t25 21.5t30.5 17.5q-25 11 -43.5 30t-18.5 50q0 27 15.5 50t40.5 39.5t56.5 26t62.5 9.5t62.5 -9t57 -25.5t41.5 -39t16 -49.5q0 -29 -18 -49.5t-45 -32.5q35 -17 57 -41t22 -61zM893 145q0 19 -25.5 30t-57.5 11q-34 0 -58 -11.5 t-24 -29.5q0 -19 26 -30.5t57 -11.5q32 0 57 12t25 30zM743 305q0 -14 21.5 -22t45.5 -8t46 8t22 22t-20.5 22t-47.5 8t-47 -8t-20 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 1049,
    d: "M217 65l283 319l251 337l83 -75l-271 -309l-263 -347zM1016 133q0 -30 -15.5 -55.5t-41.5 -44t-61 -29t-74 -10.5t-74.5 10.5t-61.5 29.5t-41.5 45t-15.5 56q0 19 6.5 34t17 27t25 21.5t30.5 17.5q-25 11 -43.5 30t-18.5 50q0 27 15.5 50t40.5 39.5t56.5 26t62.5 9.5 t62.5 -9t57 -25.5t41.5 -39t16 -49.5q0 -29 -18 -49.5t-45 -32.5q35 -17 57 -41t22 -61zM906 145q0 19 -25.5 30t-57.5 11q-34 0 -58 -11.5t-24 -29.5q0 -19 26 -30.5t57 -11.5q32 0 57 12t25 30zM756 305q0 -14 21.5 -22t45.5 -8t46 8t22 22t-20.5 22t-47.5 8t-47 -8 t-20 -22zM209 279q-63 0 -107 17t-64 54l57 84q20 -18 45.5 -31.5t66.5 -13.5q36 0 63 7.5t27 27.5q0 23 -39 32t-109 9h-25v99h24q58 0 96 8.5t38 31.5q0 8 -7 13t-17.5 8t-22 4t-20.5 1q-39 0 -64 -12t-46 -32l-69 89q13 14 33 24.5t43.5 17.5t49.5 10.5t52 3.5 q39 0 73 -9t58.5 -25.5t38.5 -38.5t14 -47q0 -36 -26.5 -59.5t-71.5 -30.5q51 -7 79.5 -39.5t28.5 -74.5q0 -35 -17.5 -59.5t-45.5 -39.5t-63.5 -22t-72.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 1070,
    d: "M223 65l283 319l251 337l83 -75l-271 -309l-263 -347zM1036 133q0 -30 -15.5 -55.5t-41.5 -44t-61 -29t-74 -10.5t-74.5 10.5t-61.5 29.5t-41.5 45t-15.5 56q0 19 6.5 34t17 27t25 21.5t30.5 17.5q-25 11 -43.5 30t-18.5 50q0 27 15.5 50t40.5 39.5t56.5 26t62.5 9.5 t62.5 -9t57 -25.5t41.5 -39t16 -49.5q0 -29 -18 -49.5t-45 -32.5q35 -17 57 -41t22 -61zM926 145q0 19 -25.5 30t-57.5 11q-34 0 -58 -11.5t-24 -29.5q0 -19 26 -30.5t57 -11.5q32 0 57 12t25 30zM776 305q0 -14 21.5 -22t45.5 -8t46 8t22 22t-20.5 22t-47.5 8t-47 -8 t-20 -22zM228 579q37 0 68.5 -10.5t55 -29.5t36.5 -45.5t13 -57.5q0 -33 -14.5 -61t-41 -48.5t-63 -31.5t-79.5 -11q-55 0 -100.5 18.5t-70.5 50.5l62 76q21 -19 50.5 -29.5t65.5 -10.5q33 0 56.5 11.5t23.5 41.5q0 15 -6.5 26t-17 18t-22.5 10t-23 3q-23 0 -47 -12t-34 -31 h-94q13 69 31 137t30 138h258v-109h-180l-17 -51q7 2 21.5 5t38.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 993,
    d: "M116 65l283 319l251 337l83 -75l-271 -309l-263 -347zM960 133q0 -30 -15.5 -55.5t-41.5 -44t-61 -29t-74 -10.5t-74.5 10.5t-61.5 29.5t-41.5 45t-15.5 56q0 19 6.5 34t17 27t25 21.5t30.5 17.5q-25 11 -43.5 30t-18.5 50q0 27 15.5 50t40.5 39.5t56.5 26t62.5 9.5 t62.5 -9t57 -25.5t41.5 -39t16 -49.5q0 -29 -18 -49.5t-45 -32.5q35 -17 57 -41t22 -61zM850 145q0 19 -25.5 30t-57.5 11q-34 0 -58 -11.5t-24 -29.5q0 -19 26 -30.5t57 -11.5q32 0 57 12t25 30zM700 305q0 -14 21.5 -22t45.5 -8t46 8t22 22t-20.5 22t-47.5 8t-47 -8 t-20 -22zM270 622h-230v109h400l-259 -440h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 586,
    d: "M257 -10q-53 0 -98 16.5t-78 45t-51.5 68t-18.5 85.5q0 52 23 96t60.5 75.5t86 49t99.5 17.5q68 0 103 -34q0 14 -1 27t-3 24q-8 49 -32 75.5t-64 26.5q-20 0 -45 -7t-43 -20l-103 108q45 35 96.5 54t108.5 19q121 0 189 -87t68 -251q0 -89 -20.5 -160.5t-59 -122 t-93.5 -78t-124 -27.5zM271 129q17 0 33.5 8t29.5 21t21 30.5t8 36.5q0 34 -23 56.5t-57 22.5q-19 0 -35.5 -7t-28.5 -19.5t-19 -29t-7 -35.5q0 -35 23 -59.5t55 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 641,
    d: "M636 150v-150h-631v150l237 560h158zM454 170l-133 327l-127 -327h260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 723,
    d: "M427 550h-131v-640h-185v640h-80v160h661v-160h-80v-640h-185v640z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 583,
    d: "M545 570h-294v-4l169 -197l-178 -205v-4h303v-160h-513v125l203 231l-196 229v125h506v-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 514,
    d: "M55 280v150h404v-150h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 641,
    d: "M-22 79l578 642l107 -89l-578 -642z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 254,
    d: "M50 238v184h154v-184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 627,
    d: "M6 395h247l73 -268l112 663h164l-152 -790h-244l-77 266h-123v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 752,
    d: "M216 557q32 0 56.5 -6.5t43 -18t33.5 -26.5t27 -31q12 16 26.5 31t33.5 26.5t43.5 18t56.5 6.5q41 0 74 -16.5t56.5 -44.5t36 -65.5t12.5 -79.5q0 -43 -14 -80.5t-38 -65t-57 -43.5t-71 -16q-31 0 -55 6t-42.5 16t-33 23t-26.5 28q-23 -29 -59.5 -51t-102.5 -22 q-34 0 -66.5 16.5t-57.5 44.5t-40.5 65.5t-15.5 79.5q0 43 14 80t38 65t57 44t71 16zM236 286q32 0 49.5 19t32.5 45q-15 27 -32.5 46.5t-49.5 19.5q-21 0 -40.5 -14.5t-19.5 -49.5t19.5 -50.5t40.5 -15.5zM516 286q22 0 40.5 15.5t18.5 50.5t-18.5 49.5t-40.5 14.5 q-33 0 -50 -20.5t-30 -49.5q14 -25 31.5 -42.5t48.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 408,
    d: "M91 668q-4 74 35 113t115 39q38 0 80.5 -9t77.5 -25l-26 -140q-23 15 -43 15q-49 0 -46 -60l33 -616q4 -74 -35 -113t-115 -39q-38 0 -80.5 9t-77.5 25l26 140q23 -15 43 -15q49 0 46 60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 466,
    d: "M426 384q-8 -17 -19.5 -34t-27 -30.5t-34.5 -22t-43 -8.5q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-14 -16l-88 44q8 16 19 32t26 29t33.5 20.5t41.5 7.5q24 0 42 -8t33 -17.5t29 -17.5t31 -8q18 0 28.5 8.5t15.5 19.5zM426 200q-8 -17 -19.5 -34 t-27 -30.5t-34.5 -22t-43 -8.5q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-14 -16l-88 44q8 16 19 32t26 29t33.5 20.5t41.5 7.5q24 0 42 -8t33 -17.5t29 -17.5t31 -8q18 0 28.5 8.5t15.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 443,
    d: "M60 441h197l61 130l65 -34l-46 -96h46v-120h-102l-43 -90h145v-120h-201l-58 -123l-65 32l43 91h-42v120h98l42 90h-140v120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 495,
    d: "M41 1v150h380v-150h-380zM45 492l375 168v-182l-198 -55l198 -47v-182l-375 150v148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 495,
    d: "M74 1v150h380v-150h-380zM450 344l-375 -150v182l198 47l-198 55v182l375 -168v-148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 614,
    d: "M414 729l186 -364l-186 -366h-214l-186 366l186 364h214zM431 353l-125 248l-115 -227l124 -250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 241,
    d: "M85 -213l36 61h-57v106h157v-106l-54 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 910,
    d: "M904 29q-40 -17 -85.5 -28.5t-89.5 -11.5q-32 0 -61 8t-50.5 26t-34 47t-12.5 72v241h-65v143h65q-1 66 -12.5 95.5t-51.5 29.5q-38 0 -58.5 -22.5t-20.5 -54.5q0 -23 10 -48t29 -46l-69 -121q-51 26 -86 36.5t-63 10.5q-23 0 -35.5 -7t-12.5 -21q0 -17 19.5 -25 t64.5 -20q59 -16 97.5 -32t61.5 -34.5t32 -42t9 -54.5q0 -87 -57.5 -133.5t-157.5 -46.5q-32 0 -67.5 5t-70.5 13t-67 19.5t-56 25.5l69 129q52 -29 99 -44t87 -15q48 0 48 25q0 16 -20 24.5t-70 22.5q-52 15 -87.5 29.5t-57.5 32t-32 39.5t-10 53q0 43 16.5 77.5t44.5 59 t64.5 38t75.5 13.5q10 0 26.5 -1t35 -4.5t37.5 -10t36 -16.5q-11 17 -15 35t-4 40q0 31 12 58.5t36.5 48t63.5 32t93 11.5q69 0 109.5 -13.5t61.5 -40t27 -64.5t6 -86h103v-143h-103v-174q0 -26 11 -36.5t30 -10.5q14 0 32 4.5t36 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 600,
    d: "M-9 0l240 568h138l239 -568h-180l-41 102h-175l-40 -102h-181zM300 363l-52 -113h101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 610,
    d: "M587 145q0 -39 -18 -66.5t-48.5 -45t-71 -25.5t-86.5 -8h-308v568h362q33 0 59.5 -12.5t45 -33.5t28.5 -47t10 -53q0 -39 -22.5 -76t-67.5 -55q54 -14 85.5 -49.5t31.5 -96.5zM414 181q0 18 -12.5 29t-32.5 11h-144v-78h138q21 0 36 9t15 29zM225 423v-69h119 q18 0 32.5 5t14.5 30q0 20 -12.5 27t-29.5 7h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 592,
    d: "M22 289q0 52 21 102.5t60.5 90.5t96.5 64.5t130 24.5q86 0 150 -33.5t94 -90.5l-130 -93q-8 19 -21.5 32t-29.5 20.5t-33.5 10.5t-32.5 3q-34 0 -59 -12t-41 -31.5t-24 -44t-8 -48.5q0 -27 9 -52t26.5 -44t42 -30.5t56.5 -11.5q16 0 33 3.5t32.5 11t28 20t19.5 30.5 l139 -84q-14 -32 -41.5 -56.5t-62.5 -41t-74.5 -25.5t-77.5 -9q-67 0 -122.5 25.5t-95.5 67t-62.5 94t-22.5 107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 645,
    d: "M55 0v568h244q79 0 139.5 -22t101 -60.5t61 -90t20.5 -110.5q0 -65 -23 -117.5t-65 -89.5t-101.5 -57.5t-132.5 -20.5h-244zM448 285q0 61 -39.5 98t-109.5 37h-74v-272h74q72 0 110.5 38.5t38.5 98.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 540,
    d: "M509 148v-148h-454v568h446v-148h-276v-62h236v-138h-236v-72h284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 508,
    d: "M55 0v568h437v-148h-267v-78h219v-138h-219v-204h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 711,
    d: "M381 -5q-80 0 -146 30.5t-113 81.5t-73.5 117t-26.5 137q0 67 24 131t69 113.5t110.5 79.5t148.5 30q92 0 162 -37t110 -108l-155 -121q-2 5 -10 20.5t-23.5 31.5t-39 28.5t-56.5 12.5q-36 0 -63 -16t-44.5 -42.5t-26 -60t-8.5 -67.5q0 -31 7.5 -64.5t24 -61t43.5 -45 t66 -17.5q42 0 74.5 18.5t46.5 41.5h-111v170h322v-89q0 -65 -22 -122t-62.5 -99.5t-98.5 -67.5t-129 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 622,
    d: "M448 41q-32 -24 -65 -34.5t-73 -10.5q-58 0 -110.5 23.5t-92 63.5t-62.5 93t-23 113t23.5 112t64.5 90t96.5 59.5t119.5 21.5q81 0 144.5 -33t94.5 -91l-127 -97q-16 31 -49 50.5t-69 19.5q-55 0 -90 -37.5t-35 -100.5t36 -99.5t94 -36.5q52 0 100 37h-94v122h258v-306 h-141v41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 672,
    d: "M617 568v-568h-170v216h-222v-216h-170v568h170v-203h222v203h170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 280,
    d: "M55 0v568h170v-568h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 450,
    d: "M40 165q3 -1 12 -5t23 -8t31 -7t37 -3q29 0 46.5 7t26.5 23.5t12 42.5t3 64v289h170v-289q0 -65 -8 -118t-35 -91t-78 -58.5t-137 -20.5q-81 0 -139 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 621,
    d: "M55 0v568h170v-218l219 218h175l-233 -255l249 -313h-178l-172 218l-60 -50v-168h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 478,
    d: "M55 0v568h170v-420h248v-148h-418z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 767,
    d: "M542 0v275l-113 -189h-91l-113 189v-275h-170v568h186l143 -250l143 250h185v-568h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 677,
    d: "M225 253v-253h-170v568h133l264 -262v262h170v-568h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 656,
    d: "M327 -5q-68 0 -124.5 24.5t-96.5 65t-62 93t-22 107.5q0 56 23 108t64 91.5t97.5 63t123.5 23.5q69 0 125 -25t96 -65.5t61.5 -93t21.5 -106.5q0 -56 -22.5 -107.5t-63.5 -91t-97.5 -63.5t-123.5 -24zM195 283q0 -26 8.5 -50.5t25 -44t41.5 -31t59 -11.5t59 12t41 32 t24 44.5t8 50.5t-8.5 50.5t-25 43t-41.5 30t-58 11.5q-34 0 -59 -12t-41.5 -31t-24.5 -44t-8 -50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 560,
    d: "M55 0v568h275q46 0 85.5 -17.5t68 -45.5t44.5 -63.5t16 -72.5q0 -38 -15 -74t-42.5 -64t-66.5 -45t-86 -17h-109v-169h-170zM225 318h98q18 0 33 9.5t15 41.5q0 16 -5 26t-12.5 15.5t-16.5 7.5t-18 2h-94v-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 658,
    d: "M476 31q-33 -17 -70 -26t-79 -9q-68 0 -124.5 24.5t-96.5 65t-62 92.5t-22 107q0 56 23 108t64 91.5t97.5 63.5t123.5 24q69 0 125 -25t96 -66t61.5 -93.5t21.5 -106.5q0 -50 -18 -95.5t-50 -83.5l100 -102h-159zM329 147q16 0 30 3l-97 99h160l26 -27q7 14 10 30t3 33 q0 26 -8.5 50.5t-25 43.5t-41.5 30.5t-58 11.5q-34 0 -59 -12t-41.5 -31.5t-24.5 -44.5t-8 -50q0 -26 8.5 -50.5t25 -43.5t41.5 -30.5t59 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 615,
    d: "M55 0v568h292q47 0 86 -17.5t67.5 -45.5t44.5 -63.5t16 -72.5q0 -48 -24.5 -90.5t-69.5 -71.5l145 -207h-193l-122 169h-72v-169h-170zM225 318h116q18 0 32.5 12.5t14.5 38.5t-17 38.5t-35 12.5h-111v-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 541,
    d: "M427 371q-3 2 -18.5 10.5t-38 17.5t-50 16t-54.5 7q-22 0 -35 -3.5t-13 -13.5q0 -18 30 -26t83 -24q42 -12 76.5 -26.5t58.5 -35t37 -48.5t13 -68q0 -53 -20.5 -88.5t-53.5 -57t-75 -30.5t-85 -9q-33 0 -69 5t-70.5 13.5t-67.5 20.5t-60 26l74 149q4 -5 22 -15t45 -20 t60.5 -17.5t68.5 -7.5q26 0 36.5 4.5t10.5 10.5q0 10 -11 16.5t-29.5 12.5t-43 11.5t-51.5 14.5q-81 26 -118 63.5t-37 102.5q0 46 19 82t50.5 60t73 36.5t86.5 12.5q33 0 65.5 -6t62 -15t55 -20t46.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 566,
    d: "M554 420h-185v-420h-171v420h-186v148h542v-148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 655,
    d: "M327 146q31 0 52 10.5t34 28.5t19 41.5t6 48.5v293h170v-293q0 -60 -17 -111t-51.5 -88.5t-87.5 -59t-125 -21.5q-75 0 -128 22.5t-86.5 61t-49.5 89t-16 107.5v293h170v-293q0 -26 6 -49.5t19.5 -41t34 -28t50.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 600,
    d: "M171 568l130 -327l128 327h179l-236 -568h-142l-239 568h180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1149,
    d: "M1149 711l-219 -710h-202l-154 390l-153 -391h-202l-219 710h221l119 -415l128 415h212l129 -414l118 415h222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 949,
    d: "M260 568h156l58 -171l58 171h157l-106 -275l41 -89l150 364h186l-252 -568h-141l-93 192l-92 -192h-142l-251 568h184l152 -364l39 89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 595,
    d: "M177 568l121 -169l120 169h184l-215 -288l208 -280h-184l-113 161l-113 -161h-185l208 280l-215 288h184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 589,
    d: "M175 568l119 -237l121 237h185l-221 -383v-185h-170v186l-218 382h184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 569,
    d: "M29 126l305 294h-292v148h489v-126l-288 -294h293v-148h-507v126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 647,
    d: "M268 -10q-54 0 -99.5 20t-78.5 56.5t-51.5 87t-18.5 110.5q0 58 17 108t47.5 86.5t72.5 57t92 20.5q53 0 95 -23t65 -65v70h190v-518h-189v69q-23 -40 -56.5 -59.5t-85.5 -19.5zM410 298q-14 36 -41.5 57t-57.5 21q-20 0 -37.5 -9.5t-30.5 -25t-20 -36.5t-7 -45 q0 -50 29 -80t74 -30q29 0 50.5 13.5t40.5 40.5v94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 584,
    d: "M359 0v65q-52 -75 -156 -75q-39 0 -73 13t-58.5 35.5t-38.5 53.5t-14 67q0 40 17 73t47 57t71.5 37t91.5 13q64 0 106 -20v16q0 37 -21.5 55t-69.5 18q-45 0 -83 -14.5t-80 -42.5l-55 118q104 67 237 67q126 0 194 -56t68 -168v-312h-183zM327 146q11 8 18 17.5t7 19.5 v39q-17 6 -37 10t-36 4q-35 0 -58 -17t-23 -43q0 -22 17.5 -36t44.5 -14q17 0 35 5.5t32 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 1002,
    d: "M996 29q-40 -17 -85.5 -28.5t-89.5 -11.5q-32 0 -61 8t-50.5 26t-34 47t-12.5 72v241h-65v143h65q0 34 -3.5 58t-11 39t-20.5 21.5t-33 6.5q-43 0 -59 -24.5t-16 -60.5q0 -23 4.5 -47.5t11.5 -47.5t15 -43.5t14 -34.5l-185 -56q-27 39 -73 39q-39 0 -66 -29.5t-27 -83.5 t27 -83.5t66 -29.5q46 0 73 39l185 -56q-32 -63 -96.5 -103t-160.5 -40q-70 0 -124 22.5t-90.5 60t-55.5 87t-19 104.5q0 54 18.5 103t55.5 86.5t92.5 60t129.5 22.5q24 0 43 -2.5t35.5 -7t32 -11.5t32.5 -16q-8 21 -11 40.5t-3 36.5q0 75 53 114.5t156 39.5q75 0 115.5 -19 t59 -49t22 -66t3.5 -70h103v-143h-103v-174q0 -26 11 -36.5t30 -10.5q14 0 32 4.5t36 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 284,
    d: "M165 556l-120 32l50 142h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 647,
    d: "M410 0v69q-23 -40 -56.5 -59.5t-85.5 -19.5q-54 0 -99.5 20t-78.5 56.5t-51.5 87t-18.5 110.5q0 58 17 108t47.5 86.5t72.5 57t92 20.5q53 0 95 -23t65 -65v282h190v-730h-189zM410 298q-14 36 -41.5 57t-57.5 21q-20 0 -37.5 -9.5t-30.5 -25t-20 -36.5t-7 -45 q0 -50 29 -80t74 -30q29 0 50.5 13.5t40.5 40.5v94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 611,
    d: "M573 221q0 -52 -21 -94.5t-57.5 -73t-85.5 -47t-104 -16.5q-53 0 -101.5 16.5t-85.5 47.5t-59 75t-22 98q0 27 8 50t20.5 42t27.5 34t30 26q-29 17 -47.5 51t-18.5 69q0 51 23.5 90.5t59.5 66.5t80 40.5t85 13.5t85 -13.5t80.5 -39.5t60 -65.5t23.5 -90.5q0 -35 -19 -70 t-48 -52q15 -11 30.5 -26.5t27.5 -35.5t20 -44t8 -52zM380 232q0 33 -21.5 51t-53.5 18q-33 0 -54 -18.5t-21 -50.5q0 -29 21.5 -49t53.5 -20q33 0 54 20t21 49zM250 495q0 -27 17.5 -40t37.5 -13t38 13t18 40q0 20 -15.5 34t-40.5 14t-40 -14t-15 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 582,
    d: "M310 466q52 0 95 -17t74.5 -47.5t49 -73t17.5 -93.5q0 -54 -20 -99t-56.5 -77t-87 -50t-111.5 -18q-78 0 -140.5 29t-96.5 83l104 120q29 -31 64.5 -48.5t69.5 -17.5q37 0 58 20t21 54q0 33 -19 53t-50 20q-21 0 -38.5 -9.5t-26.5 -25.5h-163l84 442h356v-173h-219 l-11 -77q4 1 11 2q5 1 14 2t21 1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 597,
    d: "M282 1v136h-257v170l317 404h130v-404h88v-170h-88v-136h-190zM212 307h92v120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 286,
    d: "M48 517h190v-730h-190v730zM48 730h189v-160h-189v160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 286,
    d: "M48 730h190v-730h-190v730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 608,
    d: "M36 466q0 52 20 98t56 79.5t84.5 53t105.5 19.5q64 0 113.5 -23.5t83.5 -68.5t52 -110t18 -148q0 -88 -19.5 -157.5t-56.5 -118t-90 -74.5t-120 -26q-130 0 -226 96l105 122q54 -54 124 -54q49 0 77.5 29.5t30.5 83.5q-38 -34 -108 -34q-54 0 -99.5 17.5t-79 49t-52.5 74 t-19 92.5zM302 557q-17 0 -32.5 -7.5t-27 -20t-18.5 -29t-7 -34.5q0 -35 25 -59.5t60 -24.5t60 24.5t25 59.5q0 18 -7 34.5t-18.5 29t-27 20t-32.5 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 550,
    d: "M528 170v-170h-463v170h142v362q-8 -12 -27.5 -26.5t-43 -28t-49 -22.5t-45.5 -9v174q27 0 56 14.5t53 31.5t39.5 32t16.5 17h194v-545h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 647,
    d: "M245 -10q-48 0 -89 20.5t-71 57.5t-47 87.5t-17 109.5q0 58 18.5 108t50.5 86t76.5 56.5t97.5 20.5q60 0 101 -24t69 -67v81h165v-740h-190v292q-23 -43 -65 -65.5t-99 -22.5zM319 150q52 0 90 54v94q-14 35 -41 56.5t-57 21.5q-21 0 -38.5 -9t-30 -25t-20 -37t-7.5 -45 q0 -50 28.5 -80t75.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 598,
    d: "M307 538h-271v173h570l-347 -710h-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    d: "M572 240q0 -53 -20 -98.5t-56 -79t-84.5 -53t-105.5 -19.5q-128 0 -197.5 92t-69.5 258q0 88 19.5 157.5t56.5 118t90 74.5t120 26q130 0 226 -96l-105 -122q-54 54 -124 54q-49 0 -77.5 -29.5t-30.5 -83.5q38 34 108 34q54 0 99.5 -17.5t79 -49t52.5 -74t19 -92.5z M306 149q17 0 32.5 7.5t27 20t18.5 29t7 34.5q0 35 -25 59.5t-60 24.5t-60 -24.5t-25 -59.5q0 -18 7 -34.5t18.5 -29t27 -20t32.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 431,
    d: "M105 0v356h-80v170h80v165h195v-165h120v-170h-120v-356h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 586,
    d: "M263 -9q-80 0 -136.5 28t-91.5 88l97 132q3 -3 10.5 -15t22 -25t37.5 -23.5t57 -10.5q17 0 33 3t28.5 10t20 18t7.5 27q0 39 -47.5 53.5t-136.5 14.5h-33v157h32q33 0 63 3.5t53.5 11.5t37 20.5t13.5 31.5q0 14 -6.5 21.5t-15.5 11.5t-18 4.5t-13 0.5q-28 0 -49.5 -7 t-37.5 -17t-26.5 -21t-17.5 -20l-120 141q20 22 49 39t62.5 28t69 17t69.5 6q55 0 102.5 -15t82 -41t54 -61.5t19.5 -76.5q0 -58 -36 -96t-93 -49q33 -5 59 -22t44 -41.5t28 -55.5t10 -64q0 -56 -25.5 -95t-66 -64t-91 -36t-100.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 631,
    d: "M36 0q0 69 6 120.5t24 91.5t52.5 70.5t91.5 57.5q31 15 59 29.5t49.5 31.5t34 38t12.5 48q0 36 -19.5 49.5t-45.5 13.5q-39 0 -78.5 -22t-68.5 -50l-117 127q20 22 49.5 42.5t67 36.5t81.5 25t93 9q122 0 188.5 -59t66.5 -169q0 -41 -9.5 -72t-27.5 -55.5t-44.5 -45 t-59.5 -39.5q-21 -12 -43 -24.5t-39.5 -25.5t-28.5 -27.5t-11 -30.5h264v-170h-547z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 620,
    d: "M390 0v70q-27 -44 -74 -62t-98 -18q-88 0 -131.5 46.5t-43.5 143.5v346h190v-303q0 -35 15 -54t47 -19q18 0 41 10t46 44v322h190v-526h-182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 907,
    d: "M522 0l-69 229l-68 -229h-207l-177 526h195l94 -302l75 302h177l75 -302l94 302h195l-177 -526h-207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 555,
    d: "M551 526l-223 -739h-222l83 213l-191 526h195l100 -365l81 365h177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 714,
    d: "M357 -10q-80 0 -140 33.5t-100.5 86t-61 116.5t-20.5 124q0 64 22.5 128.5t64 116t101 83.5t134.5 32q79 0 139.5 -34.5t101 -87.5t61 -116.5t20.5 -121.5q0 -65 -22.5 -129.5t-64 -115.5t-101 -83t-134.5 -32zM233 350q0 -33 7 -66t22 -60t38.5 -44t56.5 -17q34 0 58 18 t38.5 46t21 60.5t6.5 62.5q0 33 -7 66t-22 60t-38.5 44t-56.5 17q-35 0 -58.5 -18t-38 -46t-21 -60.5t-6.5 -62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 270,
    d: "M50 -213v150h170v-150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 511,
    d: "M256 284q-57 0 -100 21t-72 53.5t-43.5 72t-14.5 76.5q0 40 16 79.5t46 71.5t72.5 52t95.5 20q57 0 99.5 -21.5t71.5 -54t43.5 -72t14.5 -75.5q0 -40 -16 -80t-45.5 -71.5t-72 -51.5t-95.5 -20zM138 507q0 -20 7 -40t21.5 -36.5t37 -27t52.5 -10.5q31 0 53 11t36.5 28 t21 37t6.5 38q0 20 -7.5 40t-22 36.5t-36.5 27t-51 10.5q-32 0 -54 -11t-36.5 -28t-21 -37t-6.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 321,
    d: "M300 395v-107h-253v107h76v221q-5 -7 -16 -16t-24 -17.5t-27 -14t-26 -5.5v109q15 0 31.5 9t30 20t22.5 20t9 10h110v-336h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 441,
    d: "M26 286q0 43 6 74.5t21 56t41 43.5t66 36q24 10 47 19.5t41 20t29 22.5t11 29q0 23 -19.5 30.5t-52.5 7.5q-38 0 -69 -13.5t-51 -30.5l-68 80q22 29 75 49.5t129 20.5q87 0 133.5 -36.5t46.5 -108.5q0 -34 -12.5 -58t-31 -41t-40.5 -27t-41 -15q-36 -10 -58 -21t-22 -31 h187v-107h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 422,
    d: "M194 279q-63 0 -107 17t-64 54l57 84q20 -18 45.5 -31.5t66.5 -13.5q36 0 63 7.5t27 27.5q0 23 -39 32t-109 9h-25v99h24q58 0 96 8.5t38 31.5q0 8 -7 13t-17.5 8t-22 4t-20.5 1q-39 0 -64 -12t-46 -32l-69 89q13 14 33 24.5t43.5 17.5t49.5 10.5t52 3.5q39 0 73 -9 t58.5 -25.5t38.5 -38.5t14 -47q0 -36 -26.5 -59.5t-71.5 -30.5q51 -7 79.5 -39.5t28.5 -74.5q0 -35 -17.5 -59.5t-45.5 -39.5t-63.5 -22t-72.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 431,
    d: "M234 291v83h-215v107l249 250h74v-250h64v-107h-64v-83h-108zM120 481h118v121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 411,
    d: "M215 579q37 0 68.5 -10.5t55 -29.5t36.5 -45.5t13 -57.5q0 -33 -14.5 -61t-41 -48.5t-63 -31.5t-79.5 -11q-55 0 -100.5 18.5t-70.5 50.5l62 76q21 -19 50.5 -29.5t65.5 -10.5q33 0 56.5 11.5t23.5 41.5q0 15 -6.5 26t-17 18t-22.5 10t-23 3q-23 0 -47 -12t-34 -31h-94 q13 69 31 137t30 138h258v-109h-180l-17 -51q7 2 21.5 5t38.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 441,
    d: "M416 434q0 -32 -14.5 -60t-40.5 -49t-61.5 -33t-77.5 -12q-91 0 -142 56.5t-51 161.5q0 108 55.5 170t152.5 62q47 0 88.5 -15t71.5 -44l-62 -77q-17 16 -44.5 24t-58.5 8q-46 0 -73.5 -17t-29.5 -49q17 11 45.5 15t52.5 4q42 0 77 -11t60 -30.5t38.5 -46t13.5 -57.5z M224 380q36 0 62.5 16t26.5 38t-26 36.5t-63 14.5q-38 0 -64 -14.5t-26 -36.5t27 -38t63 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 418,
    d: "M253 622h-230v109h400l-259 -440h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 439,
    d: "M412 423q0 -30 -15.5 -55.5t-41.5 -44t-61 -29t-74 -10.5t-74.5 10.5t-61.5 29.5t-41.5 45t-15.5 56q0 19 6.5 34t17 27t25 21.5t30.5 17.5q-25 11 -43.5 30t-18.5 50q0 27 15.5 50t40.5 39.5t56.5 26t62.5 9.5t62.5 -9t57 -25.5t41.5 -39t16 -49.5q0 -29 -18 -49.5 t-45 -32.5q35 -17 57 -41t22 -61zM302 435q0 19 -25.5 30t-57.5 11q-34 0 -58 -11.5t-24 -29.5q0 -19 26 -30.5t57 -11.5q32 0 57 12t25 30zM152 595q0 -14 21.5 -22t45.5 -8t46 8t22 22t-20.5 22t-47.5 8t-47 -8t-20 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 441,
    d: "M25 575q0 33 14.5 61t40.5 49t61.5 33t77.5 12q91 0 142 -57t51 -162q0 -108 -55 -169.5t-152 -61.5q-48 0 -89.5 15t-71.5 44l62 77q17 -16 44.5 -24.5t58.5 -8.5q46 0 73.5 17.5t29.5 49.5q-16 -11 -44.5 -15.5t-54.5 -4.5q-42 0 -76.5 11t-59 30.5t-38.5 46t-14 57.5z M217 630q-36 0 -62 -16.5t-26 -38.5q0 -21 26 -35.5t63 -14.5t63 14.5t26 35.5q0 22 -26.5 38.5t-63.5 16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 511,
    d: "M256 -6q-57 0 -100 21t-72 53.5t-43.5 72t-14.5 76.5q0 40 16 79.5t46 71.5t72.5 52t95.5 20q57 0 99.5 -21.5t71.5 -54t43.5 -72t14.5 -75.5q0 -40 -16 -80t-45.5 -71.5t-72 -51.5t-95.5 -20zM138 217q0 -20 7 -40t21.5 -36.5t37 -27t52.5 -10.5q31 0 53 11t36.5 28 t21 37t6.5 38q0 20 -7.5 40t-22 36.5t-36.5 27t-51 10.5q-32 0 -54 -11t-36.5 -28t-21 -37t-6.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 370,
    d: "M354 107v-107h-307v107h103v221q-6 -7 -20 -16t-31.5 -17.5t-35.5 -14t-33 -5.5v109q19 0 40.5 9t39 20t29 20t11.5 10h110v-336h94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 448,
    d: "M26 0q0 43 6 74.5t21 56t41 43.5t67 36q24 10 46.5 19.5t40.5 20t29 22.5t11 29q0 23 -19.5 30.5t-52.5 7.5q-38 0 -69 -13.5t-51 -30.5l-68 80q22 29 75 49.5t130 20.5q86 0 132.5 -36.5t46.5 -108.5q0 -34 -12.5 -58t-31 -41t-40.5 -27t-41 -15q-36 -10 -58 -21 t-22 -31h206v-107h-387z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 422,
    d: "M194 -6q-63 0 -107 17t-64 54l57 84q20 -18 45.5 -31.5t66.5 -13.5q36 0 63 7.5t27 27.5q0 23 -39 32t-109 9h-25v99h24q58 0 96 8.5t38 31.5q0 8 -7 13t-17.5 8t-22 4t-20.5 1q-39 0 -64 -12t-46 -32l-69 89q13 14 33 24.5t43.5 17.5t49.5 10.5t52 3.5q39 0 73 -9 t58.5 -25.5t38.5 -38.5t14 -47q0 -36 -26.5 -59.5t-71.5 -30.5q51 -7 79.5 -39.5t28.5 -74.5q0 -35 -17.5 -59.5t-45.5 -39.5t-63.5 -22t-72.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 431,
    d: "M234 1v83h-215v107l249 250h74v-250h64v-107h-64v-83h-108zM120 191h118v121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 412,
    d: "M216 289q37 0 68.5 -10.5t55 -29.5t36.5 -45.5t13 -57.5q0 -33 -14.5 -61t-41 -48.5t-63 -31.5t-79.5 -11q-55 0 -100.5 18.5t-70.5 50.5l62 76q21 -19 50.5 -29.5t65.5 -10.5q33 0 56.5 11.5t23.5 41.5q0 15 -6.5 26t-17 18t-22.5 10t-23 3q-23 0 -47 -12t-34 -31h-94 q13 69 31 137t30 138h258v-109h-180l-17 -51q7 2 21.5 5t38.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 441,
    d: "M416 148q0 -32 -14.5 -60t-40.5 -49t-61.5 -33t-77.5 -12q-91 0 -142 56.5t-51 161.5q0 108 55.5 170t152.5 62q47 0 88.5 -15t71.5 -44l-62 -77q-17 16 -44.5 24t-58.5 8q-46 0 -73.5 -17t-29.5 -49q17 11 45.5 15t52.5 4q42 0 77 -11t60 -30.5t38.5 -46t13.5 -57.5z M224 94q36 0 62.5 16t26.5 38t-26 36.5t-63 14.5q-38 0 -64 -14.5t-26 -36.5t27 -38t63 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 417,
    d: "M253 332h-230v109h400l-259 -440h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 439,
    d: "M412 133q0 -30 -15.5 -55.5t-41.5 -44t-61 -29t-74 -10.5t-74.5 10.5t-61.5 29.5t-41.5 45t-15.5 56q0 19 6.5 34t17 27t25 21.5t30.5 17.5q-25 11 -43.5 30t-18.5 50q0 27 15.5 50t40.5 39.5t56.5 26t62.5 9.5t62.5 -9t57 -25.5t41.5 -39t16 -49.5q0 -29 -18 -49.5 t-45 -32.5q35 -17 57 -41t22 -61zM302 145q0 19 -25.5 30t-57.5 11q-34 0 -58 -11.5t-24 -29.5q0 -19 26 -30.5t57 -11.5q32 0 57 12t25 30zM152 305q0 -14 21.5 -22t45.5 -8t46 8t22 22t-20.5 22t-47.5 8t-47 -8t-20 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 441,
    d: "M25 289q0 33 14.5 61t40.5 49t61.5 33t77.5 12q91 0 142 -57t51 -162q0 -108 -55 -169.5t-152 -61.5q-48 0 -89.5 15t-71.5 44l62 77q17 -16 44.5 -24.5t58.5 -8.5q46 0 73.5 17.5t29.5 49.5q-16 -11 -44.5 -15.5t-54.5 -4.5q-42 0 -76.5 11t-59 30.5t-38.5 46t-14 57.5z M217 344q-36 0 -62 -16.5t-26 -38.5q0 -21 26 -35.5t63 -14.5t63 14.5t26 35.5q0 22 -26.5 38.5t-63.5 16.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0394",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0457",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0135",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEF",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEE",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "w.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "Z.sc",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "Y.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "X.sc",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "J.sc",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "A.sc",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u01FF",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u01FE",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xF8",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xD8",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "x",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0457",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0135",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEF",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEE",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "X.sc",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "W.alt",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "A.sc",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u04B0",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0458",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0457",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u044F",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u044A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0445",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0442",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0436",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u042F",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u042A",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0425",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0424",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0422",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0416",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0410",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u03C0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0259",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u01FF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u01FE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0135",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012D",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0128",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEF",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEC",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xD8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xCF",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "x",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "j",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "X",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "V",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "W.sc",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "S.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u04B0",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0457",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0455",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0434",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u042A",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0425",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0422",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0417",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0414",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0410",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0408",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0394",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0166",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0135",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012D",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0126",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEF",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEE",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "X",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "V",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "three.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0458",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0166",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0135",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "j",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "eight.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "Z.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "W.alt",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "U.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B0",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0457",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0455",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044F",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0447",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0445",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0437",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0434",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0431",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0430",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0425",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0416",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0410",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0408",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0405",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0259",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012D",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEF",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEC",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "X",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "V",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 285
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "X",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\\\\\\\\",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xD7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB0",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "7",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0458",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0135",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u01FF",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xF8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "Y.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "X.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "A.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xF0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xEF",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0135",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0129",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xEF",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xEE",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0142",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0129",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0135",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xEF",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xEE",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0135",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012D",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEF",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEE",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xED",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "*",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ")",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0129",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\xEF",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0135",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0129",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xEF",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xEE",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u01FF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u01FE",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012D",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0104",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF8",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEF",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEC",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD8",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0142",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "y.alt",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "Y.sc",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "W.sc",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "W.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "V.sc",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0129",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEF",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "x",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ")",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    g2: "X.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    g2: "A.sc",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u01FC",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u01FA",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0142",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0102",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0100",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC6",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC4",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC2",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC0",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "x",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "A",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "4",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "/",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ")",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u01FF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0129",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xEF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0135",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0129",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\xEF",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\xEE",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1EBD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0161",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u015D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0135",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012D",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEF",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEE",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xED",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEC",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0135",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0129",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xEF",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xEE",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "t.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "Z.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2122",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0161",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0135",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012D",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0127",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: -85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xED",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEC",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\\\\\\\",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "*",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ")",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u017E",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0161",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u015D",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0135",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012D",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0127",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEF",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEE",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xED",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEC",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "t.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "Y.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "T.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FF",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0135",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0131",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012D",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0127",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEF",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEE",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xED",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEC",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xDF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xAE",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xA9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "4",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "2",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "/",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "*",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: ")",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u017E",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0161",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u015D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0135",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012D",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0127",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEF",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEE",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xED",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEC",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEB",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE3",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0135",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012D",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xEF",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xEE",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0458",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0457",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0424",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0416",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0135",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0129",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xEF",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xEE",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "X.sc",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "A.sc",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u044F",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u044A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0445",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0442",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0436",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u042F",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u042A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0427",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0425",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0424",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0416",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0410",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u01FE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xD8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "x",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "X",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u0129",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xEF",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u0142",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0142",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0135",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEE",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0135",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0129",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xEE",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0129",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xEE",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u01FF",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF8",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u0142",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\\\\\\\\",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u01FF",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF8",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "/",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: ")",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0458",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0457",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0424",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0135",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0129",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xEF",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xEE",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0129",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0128",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "\u0129",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0129",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0128",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "three.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    g2: "W.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1EF8",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1EF2",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1E84",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1E82",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1E80",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0178",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0176",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0174",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xDD",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\\\\\\\\",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "Y",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "X",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "W",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: ")",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "Y.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "X.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "J.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "}",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "x",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "]",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u0129",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u0142",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "j",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\u2122",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\\\\\\\\",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: ")",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    g2: "l.alt",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    g2: "j.alt",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2122",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2120",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u201D",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u201C",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2019",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2018",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u0133",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xFE",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xBA",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "}",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "l",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "k",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "i",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "h",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "b",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "]",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "?",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "*",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "'",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\"",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    g2: "l.alt",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    g2: "j.alt",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2122",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2120",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u201D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2019",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u0133",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xFE",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xDF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xBA",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xAA",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "}",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "l",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "k",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "i",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "h",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "b",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "]",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\\\\\\\\",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "?",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "*",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: ")",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "'",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\"",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u0142",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u0129",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xEF",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "three.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "y",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "x",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "w",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u01FE",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0104",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD8",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "g",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: " ",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "y.alt",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "w.alt",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "u.alt",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "t.alt",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "l.alt",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "j.alt",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_f_l",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_f_i",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_l",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_i",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_f",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -168
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2120",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201C",
    k: -113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2018",
    k: -113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u017E",
    k: -114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u016F",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFA",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xF0",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xBA",
    k: -91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xAE",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xAA",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA9",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "z",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "y",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "x",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "w",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "v",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "u",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "t",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "r",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "p",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "n",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "m",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "l",
    k: -156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "j",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "f",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "?",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -177
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "'",
    k: -151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "&",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\"",
    k: -151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "!",
    k: -110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: " ",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "*",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u0142",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "Y.sc",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "X.sc",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "W.sc",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "V.sc",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "*",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    g2: "l.alt",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    g2: "j.alt",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2120",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201C",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2018",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u0133",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xFE",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xAA",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xA6",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "|",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "l",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "k",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "j",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "i",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "h",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "b",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "*",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "'",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\"",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "!",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "\u2122",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "\\\\\\\\",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: ")",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012E",
    u2: "j",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\u0135",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\u0129",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xEE",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    g2: "l.alt",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    g2: "j.alt",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2122",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2120",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u201D",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u201C",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2019",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2018",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u0133",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\xFE",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\xBA",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "}",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "l",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "k",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "i",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "h",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "b",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "]",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "?",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "*",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "'",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\"",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u01FE",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u0104",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\xD8",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2122",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2120",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201D",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201C",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2019",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2018",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1EF8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1EF2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E84",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E82",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E80",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E6C",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u021A",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0178",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0176",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0174",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0164",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0162",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xDD",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xAA",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\\\\\\\\",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "Y",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "W",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "T",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "*",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "'",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\"",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "y.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "w.alt",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "t.alt",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "l.alt",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "j.alt",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "f_l",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2120",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u201D",
    k: -120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u201C",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2019",
    k: -120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2018",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u017E",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0161",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0133",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u010D",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xFE",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xF0",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xDF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xBA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xAA",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "y",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "x",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "w",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "v",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "t",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "l",
    k: -116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "k",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "j",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "i",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "h",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "b",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "?",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "*",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "'",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "&",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\"",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "!",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: " ",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "y.alt",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "w.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "t.alt",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\uFB06",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "f_f_l",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "f_f_i",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "f_l",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "f_i",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "f_f",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u2120",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u017C",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u017A",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\xAA",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "z",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "y",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "w",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "t",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "f",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u0142",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "\\\\\\\\",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: ")",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u2122",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u201D",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u2019",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "l",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "]",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\\\\\\\\",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "*",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: ")",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "j",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xEE",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    g2: "l.alt",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    g2: "j.alt",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2122",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2120",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u201D",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u201C",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2019",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2018",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u0165",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u0161",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u0133",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xFE",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xF0",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xED",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xE4",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xBA",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xAA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xA6",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "}",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "|",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "t",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "l",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "k",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "i",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "h",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "b",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "]",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\\\\\\\\",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "?",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "*",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: ")",
    k: -105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "'",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\"",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "!",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "t.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "T.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_f_i",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2122",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2026",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201E",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201A",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FC",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0134",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0104",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0102",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0100",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC6",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "J",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ".",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ",",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "*",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ")",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u01FE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0166",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    g2: "W.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1EF8",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1EF2",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1E84",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1E82",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1E80",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0178",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0176",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0174",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xDD",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\\\\\\\\",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "Y",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "X",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "W",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "V",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: ")",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "y",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "x",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "w",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xEE",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "*",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BC",
    u2: "\u03C0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BC",
    u2: "\\\\\\\\",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BC",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C0",
    u2: "\u03C0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C0",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u0457",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0445",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0442",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0436",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0425",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0416",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0410",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "*",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0451",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0457",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u042F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0424",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0414",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0410",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0458",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0445",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0442",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0436",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0431",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0425",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0416",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0410",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0406",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0458",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u044F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u044D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0436",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0434",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0410",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0408",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u044A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0442",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0422",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\\\\\\\\",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "*",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040D",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0451",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0455",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0430",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0422",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0405",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\\\\\\\\",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "/",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: ")",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0442",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0437",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0422",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0457",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0442",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0437",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0436",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0425",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0417",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0416",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0410",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0457",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0451",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0457",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B0",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0457",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0434",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "]",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\\\\\\\\",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "/",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0457",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u044F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u044D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0445",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0442",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0437",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0436",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0417",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0416",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0414",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0410",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0418",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0419",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0457",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041D",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041F",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B1",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0457",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0445",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0408",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "/",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ")",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0457",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0455",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u042F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0424",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0457",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0408",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "*",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ")",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0457",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0451",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0445",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0437",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0436",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0425",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0414",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0408",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0405",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "]",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "/",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B0",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0457",
    k: -87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0431",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0430",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\\\\\\\\",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "/",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "*",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: ")",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0427",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0428",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042B",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\u0457",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0442",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\\\\\\\\",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "*",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0455",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0437",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0430",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0445",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0436",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\\\\\\\\",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "*",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0458",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0431",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0430",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "/",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: ")",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0436",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\\\\\\\\",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "*",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0436",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\\\\\\\\",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "*",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0430",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "]",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ")",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0431",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "/",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: ")",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0458",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0458",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0458",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0442",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\\\\\\\\",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "*",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u044F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u0445",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u0442",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\\\\\\\\",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0456",
    u2: "\u0457",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u201D",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u2019",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u0457",
    k: -124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u0456",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "}",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "]",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\\\\\\\\",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "?",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "*",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: ")",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "'",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\"",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0458",
    u2: "\u045B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0458",
    u2: "\u0458",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0458",
    u2: "\u0452",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u0442",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\\\\\\\\",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "*",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0457",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0451",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0457",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "*",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u04B1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u04B0",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0447",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0442",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0437",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0436",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0434",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0431",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0430",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u042A",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0424",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0422",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0416",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0410",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\\\\\\\\",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "/",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "*",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: ")",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0434",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0457",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0135",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0129",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEF",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEE",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0457",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0135",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEF",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEE",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0458",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0135",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "j",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0457",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0135",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0129",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEF",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEE",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0457",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0135",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xEF",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xEE",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0458",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0135",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "j",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "four.denominator",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0135",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xF0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xEF",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xEE",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "three.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0142",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0135",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEE",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0135",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\xEF",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\xEE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0135",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\xEF",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\xEE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "/",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: ")",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "}",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "]",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "X.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0142",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0129",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\xEF",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\\\\\\\\",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "S.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "/",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: ")",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: ")",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "}",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "]",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    g2: "X.sc",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    g2: "A.sc",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xC6",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xC3",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "X",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "A",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "/",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: ")",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "/",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: ")",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "X.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "S.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "S.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\xBA",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "t.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "Z.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u2122",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0161",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0135",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012D",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xEF",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xEE",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xED",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xEC",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\\\\\\\\",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "*",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: ")",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\xBA",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "*",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\xBA",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "/",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: ")",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\xBA",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "*",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u0135",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u0129",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xEE",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lnum",
    u2: "\xB0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lnum",
    u2: "\\\\\\\\",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\u0135",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\u0129",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xEE",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u0135",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u0129",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xEE",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xB0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\\\\\\\\",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "five.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "=",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: ")",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0142",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "slash",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "four",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "parenright",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "AE,AEacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V.sc",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W.sc",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y.sc",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "eth",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "four",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "AE,AEacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "X.sc",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "AE,AEacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "slash",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "T.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "backslash",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "four",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "parenright",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "t.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "trademark",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "bracketright",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "two",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "slash",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "four",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "parenright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "slash",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "four",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "parenright",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "AE,AEacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "X.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "three",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "asterisk",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "parenright",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "trademark",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "S.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "asterisk",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "backslash",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "parenright",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "trademark",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Z.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "colon,semicolon",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "guillemotleft,guilsinglleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "asterisk",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "backslash",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "parenright",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "trademark",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "exclam",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "W.sc",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "asterisk",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "ordfeminine",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "ordmasculine",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteright,quotedblright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "trademark",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "servicemark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "trademark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "slash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "AE,AEacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bracketright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "X",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "AE,AEacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "AE,AEacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "asterisk",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "quoteright,quotedblright",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bracketright",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "AE,AEacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "slash",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "eth",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "parenright",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "backslash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "parenright",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "t.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "slash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "parenright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "AE,AEacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "bracketright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "backslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "parenright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "x",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "backslash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "asterisk",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ordmasculine",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "backslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "AE,AEacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "AE,AEacute",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "slash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "AE,AEacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "bracketright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "AE,AEacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "AE,AEacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03A9,Omega",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0409,uni041B",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni040E,uni0423",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni043B,uni0459",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0443,uni045E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0404,uni041E,uni0421",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "AE,AEacute",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "J,Jcircumflex",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0409,uni041B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni040E,uni0423",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni043B,uni0459",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0402,uni040B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0452,uni045B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni040E,uni0423",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0443,uni045E",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0404,uni041E,uni0421",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0402,uni040B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni040E,uni0423",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "AE,AEacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "AE,AEacute",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "AE,AEacute",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lnum",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni040E,uni0423",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni042A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "AE,AEacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni040E,uni0423",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0402,uni040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "pi",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0416",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0425",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0434",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0436",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0437",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0442",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0445",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0422",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni040E,uni0423",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0402,uni040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni042A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0416",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0425",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0436",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0445",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0422",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "J,Jcircumflex",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni040E,uni0423",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0443,uni045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0402,uni040B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni042A",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "pi",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0416",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0427",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0442",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0422",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0424",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0447",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0409,uni041B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni043B,uni0459",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0452,uni045B",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0434",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0410",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0394",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0414",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0408",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0409,uni041B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni043B,uni0459",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0452,uni045B",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0434",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0410",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0414",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0408",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0455",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni04B0",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "S.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0409,uni041B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni043B,uni0459",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0452,uni045B",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0434",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0410",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0394",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0414",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0408",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "AE,AEacute",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "AE,AEacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "uni0404,uni041E,uni0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "uni0452,uni045B",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "AE,AEacute",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "uni0404,uni041E,uni0421",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "uni0452,uni045B",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni040E,uni0423",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0443,uni045E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0404,uni041E,uni0421",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0402,uni040B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0452,uni045B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "backslash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "pi",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quoteright,quotedblright",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quotedbl,quotesingle",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BC",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni040E,uni0423",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0443,uni045E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0402,uni040B",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0409,uni041B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0404,uni041E,uni0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteleft,quotedblleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteright,quotedblright",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quotedbl,quotesingle",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni040E,uni0423",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0443,uni045E",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0402,uni040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni040E,uni0423",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0443,uni045E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0409,uni041B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni040E,uni0423",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni043B,uni0459",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0443,uni045E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "slash",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "asterisk",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "backslash",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotleft,guilsinglleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "parenright",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0409,uni041B",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni043B,uni0459",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0443,uni045E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0404,uni041E,uni0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0452,uni045B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0434",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0436",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0437",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0445",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044A",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni04B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0410",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0447",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0414",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0408",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044F",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0455",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni04B0",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0430",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "quoteleft,quotedblleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni040E,uni0423",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0443,uni045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0404,uni041E,uni0421",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0402,uni040B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni042A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0427",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0422",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0424",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni04B0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0431",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0456,uni0457,uni0458",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "guillemotleft,guilsinglleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0443,uni045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0404,uni041E,uni0421",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0452,uni045B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0409,uni041B",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni040E,uni0423",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni043B,uni0459",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0443,uni045E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0452,uni045B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0434",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0447",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0430",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "slash",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "backslash",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "guillemotleft,guilsinglleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "parenright",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "bracketright",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0443,uni045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0404,uni041E,uni0421",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0452,uni045B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0434",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0442",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni044A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0424",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni04B0",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0431",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "slash",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "asterisk",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "backslash",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotleft,guilsinglleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "parenright",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "quoteright,quotedblright",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "bracketright",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "colon,semicolon",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotright,guilsinglright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0409,uni041B",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni043B,uni0459",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0404,uni041E,uni0421",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0452,uni045B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042A",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0434",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0436",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0437",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0442",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0445",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044D",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0410",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0422",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0424",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0447",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0414",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0408",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044F",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0455",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni04B0",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0430",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0431",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0417",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042D",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0405",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0409,uni041B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni040E,uni0423",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni043B,uni0459",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0443,uni045E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0402,uni040B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "guillemotleft,guilsinglleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0443,uni045E",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0404,uni041E,uni0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0452,uni045B",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "asterisk",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "backslash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteleft,quotedblleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteright,quotedblright",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni040E,uni0423",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0443,uni045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0402,uni040B",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni042A",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0427",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0436",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0445",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0410",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0422",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni042F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "quoteright,quotedblright",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0409,uni041B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni040E,uni0423",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni043B,uni0459",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0443,uni045E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0404,uni041E,uni0421",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0404,uni041E,uni0421",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0452,uni045B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0424",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0431",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0404,uni041E,uni0421",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0452,uni045B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteleft,quotedblleft",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteright,quotedblright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quotedbl,quotesingle",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni040E,uni0423",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0443,uni045E",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0404,uni041E,uni0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0402,uni040B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "slash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0409,uni041B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni040E,uni0423",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni043B,uni0459",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0443,uni045E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0402,uni040B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0416",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0425",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0437",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0445",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0410",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0422",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0408",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni044F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni04B0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0456,uni0457,uni0458",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0417",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0405",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0409,uni041B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni043B,uni0459",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0409,uni041B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni043B,uni0459",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0443,uni045E",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0452,uni045B",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotleft,guilsinglleft",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0409,uni041B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni043B,uni0459",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0404,uni041E,uni0421",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0452,uni045B",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0409,uni041B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni043B,uni0459",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0443,uni045E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni043B,uni0459",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni0443,uni045E",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "slash",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "bracketright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni043B,uni0459",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0434",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "asterisk",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "backslash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0443,uni045E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0442",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni044A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni04B1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0447",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "guillemotleft,guilsinglleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0438,uni0439,uni043B,uni043C,uni043D,uni043F,uni0447,uni0448,uni044B,uni044F,uni045D,uni045F",
    g2: "backslash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "slash",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "parenright",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0455",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0430",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0431",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni043B,uni0459",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "slash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "backslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "parenright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni043B,uni0459",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0434",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0437",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "asterisk",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "backslash",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteleft,quotedblleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteright,quotedblright",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quotedbl,quotesingle",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0443,uni045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0436",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0442",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0445",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni044A",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni04B1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteright,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0443,uni045E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni0443,uni045E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteright,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "guillemotleft,guilsinglleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteright,quotedblright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "uni0443,uni045E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni043B,uni0459",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0443,uni045E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "slash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "asterisk",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "backslash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "parenright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "bracketright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0443,uni045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0436",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0437",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni04B1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "asterisk",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "backslash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0443,uni045E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0436",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni044D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni044F",
    k: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayBlack);
export default __webpack_public_path__ + "static/media/Raleway-Black.248211a19ee5cae9e4ec53178bd5f789.svg";
export { ForwardRef as ReactComponent };